<template>
  <div id="mainDiv" v-if="offices.length" style="margin-top: 50px">
    <div v-if="offices[currentIndex].addressDialog">
      <v-dialog
        v-model="offices[currentIndex].addressDialog"
        max-width="700"
        style="z-index: 550"
      >
        <AgencyAddress
          :id="offices[currentIndex].agencyId"
          :agencyName="offices[currentIndex].name"
          :address="offices[currentIndex].agencyAddress1"
          :address2="offices[currentIndex].agencyAddress2"
          :city="offices[currentIndex].agencyCity"
          :state="offices[currentIndex].agencyState"
          :zip="offices[currentIndex].agencyZip"
          :country="offices[currentIndex].agencyCountry"
          :phone="offices[currentIndex].agencyPhone"
          :phoneExt="offices[currentIndex].agencyPhoneExt"
          :email="offices[currentIndex].agencyEmail"
          :code="offices[currentIndex].agencyCode"
          :companyId="offices[currentIndex].companyId"
          :countryCode="offices[currentIndex].countryCode"
          :phoneTypeId="offices[currentIndex].phoneTypeId"
          :aoId="offices[currentIndex].aoId"
          :aoName="offices[currentIndex].levels[0].levelMembers[0].name"
          :addressTypeId="offices[currentIndex].addressTypeId"
          :countryId="offices[currentIndex].countryId"
          :primaryAgencyInd="offices[currentIndex].primaryAgencyInd"
        />
      </v-dialog>
    </div>

    <modal
      name="overrideModal"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 225px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Override In Effect</v-toolbar-title>
        </v-toolbar>

        <v-card-subtitle>
          {{ overrideMsg }}
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer /> <v-spacer />
          <v-btn
            color="#00558C"
            dark
            @click="
              $modal.hide('overrideModal');
              reload();
            "
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="msgModal"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="400"
    >
      <v-card style="height: 525px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Incoming Message</v-toolbar-title>
        </v-toolbar>
        <v-card-subtitle>
          You've received a message from {{ unlockMsgFrom }}: <br /><br />
          <v-textarea
            name="unlockMsgRcvd"
            v-model="unlockMsg"
            filled
            :readonly="true"
            label="Incoming Message"
            rows="3"
            no-resize
            value=""
            class="unlockMsgRcvd"
          ></v-textarea>
          If you would like to reply, please submit your reply below.<br /><br />
          <v-textarea
            name="replyMsg"
            v-model="replyMsg"
            filled
            label="Reply Message"
            rows="3"
            no-resize
            value=""
          ></v-textarea>
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer /><v-spacer />
          <v-btn
            color="#00558C"
            dark
            @click="
              sendReplyMsg();
              $modal.hide('msgModal');
            "
            >Send Reply</v-btn
          >
          <v-btn color="#00558C" dark @click="$modal.hide('msgModal')"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="overrideSelfModal"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 250px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Override In Effect</v-toolbar-title>
        </v-toolbar>

        <v-card-subtitle>
          You have invalidated your editing lock in this tab/browser by
          selecting "Override" in another tab/browser. Please continue editing
          there. If you no longer have that editing session open, you may edit
          again here. The hierarchy will now be reloaded.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer /> <v-spacer />
          <v-btn
            color="#00558C"
            dark
            @click="
              $modal.hide('overrideSelfModal');
              reload();
            "
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="secondLoginModal"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 200px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>System Message</v-toolbar-title>
        </v-toolbar>
        <v-card-subtitle
          v-if="
            $store.state.currentUser &&
              $store.state.currentUser.agentNum ==
                $store.state.unlockMsg.AOAgentNum
          "
        >
          Your hierarchy has been unlocked because you logged into another AMT
          session. It will now be reloaded.
        </v-card-subtitle>
        <v-card-subtitle v-else>
          {{ unlockAOName }}'s hierarchy has been unlocked because you logged
          into another AMT session. It will now be reloaded.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer /> <v-spacer />
          <v-btn
            color="#00558C"
            dark
            @click="
              $modal.hide('secondLoginModal');
              reload();
            "
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>
    <modal
      v-if="offices[currentIndex].deleteMember"
      name="revokeNotFoundModal"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 225px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Not Found</v-toolbar-title>
        </v-toolbar>
        <v-card-subtitle
          >{{ offices[currentIndex].deleteMember.name }} could not be located
          for access to be revoked. This may indicate that
          {{ offices[currentIndex].deleteMember.name }} does not currently have
          access to Salesforce.</v-card-subtitle
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#00558C"
            dark
            @click="$modal.hide('revokeNotFoundModal')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="errorModal"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 225px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Error</v-toolbar-title>
        </v-toolbar>
        <v-card-subtitle>
          Something went wrong. Please try again. If the error persists, please
          contact support.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('errorModal')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="savedModal"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 225px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Changes Saved</v-toolbar-title>
        </v-toolbar>
        <br />

        <v-card-subtitle
          >Agency name/address changes have been saved.</v-card-subtitle
        >
        <br />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('savedModal')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="willBeSavedModal"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 250px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Changes Recorded</v-toolbar-title>
        </v-toolbar>
        <br />

        <v-card-subtitle
          >Agency name/address changes will be saved upon saving agency
          creation.</v-card-subtitle
        >
        <br />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('willBeSavedModal')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="longSaveModal"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 225px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Save In Progress</v-toolbar-title>
        </v-toolbar>
        <br />

        <v-card-subtitle
          >Save is in progress. Due to the number of changes, the save may take
          a couple of minutes. Please wait.</v-card-subtitle
        >
      </v-card>
    </modal>

    <modal
      name="cannotSaveModal"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 225px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Save Cannot Be Completed</v-toolbar-title>
        </v-toolbar>
        <v-card-subtitle>
          You have unassigned agents in the agency transfer pool. Please assign
          these agents and then try your save again.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('cannotSaveModal')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="readOnlyModal"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 200px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Viewing in Read-Only Mode</v-toolbar-title>
        </v-toolbar>
        <v-card-subtitle>
          Your current role permissions allow you to view, but not edit, the
          hierarchy.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('readOnlyModal')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="editLock"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 300px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Hierarchy Lock In Effect</v-toolbar-title>
        </v-toolbar>
        <br />
        <v-card-subtitle>
          This hierarchy will now show as being edited by you. Please Save or
          Revert your changes as appropriate when you are done. Please be aware
          that other users attempting to edit the hierarchy will be notified
          that you are editing it. Other users may override edit locks if they
          so choose. If this happens, you will no longer be able to save
          changes.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('editLock')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="maxLevelExceeded"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 200px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Assignment Not Allowed</v-toolbar-title>
        </v-toolbar>
        <br />
        <v-card-subtitle
          >The agent role cannot have subordinates.</v-card-subtitle
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('maxLevelExceeded')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="saveError"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="525"
      v-if="
        currentIndex != undefined &&
          offices[currentIndex] &&
          offices[currentIndex].levels &&
          offices[currentIndex].levels[0].levelMembers &&
          offices[currentIndex].levels[0].levelMembers[0] &&
          lastModifiedInDb != null &&
          lastModifiedInDb != undefined
      "
    >
      <v-card style="height: 275px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title
            >Save Failed: Changes to Source Data Detected</v-toolbar-title
          >
        </v-toolbar>
        <br />
        <v-card-subtitle>
          The AMT has detected changes to this hierarchy from outside this
          editing session. Changes to
          {{ offices[currentIndex].levels[0].levelMembers[0].name }}'s hierarchy
          were saved {{ lastModifiedInDb | mmddyyyy }} at
          {{ lastModifiedInDb | hhmm }}. The hierarchy will now be reloaded.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="#00558c"
            dark
            @click="
              $modal.hide('saveError');
              reload();
            "
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="lockWasOverriden"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
      v-if="
        currentIndex != undefined &&
          offices[currentIndex] &&
          offices[currentIndex].levels &&
          offices[currentIndex].levels[0].levelMembers &&
          offices[currentIndex].levels[0].levelMembers[0] &&
          currentLock &&
          currentLock.EditedByName
      "
    >
      <v-card style="height: 275px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title
            >Save Failed - Lock Override in Effect</v-toolbar-title
          >
        </v-toolbar>
        <br />
        <v-card-subtitle>
          Your editing lock on
          {{ offices[currentIndex].levels[0].levelMembers[0].name }}'s hierarchy
          was overridden by {{ currentLock.EditedByName }} on
          {{ currentLock.EditStartDateTime | mmddyyyy }} at
          {{ currentLock.EditStartDateTime | hhmm }}. The hierarchy will now be
          reloaded.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="#00558c"
            dark
            @click="
              $modal.hide('lockWasOverriden');
              reload();
            "
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="lockWasInvalidated"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 250px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Save Failed - Lock Was Invalidated</v-toolbar-title>
        </v-toolbar>
        <v-card-subtitle>
          This session's editing lock was invalidated. If you opened a second
          AMT instance, please continue in that instance, otherwise please
          select "EDIT" from the menu to continue after the hierarchy reloads.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="#00558c"
            dark
            @click="
              $modal.hide('lockWasInvalidated');
              reload();
            "
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="selfLockWasOverriden"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
      v-if="
        currentIndex != undefined &&
          offices[currentIndex] &&
          offices[currentIndex].levels &&
          offices[currentIndex].levels[0].levelMembers &&
          offices[currentIndex].levels[0].levelMembers[0] &&
          currentLock &&
          currentLock.EditedByName
      "
    >
      <v-card style="height: 275px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title
            >Save Failed - Lock Override in Effect</v-toolbar-title
          >
        </v-toolbar>
        <br />
        <v-card-subtitle>
          You overrode this session's editing lock for
          {{ offices[currentIndex].levels[0].levelMembers[0].name }}'s hierarchy
          on {{ currentLock.EditStartDateTime | mmddyyyy }} at
          {{ currentLock.EditStartDateTime | hhmm }}. This session's hierarchy
          will now be reloaded.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="#00558c"
            dark
            @click="
              $modal.hide('selfLockWasOverriden');
              reload();
            "
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="overrideSelfLockModal"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
      v-if="
        currentLock != undefined &&
          currentIndex != undefined &&
          offices[currentIndex] &&
          offices[currentIndex].levels &&
          offices[currentIndex].levels[0] &&
          offices[currentIndex].levels[0].levelMembers &&
          offices[currentIndex].levels[0].levelMembers[0]
      "
    >
      <v-card style="height: 300px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Another Editing Session Detected</v-toolbar-title>
        </v-toolbar>
        <br />
        <v-card-subtitle>
          {{ offices[currentIndex].levels[0].levelMembers[0].name }}'s hierarchy
          was locked for editing by you on
          {{ currentLock.EditStartDateTime | mmddyyyy }} at
          {{ currentLock.EditStartDateTime | hhmm }} in a different browser or
          from a different tab. If you do not have another editing session open,
          click override to continue, otherwise please click cancel and continue
          editing in the original window.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="overrideLock">Override</v-btn>
          <v-btn
            color="#00558C"
            dark
            @click="$modal.hide('overrideSelfLockModal')"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <!-- <modal
      name="overrideLockDialog"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
      v-if="
        currentIndex != undefined &&
          offices[currentIndex] &&
          offices[currentIndex].levels &&
          offices[currentIndex].levels[0] &&
          offices[currentIndex].levels[0].levelMembers &&
          offices[currentIndex].levels[0].levelMembers[0] &&
          currentLock &&
          currentLock.EditedByName
      "
    >
      <v-card style="height: 300px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Hierarchy Editing Is Locked</v-toolbar-title>
        </v-toolbar>
        <br />
        <v-card-subtitle>
          {{ offices[currentIndex].levels[0].levelMembers[0].name }}'s hierarchy
          was locked for editing by {{ currentLock.EditedByName }} on
          {{ currentLock.EditStartDateTime | mmddyyyy }} at
          {{ currentLock.EditStartDateTime | hhmm }}. Do you want to override
          the lock? {{ currentLock.EditedByName }} will lose all changes made
          since the last save.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="overrideLock">Override</v-btn>
          <v-btn color="#00558c" dark @click="$modal.hide('overrideLockDialog')"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal> -->

    <modal
      name="editingLockedDialog"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
      v-if="
        currentIndex != undefined &&
          offices[currentIndex] &&
          offices[currentIndex].levels &&
          offices[currentIndex].levels[0] &&
          offices[currentIndex].levels[0].levelMembers &&
          offices[currentIndex].levels[0].levelMembers[0] &&
          currentLock &&
          currentLock.EditedByName
      "
    >
      <v-card style="height: 250px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Hierarchy Editing Is Locked</v-toolbar-title>
        </v-toolbar>
        <br />
        <v-card-subtitle>
          This hierarchy was locked for editing by
          {{ currentLock.EditedByName }} on
          {{ currentLock.EditStartDateTime | mmddyyyy }} at
          {{ currentLock.EditStartDateTime | hhmm }}. The lock can only be
          overridden by the agency owner or a home office user.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#00558c"
            dark
            @click="$modal.hide('editingLockedDialog')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="overrideLockDialog"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
      v-if="
        currentIndex != undefined &&
          offices[currentIndex] &&
          offices[currentIndex].levels &&
          offices[currentIndex].levels[0] &&
          offices[currentIndex].levels[0].levelMembers &&
          offices[currentIndex].levels[0].levelMembers[0] &&
          currentLock &&
          currentLock.EditedByName
      "
    >
      <v-card style="height: 475px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Hierarchy Editing Is Locked</v-toolbar-title>
        </v-toolbar>
        <br />
        <v-card-subtitle>
          {{ offices[currentIndex].levels[0].levelMembers[0].name }}'s hierarchy
          was locked for editing by {{ currentLock.EditedByName }} on
          {{ currentLock.EditStartDateTime | mmddyyyy }} at
          {{ currentLock.EditStartDateTime | hhmm }}. You can ask
          {{ currentLock.EditedByName }} to save and exit and wait for a
          response, you can cancel your editing request, or you can override the
          lock immediately. If you choose to override the lock,
          {{ currentLock.EditedByName }} will lose all changes made since the
          last save. <br /><br />
          <v-textarea
            name="lockedMsg"
            v-model="lockedMsg"
            filled
            label="Message To Send"
            rows="3"
            no-resize
          ></v-textarea>
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer /> <v-spacer />
          <v-btn
            color="#00558c"
            dark
            @click="
              submitMsg();
              $modal.hide('overrideLockDialog');
            "
            >Send Msg</v-btn
          >
          <v-btn
            color="#00558C"
            dark
            @click="
              overrideLock();
              $modal.hide('overrideLockDialog');
            "
            >Override</v-btn
          >
          <v-btn color="#00558c" dark @click="$modal.hide('overrideLockDialog')"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="dropPreventedAO"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 200px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Assignment Not Allowed</v-toolbar-title>
        </v-toolbar>
        <br />
        <v-card-subtitle>The agency owner cannot be moved.</v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('dropPreventedAO')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="dropPreventedFromAA"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 200px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Assignment Not Allowed</v-toolbar-title>
        </v-toolbar>
        <br />
        <v-card-subtitle
          >Agency users cannot move Agency Administrator.</v-card-subtitle
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#00558C"
            dark
            @click="$modal.hide('dropPreventedFromAA')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="dropPreventedAA"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 200px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Assignment Not Allowed</v-toolbar-title>
        </v-toolbar>
        <br />
        <v-card-subtitle
          >The agency administrator role cannot have
          subordinates.</v-card-subtitle
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('dropPreventedAA')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="dropPreventedAA2"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 250px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Assignment Not Allowed</v-toolbar-title>
        </v-toolbar>
        <br />
        <v-card-subtitle>
          The agency administrator role cannot have subordinates. Please uncheck
          the
          <i>Move Sub-Hierarchy</i> checkbox and try again.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('dropPreventedAA2')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="crossOfficeMaxLevelExceeded"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="min-height: 400px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Assignment Not Allowed</v-toolbar-title>
        </v-toolbar>
        <br />
        <v-card-subtitle>
          <span v-if="crossOfficeAgents.length == 1"
            >The following agent is</span
          >
          <span v-else>The following agents are</span> in an AA role across
          offices and cannot simultaneously be placed as an AB, ABL or Agent in
          this office:
          <br />
          <br />
          <span v-for="(agent, index) in crossOfficeAgents" :key="index">
            {{ agent }}
            <br />
          </span>

          <br />
          <span>
            You can make this change by first removing the AA from the
            hierarchy. This will affect all offices under the AO.
          </span>
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#00558C"
            dark
            @click="$modal.hide('crossOfficeMaxLevelExceeded')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="revertChangesDialog"
      height="auto"
      :width="450"
      :draggable="!isMobile"
      :clickToClose="false"
    >
      <v-card style="height: 225px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Revert Changes?</v-toolbar-title>
        </v-toolbar>
        <br />
        <v-card-subtitle>
          <span v-if="unsavedChanges">You have unsaved changes.&nbsp;</span>Are
          you sure you want to revert the hierarchy to the last save point?
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#00558C"
            dark
            @click="$modal.hide('revertChangesDialog')"
            >Cancel</v-btn
          >
          <v-btn
            color="#00558C"
            dark
            @click="
              $modal.hide('revertChangesDialog');
              reload();
            "
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="unsavedChangesDialog"
      height="auto"
      :width="450"
      :draggable="!isMobile"
      :clickToClose="false"
      ref="unsavedChangesDialog"
    >
      <v-card style="height: 225px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Discard Changes?</v-toolbar-title>
        </v-toolbar>
        <br />
        <v-card-subtitle>
          <span v-if="unsavedChanges">You have unsaved changes.&nbsp;</span>Are
          you sure you want to navigate away and lose these changes?
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="handleNavigation(false)"
            >Cancel</v-btn
          >
          <v-btn color="#00558C" dark @click="handleNavigation(true)">OK</v-btn>
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="minLevelExceeded"
      height="auto"
      :width="450"
      :draggable="!isMobile"
      :clickToClose="false"
    >
      <v-card style="height: 225px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Assignment Not Allowed</v-toolbar-title>
        </v-toolbar>
        <br />
        <v-card-subtitle>
          When moving a sub-hierarchy, the agent's new role must be greater than
          that of all his/her existing subordinates.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('minLevelExceeded')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="levelSelectionDialog"
      ref="levelSelectionDialog"
      height="auto"
      :width="450"
      :draggable="!isMobile"
      :clickToClose="false"
    >
      <v-card style="height: 225px" @mousedown="$refs.levelSelectionBox.blur()">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Select Role</v-toolbar-title>
        </v-toolbar>
        <br /><br />
        <v-form ref="selectionForm">
          <v-row align="center">
            <v-col></v-col>
            <v-col cols="10">
              <v-select
                ref="levelSelectionBox"
                v-model="offices[currentIndex].selectedLevel"
                :items="levelNames"
                dense
                outlined
                :rules="[v => !!v || 'Role selection is required.']"
              ></v-select>
            </v-col>
            <v-col></v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#00558C"
              dark
              @click="
                $refs.selectionForm.reset();
                offices[currentIndex].levelSelectionDialog = false;
                $modal.hide('levelSelectionDialog');
              "
              >Cancel</v-btn
            >
            <v-btn color="#00558C" dark submit @click="roleSelected()"
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </modal>

    <modal
      name="restoreAccessDialog"
      height="auto"
      :width="500"
      :draggable="!isMobile"
      :clickToClose="false"
      v-if="offices[currentIndex].restoreMember != null"
    >
      <v-card style="height: 225px">
        <v-toolbar color="#00558C" dark>
          <v-icon x-large color="green" style="margin-right: 10px"
            >mdi-alert-circle-outline</v-icon
          >
          <v-toolbar-title>Confirm Restore Access</v-toolbar-title>
        </v-toolbar>

        <br />
        <v-card-text>
          Are you sure you want to restore SalesForce access for
          {{ offices[currentIndex].restoreMember.name }}?
          <!-- <span
            v-if="
              offices[currentIndex].restoreMember.id !=
                $store.state.currentAO.id
            "
          >
            ({{ offices[currentIndex].restoreMember.name }}
            will be returned to the Assignment Pool.)
          </span>-->
        </v-card-text>
        <br v-if="offices[currentIndex].restoreMember.name.length < 15" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#00558C"
            dark
            @click="$modal.hide('restoreAccessDialog')"
            >Cancel</v-btn
          >
          <v-btn
            color="#00558C"
            dark
            @click="
              $modal.hide('restoreAccessDialog');
              restoreMemberAccess(offices[currentIndex].restoreMember);
            "
            >Restore Access</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="revokeAccessDialog"
      height="auto"
      :width="500"
      :draggable="!isMobile"
      :clickToClose="false"
      v-if="offices[currentIndex].deleteMember != null"
    >
      <v-card style="height: 225px">
        <v-toolbar color="#00558C" dark>
          <v-icon color="red" x-large style="margin-right: 10px"
            >mdi-alert</v-icon
          >
          <v-toolbar-title>Confirm Revoke Access</v-toolbar-title>
        </v-toolbar>

        <br />
        <v-card-text>
          Are you sure you want to revoke SalesForce access for
          {{ offices[currentIndex].deleteMember.name }}?
        </v-card-text>
        <br v-if="offices[currentIndex].deleteMember.name.length < 15" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('revokeAccessDialog')"
            >Cancel</v-btn
          >
          <v-btn
            color="#00558C"
            dark
            @click="
              $modal.hide('revokeAccessDialog');
              moveToRevoked(offices[currentIndex].deleteMember, 0);
            "
            >Revoke Access</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="deleteDialog"
      height="auto"
      :width="550"
      :draggable="!isMobile"
      :clickToClose="false"
      v-if="
        currentIndex != undefined &&
          offices[currentIndex] &&
          offices[currentIndex].deleteMember &&
          offices[currentIndex].deleteMember.name
      "
    >
      <v-card style="height: 275px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title
            v-if="!isRevoked(offices[currentIndex].deleteMember.id)"
            >Confirm Removal or Revoke Access</v-toolbar-title
          >
          <v-toolbar-title v-else>Confirm Removal</v-toolbar-title>
        </v-toolbar>

        <br />
        <v-card-text v-if="!isRevoked(offices[currentIndex].deleteMember.id)">
          Do you want to remove
          {{ offices[currentIndex].deleteMember.name }} from this hierarchy or
          revoke {{ offices[currentIndex].deleteMember.name }}'s access to
          SalesForce? <br />(Removal from the hierarchy will move the agent to
          the Agency Transfer Pool for reassignment.)
        </v-card-text>
        <v-card-text v-else>
          Do you want to remove
          {{ offices[currentIndex].deleteMember.name }} from this hierarchy?
          <br />(Removal from the hierarchy will move the agent to the Agency
          Transfer Pool for reassignment.)
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('deleteDialog')"
            >Cancel</v-btn
          >
          <v-btn
            color="#00558C"
            dark
            @click="
              $modal.hide('deleteDialog');
              moveToUnassigned(offices[currentIndex].deleteMember);
            "
            >Remove From Hierarchy</v-btn
          >
          <v-btn
            color="#00558C"
            dark
            v-if="!isRevoked(offices[currentIndex].deleteMember.id)"
            @click="
              $modal.hide('deleteDialog');
              $modal.show('revokeAccessDialog');
            "
            >Revoke Access</v-btn
          >
          <!-- moveToRevoked(offices[currentIndex].deleteMember);
          "-->
        </v-card-actions>
      </v-card>
    </modal>

    <!-- <modal
      name="deleteDialog"
      height="auto"
      :width="550"
      :draggable="!isMobile"
      :clickToClose="false"
    >
      <v-card
        style="height:275px;"
        v-if="
          currentIndex != undefined &&
            offices &&
            offices[currentIndex] &&
            offices[currentIndex].deleteMember &&
            offices[currentIndex].deleteMember.name
        "
      >
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Confirm Removal</v-toolbar-title>
        </v-toolbar>

        <br />
        <v-card-text>
          Do you want to remove
          {{ offices[currentIndex].deleteMember.name }} from this hierarchy?
          <br />(Removal from the hierarchy will move the agent to the Agency
          Transfer Pool for reassignment.)
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('deleteDialog')">Cancel</v-btn>
          <v-btn
            color="#00558C"
            dark
            @click="
              $modal.hide('deleteDialog');
              moveToUnassigned(offices[currentIndex].deleteMember);
            "
          >Remove From Hierarchy</v-btn>
        </v-card-actions>
      </v-card>
    </modal>-->

    <modal
      name="detailsDialog"
      :draggable="!isMobile"
      :width="425"
      height="auto"
      :clickToClose="false"
      v-if="offices[currentIndex].detailsMember"
    >
      <v-card style="height: 275px">
        <v-toolbar
          :color="
            offices[currentIndex].detailsLevel
              ? offices[currentIndex].connectorColors[
                  offices[currentIndex].detailsLevel.levelOrder
                ]
              : '#00558c'
          "
          dark
        >
          <v-toolbar-title>
            <v-icon x-large>mdi-account</v-icon>
            {{ offices[currentIndex].detailsMember.name }}
          </v-toolbar-title>
          <br />
        </v-toolbar>
        <br />
        <v-card-subtitle>
          Agent Number: {{ offices[currentIndex].detailsMember.id }}
          <br />
          <span v-if="offices[currentIndex].detailsLevel">{{
            offices[currentIndex].detailsLevel.levelName
          }}</span>
          <span
            v-if="findMemberSupervisor(offices[currentIndex].detailsMember)"
          >
            <span v-if="offices[currentIndex].detailsLevel">
              <br />
              Reports To:&nbsp;{{
                offices[currentIndex].detailsMember.supervisor.name
              }}&nbsp;({{
                offices[currentIndex].detailsMember.supervisor.level
              }})
            </span>
            <span v-else>UNASSIGNED</span>
          </span>
          <span
            v-if="isRevoked(offices[currentIndex].detailsMember.id)"
            style="color: red"
          >
            <br />Salesforce Access Revoked
          </span>
          <span
            v-if="
              offices[currentIndex].detailsMember.terminationDate &&
                offices[currentIndex].detailsMember.terminationDate != ''
            "
            style="color: orange"
          >
            <br />Termination Date:
            {{
              offices[currentIndex].detailsMember.terminationDate
                | dateFromString
            }}
          </span>
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('detailsDialog')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="replaceDialog"
      height="auto"
      :width="475"
      :draggable="!isMobile"
      :clickToClose="false"
    >
      <v-card
        style="height: 275px"
        v-if="offices[currentIndex].replaceMember != null"
        @mousedown="$refs.selectedReplacementBox.blur()"
      >
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>
            Select Replacement
            {{ offices[currentIndex].replaceLevel.levelName }}
          </v-toolbar-title>
        </v-toolbar>
        <v-form ref="replacementForm">
          <v-row align="center">
            <v-col></v-col>
            <v-col cols="10">
              <v-card-text>
                Select the replacement for
                {{ offices[currentIndex].replaceMember.name }}:
              </v-card-text>
              <v-select
                ref="selectedReplacementBox"
                v-model="offices[currentIndex].selectedReplacement"
                :items="availableAgents"
                dense
                outlined
                :rules="[v => !!v || 'Replacement selection is required.']"
              ></v-select>
            </v-col>
            <v-col></v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#00558C"
              dark
              @click="
                $refs.replacementForm.reset();
                cancelReplace();
              "
              >Cancel</v-btn
            >
            <v-btn
              color="#00558C"
              dark
              submit
              @click.stop="replaceWithSelection()"
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </modal>

    <modal
      name="moveAgentsDialog"
      height="auto"
      :width="500"
      :draggable="!isMobile"
      :clickToClose="false"
    >
      <v-card
        style="height: 400px"
        @mousedown="
          $refs.currentMoveSup.blur();
          $refs.possAgentSup.blur();
        "
      >
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Move Agents</v-toolbar-title>
        </v-toolbar>
        <v-form ref="moveAgentsForm">
          <v-row align="center" no-gutters>
            <v-col></v-col>
            <v-col cols="10">
              <v-card-text
                >Select the person the agents report to now:</v-card-text
              >
              <v-select
                ref="currentMoveSup"
                v-model="offices[currentIndex].currentMoveSupervisor"
                :items="agentSupervisors"
                dense
                outlined
                :rules="[v => !!v || 'Current Report To is required.']"
              ></v-select>
            </v-col>
            <v-col></v-col>
          </v-row>
          <v-row align="center" no-gutters>
            <v-col></v-col>
            <v-col cols="10">
              <v-card-text>
                Select the person the agents should report to (or select
                <i>Agency Transfer Pool</i> to facilitate moving groups of
                agents):
              </v-card-text>
              <v-select
                ref="possAgentSup"
                v-model="offices[currentIndex].selectedMoveSupervisor"
                :items="possibleAgentSupervisorsMove"
                dense
                outlined
                :rules="[v => !!v || 'New Report To is required.']"
              ></v-select>
            </v-col>
            <v-col></v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#00558C"
              dark
              @click="
                $modal.hide('moveAgentsDialog');
                $refs.moveAgentsForm.reset();
              "
              >Cancel</v-btn
            >
            <v-btn
              color="#00558C"
              dark
              submit
              @click.stop="moveAgentsToSelectedSupervisor()"
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </modal>

    <modal
      name="moveSelectedDialog"
      height="auto"
      :width="500"
      :draggable="!isMobile"
      :clickToClose="false"
    >
      <v-card style="max-height: 640px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Move Agents</v-toolbar-title>
        </v-toolbar>
        <v-form ref="moveSelectedForm">
          <!-- From Agency Transfer Pool Start -->
          <v-row align="center" no-gutters v-if="movingFromSupervisor == -100">
            <v-col></v-col>
            <v-col cols="10">
              <v-card-text>Selected unassigned agents:</v-card-text>
            </v-col>
            <v-col></v-col>
          </v-row>
          <v-row v-if="movingFromSupervisor == -100">
            <v-col></v-col>
            <v-col cols="10">
              <v-data-table
                id="selectedMovingRows"
                class="elevation-1 selected-table"
                v-model="selectedMovingRows"
                :headers="selectedTableHeaders"
                :items="movingAgentsPool"
                :items-per-page="-1"
                item-key="name"
                height="125"
                :hide-default-footer="true"
                no-data-text="No Agent Found"
              >
              </v-data-table>
            </v-col>
            <v-col></v-col>
          </v-row>
          <v-row align="center" no-gutters v-if="movingFromSupervisor == -100">
            <v-col></v-col>
            <v-col cols="10">
              <v-card-text>
                Select the person the agents should report to:
              </v-card-text>
              <v-select
                ref="possAgentSup"
                v-model="movingToSupervisor"
                :items="possibleAgentSupervisors"
                dense
                outlined
                :rules="[v => !!v || 'New Report To is required.']"
              ></v-select>
            </v-col>
            <v-col></v-col>
          </v-row>
          <!-- From Agency Transfer Pool End -->

          <!-- From Supervisor Start -->
          <v-row align="center" no-gutters v-if="movingFromSupervisor != -100">
            <v-col></v-col>
            <v-col cols="10">
              <v-card-text
                >Select the person the agents report to now:</v-card-text
              >
              <v-select
                ref="movingFromSup"
                v-model="movingFromSupervisor"
                :items="possibleAgentSupervisors"
                dense
                outlined
                :rules="[v => !!v || 'Current Report To is required.']"
              ></v-select>
            </v-col>
            <v-col></v-col>
          </v-row>
          <v-row v-if="movingFromSupervisor && movingFromSupervisor != -100">
            <v-col></v-col>
            <v-col cols="10">
              <v-data-table
                id="selectedMovingRows"
                class="elevation-1 selected-table"
                v-model="selectedMovingRows"
                :headers="selectedTableHeaders"
                :items="movingAgentsPool"
                :items-per-page="-1"
                item-key="name"
                :hide-default-footer="true"
                no-data-text="No Agent Found"
                show-select
                height="125"
              >
              </v-data-table>
            </v-col>
            <v-col></v-col>
          </v-row>
          <v-row align="center" no-gutters v-if="movingFromSupervisor != -100">
            <v-col></v-col>
            <v-col cols="10">
              <v-card-text>
                Select the person the agents should report to (or select
                <i>Agency Transfer Pool</i> to facilitate moving groups of
                agents):
              </v-card-text>
              <v-select
                ref="possAgentSup"
                v-model="movingToSupervisor"
                :items="possibleAgentSupervisorsMove"
                dense
                outlined
                :rules="[v => !!v || 'New Report To is required.']"
              ></v-select>
            </v-col>
            <v-col></v-col>
          </v-row>
          <!-- From Supervisor End -->

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#00558C"
              dark
              @click="
                $modal.hide('moveSelectedDialog');
                $refs.moveSelectedForm.reset();
              "
              >Cancel</v-btn
            >
            <v-btn
              color="#00558C"
              dark
              submit
              @click.stop="moveSelectedToSupervisor()"
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </modal>

    <modal
      name="moveMemberDialog"
      height="auto"
      :width="500"
      :draggable="!isMobile"
      :clickToClose="false"
    >
      <v-card @mousedown="$refs.moveMemberSup.blur()">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Move Agent</v-toolbar-title>
        </v-toolbar>
        <v-form ref="moveMemberForm">
          <v-row align="center" no-gutters v-if="showMemberSelect">
            <v-col></v-col>
            <v-col cols="10">
              <v-card-text>Select the person</v-card-text>
              <v-select
                v-model="movingFromMemberId"
                :items="possibleFromMember"
                dense
                outlined
                :rules="[v => !!v || 'Agent From is required.']"
              ></v-select>
            </v-col>
            <v-col></v-col>
          </v-row>
          <v-row align="center" no-gutters>
            <v-col></v-col>
            <v-col cols="10">
              <v-card-text>
                Select who
                {{ selectedMember ? selectedMember.name : "" }} should report
                to:
              </v-card-text>
              <v-select
                ref="moveMemberSup"
                v-model="movingToMemberId"
                :items="possibleAgentSupervisors"
                dense
                outlined
                :rules="[v => !!v || 'New Report To is required.']"
              ></v-select>
            </v-col>
            <v-col></v-col>
          </v-row>
          <v-card-actions>
            <v-checkbox
              style="
                        margin-left: 10px;
                        margin-bottom: 0px;
                        margin-top: 10px;
                      "
              v-model="offices[currentIndex].moveHierFlag"
              label="Move Sub-Hierarchy?"
            ></v-checkbox>
            <v-spacer></v-spacer>
            <v-btn
              color="#00558C"
              dark
              @click="
                $modal.hide('moveMemberDialog');
                $refs.moveMemberForm.reset();
              "
              >Cancel</v-btn
            >
            <v-btn color="#00558C" dark submit @click.stop="tryMoveMember()"
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </modal>

    <modal
      name="addAgentsDialog"
      height="auto"
      :width="475"
      :draggable="!isMobile"
      :clickToClose="false"
      v-if="offices[currentIndex].agentsToAdd.length"
    >
      <v-card
        style="height: 275px"
        @mousedown="$refs.addAgentsPossAgentSups.blur()"
      >
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Select Report To</v-toolbar-title>
        </v-toolbar>
        <v-form ref="addAgentsForm">
          <v-row align="center">
            <v-col></v-col>
            <v-col cols="10">
              <v-card-text
                >Select the person the agents should report to.</v-card-text
              >
              <v-select
                ref="addAgentsPossAgentSups"
                v-model="offices[currentIndex].selectedSupervisor"
                :items="possibleAgentSupervisors"
                dense
                outlined
                :rules="[v => !!v || 'Report To is required.']"
              ></v-select>
            </v-col>
            <v-col></v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#00558C"
              dark
              @click="
                $modal.hide('addAgentsDialog');
                $refs.addAgentsForm.reset();
              "
              >Cancel</v-btn
            >
            <v-btn
              color="#00558C"
              dark
              submit
              @click.stop="addAgentsToSelectedSupervisor()"
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </modal>

    <modal
      name="addNewOfficeDialog"
      height="auto"
      :width="475"
      :draggable="!isMobile"
      :clickToClose="false"
    >
      <v-card style="height: 325px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>New Office</v-toolbar-title>
        </v-toolbar>

        <br />
        <v-row align="center" no-gutters>
          <v-col></v-col>
          <v-col cols="10">
            <v-card-subtitle
              >Please enter a name for the new office.</v-card-subtitle
            >
            <v-text-field
              ref="officeName"
              v-model="officeName"
              label="Office Name"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col></v-col>
        </v-row>
        <v-row align="center" no-gutters>
          <v-col></v-col>
          <v-col cols="10">
            <v-checkbox
              style="
                margin-top: 5px;
                display: inline-block;
                float: left;
                padding-right: 10px;
              "
              v-model="offices[currentIndex].moveHierFlag"
              label="Move Sub-Hierarchy?"
            ></v-checkbox>
          </v-col>
          <v-col></v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('addNewOfficeDialog')"
            >Cancel</v-btn
          >
          <v-btn color="#00558C" dark submit @click.stop="createOffice()"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="renameOfficeDialog"
      height="auto"
      :width="475"
      :draggable="!isMobile"
      :clickToClose="false"
    >
      <v-card style="height: 275px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>New Office</v-toolbar-title>
        </v-toolbar>

        <br />
        <v-row align="center" no-gutters>
          <v-col></v-col>
          <v-col cols="10">
            <v-card-subtitle
              >Please enter a new name for this office.</v-card-subtitle
            >

            <v-text-field
              ref="officeName"
              v-model="officeName"
              label="Office Name"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col></v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('renameOfficeDialog')"
            >Cancel</v-btn
          >
          <v-btn color="#00558C" dark submit @click.stop="renameOffice()"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="saveSuccessDialog"
      height="auto"
      :width="475"
      :draggable="!isMobile"
      :clickToClose="false"
    >
      <v-card style="height: 250px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Changes Saved</v-toolbar-title>
        </v-toolbar>

        <br />
        <v-row align="center" no-gutters>
          <v-col></v-col>
          <v-col cols="10">
            <v-card-subtitle
              >All changes made to the hierarchy will be reflected in Salesforce
              on the following day, except for Revoke Access requests, which are
              immediate.</v-card-subtitle
            >
          </v-col>
          <v-col></v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('saveSuccessDialog')"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <!-- Code Marker -- Start Column One -->

    <v-row id="outerRowTop">
      <v-col
        id="unclassifiedCol"
        xl="2"
        lg="3"
        md="3"
        sm="4"
        style="max-width: 325px !important; width: 325px !important"
      >
        <div style="'max-height:' + calcHeight + 'px;'">
          <br />
          <v-row style="calcAgencyAddrHeight">
            <v-card
              style="
                margin-left: 30px;
                max-width: 325px !important;
                width: 325px !important;
                margin-right: 10px;
                margin-bottom: 10px;
              "
              class="elevation-7"
            >
              <v-toolbar color="#00558C">
                <v-row>
                  <v-layout align-content-center align-center justify-center>
                    <span
                      style="
                        width: 250px;
                        font-size: 0.75rem;
                        max-width: 200px !important;
                        margin-right: 5px;
                        margin-top: 20px;
                      "
                    >
                      <v-select
                        name="officeSelections"
                        v-model="currentIndex"
                        :items="officeSelections"
                        item-text="officeName"
                        item-value="officeIndex"
                        label="Please Select an Office"
                        single-line
                        solo
                        dense
                        style="font-size: 0.75rem"
                      ></v-select>
                    </span>
                    <v-tooltip
                      top
                      color="green"
                      z-index="999"
                      v-if="isEditUser"
                    >
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          color="white"
                          style="cursor: pointer; margin-left: 5px"
                          @click.stop="
                            offices[currentIndex].addressDialog = true
                          "
                          >mdi-lead-pencil</v-icon
                        >
                      </template>
                      <span>Edit Agency Name &amp; Address</span>
                    </v-tooltip>
                  </v-layout>
                </v-row>
              </v-toolbar>
              <v-card-text style="margin-top: 0px; padding-top: 5px">
                <strong>{{ offices[currentIndex].name }}</strong>
                <br />
                {{ offices[currentIndex].agencyAddress1 }}
                <br />
                <span v-if="offices[currentIndex].agencyAddress2 != ''">
                  {{ offices[currentIndex].agencyAddress2 }}
                  <br />
                </span>
                {{ csz }}
                <br />
                {{ offices[currentIndex].agencyPhone | phone }}
                <span
                  v-if="
                    offices[currentIndex].agencyPhoneExt &&
                      offices[currentIndex].agencyPhoneExt != ''
                  "
                  >Ext: {{ offices[currentIndex].agencyPhoneExt }}</span
                >
                <v-checkbox
                  color="green"
                  ref="primaryAgencyInd"
                  id="primaryAgencyInd"
                  v-model="offices[currentIndex].primaryAgencyInd"
                  :readonly="true"
                  label="Primary Agency"
                  style="padding-top: 0px;padding-bottom: 0px; margin-bottom: 0px;"
                ></v-checkbox>
              </v-card-text>
            </v-card>
          </v-row>
          <v-row
            style="margin-top: 0px; margin-bottom: 10px; margin-left: 10px"
          >
            <v-card
              style="
                height: 90px;
                margin-left: 5px;
                width: 290px !important;
                max-width: 290px !important;
                margin-right: 10px;
                margin-top: 15px;
                margin-bottom: 5px;
              "
              class="elevation-7"
            >
              <v-toolbar
                color="#00558C"
                dark
                style="height: 90px; padding-top: 5px"
              >
                <AgentSearchBox
                  :isEditMode="editableFlag"
                  :searchableAgents="possibleSearchAgentsAllOffices"
                  :sortedAgentPool="sortedAgentPoolAllOffices"
                  :revokedAgents="revokedAgents"
                ></AgentSearchBox>
              </v-toolbar>
            </v-card>
          </v-row>
          <v-row style="margin-top: 10px; margin-bottom: 10px">
            <v-card
              style="
                height: 250px;
                margin-left: 30px;
                width: 325px !important;
                max-width: 325px !important;
                margin-right: 10px;
                margin-top: 5px;
                margin-bottom: 5px;
              "
              class="elevation-7"
            >
              <v-toolbar color="#00558C" dark>
                <v-toolbar-title>Agency Transfer Pool</v-toolbar-title>
              </v-toolbar>

              <v-list
                :flat="false"
                :dense="true"
                style="
                  min-height: 140px;
                  max-height: 140px;
                  overflow: auto;
                  margin: 0px;
                "
                ref="assignmentPool"
              >
                <v-list-item-group
                  :multiple="true"
                  color="#00558C"
                  v-model="offices[currentIndex].selectedAgents"
                >
                  <draggable
                    :group="group"
                    handle=".drag-item"
                    @start="dragStart"
                    @end="dragEnd"
                    :scroll-sensitivity="100"
                    :scroll="true"
                    :bubble-scroll="true"
                    :delay="200"
                    :delay-on-touch-only="true"
                  >
                    <v-list-item
                      v-for="(agent, index) in sortedAgentPool"
                      :key="index"
                      @click="listClick"
                      :id="'listItem_' + agent.id"
                      :ripple="false"
                      style="margin-left: 5px; padding-left: 0px"
                    >
                      <v-list-item-content
                        :draggable="true"
                        style="margin-left: 0px; padding-left: 0px"
                        :class="editableFlag ? 'drag-item' : ''"
                        :id="'listItemContent_' + agent.id"
                      >
                        <div
                          style="margin-left: 0px; padding-left: 0px"
                          class="drag-item-text"
                          :key="agent.id"
                          :id="buildRef(agent)"
                        >
                          <span
                            :id="'listItemSpan_' + agent.id"
                            :style="
                              isRevoked(agent.id)
                                ? 'color:red; font-size: 0.9rem'
                                : agent.terminationDate &&
                                  agent.terminationDate != ''
                                ? 'color:orange;font-weight:bold;font-size:0.9rem;'
                                : agent.newFlag
                                ? 'color:green;font-size: 0.9rem'
                                : 'font-size:0.9rem;'
                            "
                          >
                            <span style="padding-right: 10px"></span>
                            {{ agent.name }}
                            <span style="padding-right: 10px"></span>

                            <template v-if="!isRevoked(agent.id)">
                              <v-tooltip top color="#00558c">
                                <template v-slot:activator="{ on }">
                                  <v-icon
                                    v-on="on"
                                    size="25"
                                    style="margin-right: 4px; color: #0000008a"
                                    @click.stop="moveMember(agent)"
                                    >mdi-account-switch</v-icon
                                  >
                                </template>
                                <span>Move Agent</span>
                              </v-tooltip>

                              <v-tooltip
                                top
                                color="#00558C"
                                v-if="isHomeOfficeUser"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-icon
                                    size="25"
                                    style="margin-right: 4px; color: #0000008a"
                                    v-on="on"
                                    @click.stop="
                                      if (editableFlag)
                                        checkForRevokeAccess(agent);
                                    "
                                    >mdi-delete</v-icon
                                  >
                                </template>
                                <span>Revoke Access</span>
                              </v-tooltip>

                              <v-tooltip top color="#00558C">
                                <template v-slot:activator="{ on }">
                                  <v-icon
                                    @click="getDetails(agent, null)"
                                    size="25"
                                    style="margin-right: 4px"
                                    v-on="on"
                                    :color="
                                      agent.newFlag == true
                                        ? 'green'
                                        : '#0000008a'
                                    "
                                    >mdi-account</v-icon
                                  >
                                </template>
                                <span v-if="agent.newFlag == true">New!</span>
                                <span v-else>Details</span>
                              </v-tooltip>
                            </template>
                            <template v-else>
                              <!-- access revoked -->

                              <v-tooltip top color="#00558c">
                                <template v-slot:activator="{ on }">
                                  <v-icon
                                    v-on="on"
                                    size="25"
                                    style="margin-right: 4px; color: #0000008a"
                                    @click.stop="moveMember(agent)"
                                    >mdi-account-switch</v-icon
                                  >
                                </template>
                                <span>Move Agent</span>
                              </v-tooltip>

                              <v-tooltip top color="#00558C">
                                <template v-slot:activator="{ on }">
                                  <v-icon
                                    @click="getDetails(agent, null)"
                                    size="25"
                                    style="margin-right: 4px"
                                    v-on="on"
                                    :color="
                                      agent.newFlag == true
                                        ? 'green'
                                        : '#0000008a'
                                    "
                                    >mdi-account</v-icon
                                  >
                                </template>
                                <span v-if="agent.newFlag == true">New!</span>
                                <span v-else>Details</span>
                              </v-tooltip>

                              <v-tooltip top color="#00558c">
                                <template v-slot:activator="{ on }">
                                  <v-icon
                                    v-on="on"
                                    size="25"
                                    style="margin-right: 4px"
                                    color="red"
                                    @click="checkForRestoreAccess(agent)"
                                    >mdi-alert</v-icon
                                  >
                                </template>
                                <span>SalesForce Access Has Been Revoked</span>
                              </v-tooltip>
                            </template>
                          </span>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </draggable>
                </v-list-item-group>
              </v-list>

              <v-layout
                align-center
                align-content-center
                justify-center
                v-if="isEditUser && editableFlag"
                style="flex: 1 1 auto"
              >
                <!-- <v-btn disabled v-if="!editableFlag || !sortedAgentPool.length"
                  >Add To Agents</v-btn
                >
                <v-btn
                  color="#00558C"
                  dark
                  @click="addAgents"
                  v-if="editableFlag && sortedAgentPool.length"
                  ref="addAgentsBtn"
                  >Add To Agents</v-btn
                >-->

                <v-tooltip top color="green">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="
                        offices[currentIndex].selectedAgents &&
                          offices[currentIndex].selectedAgents.length
                      "
                      class="icon-action-button"
                      dark
                      color="#00558C"
                      v-bind="attrs"
                      v-on="on"
                      @click="moveTransferPoolAgents"
                      ref="moveSelectedBtn"
                    >
                      <v-icon dark>mdi-account-switch</v-icon>
                    </v-btn>
                    <v-btn
                      class="icon-action-button"
                      color="gray"
                      v-bind="attrs"
                      v-on="on"
                      v-else
                    >
                      <v-icon dark>mdi-account-switch</v-icon>
                    </v-btn>
                  </template>
                  <span>Move Selected Agents</span>
                </v-tooltip>
                <v-tooltip top color="green">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="
                        isEditUser && editableFlag && sortedAgentPool.length > 0
                      "
                      class="icon-action-button"
                      dark
                      color="#00558C"
                      v-bind="attrs"
                      v-on="on"
                      @click="selectAll"
                      ref="moveSelectedBtn"
                    >
                      <v-icon dark>mdi-check-all</v-icon>
                    </v-btn>
                    <v-btn
                      class="icon-action-button"
                      color="gray"
                      v-else
                      v-bind="attrs"
                      v-on="on"
                      ><v-icon dark>mdi-check-all</v-icon></v-btn
                    >
                  </template>
                  <span>Select All</span>
                </v-tooltip>
                <v-tooltip top color="green">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="
                        offices[currentIndex].selectedAgents &&
                          offices[currentIndex].selectedAgents.length
                      "
                      class="icon-action-button"
                      dark
                      color="#00558C"
                      v-bind="attrs"
                      v-on="on"
                      @click="offices[currentIndex].selectedAgents = []"
                      ref="deselectBtn"
                    >
                      <v-icon dark>mdi-selection-off</v-icon>
                    </v-btn>
                    <v-btn
                      class="icon-action-button"
                      color="gray"
                      v-else
                      v-bind="attrs"
                      v-on="on"
                      ><v-icon dark>mdi-selection-off</v-icon></v-btn
                    >
                  </template>
                  <span>Deselect All</span>
                </v-tooltip>

                <!-- 
                  <v-btn
                  color="#00558C"
                  dark
                  v-if="offices[currentIndex].selectedAgents && offices[currentIndex].selectedAgents.length"
                  @click="offices[currentIndex].selectedAgents = []"
                  ref="deselectBtn">
                  Deselect All</v-btn>
                <v-btn v-else disabled>Deselect All</v-btn> 
                -->
              </v-layout>
            </v-card>
          </v-row>

          <v-row style="margin-top: 0px; margin-bottom: 10px">
            <v-card
              style="
                height: 200px;
                margin-left: 30px;
                width: 325px !important;
                max-width: 325px !important;
                margin-right: 10px;
                margin-top: 5px;
                margin-bottom: 5px;
              "
              class="elevation-7"
            >
              <v-toolbar color="#00558C" dark>
                <v-toolbar-title>Access Revoked</v-toolbar-title>
              </v-toolbar>

              <v-list
                :flat="false"
                :dense="true"
                style="min-height: 125px; max-height: 125px; overflow: auto"
                ref="accessRevoked"
              >
                <v-list-item-group :multiple="true" color="#00558C">
                  <!-- <draggable
                    :group="group"
                    handle=".drag-item"
                    @start="dragStart"
                    @end="dragEnd"
                    :scroll-sensitivity="200"
                    :scroll="true"
                    :bubble-scroll="true"
                  >-->
                  <v-list-item
                    v-for="agent in sortedRevokedAgents"
                    :key="agent.id"
                    :id="'revokedListItem_' + agent.id"
                    :ripple="false"
                  >
                    <v-list-item-content
                      style="margin-left: 0px; padding-left: 0px"
                      :draggable="true"
                      :class="editableFlag ? 'drag-item' : ''"
                      :id="'revokedListItemContent_' + agent.id"
                    >
                      <div
                        style="margin-left: 5px; padding-left: 0px"
                        class="drag-item-text"
                        :key="agent.id"
                        :id="'revoked_' + buildRef(agent)"
                      >
                        <span
                          :id="'revokedListItemSpan_' + agent.id"
                          style="font-size: 0.8rem; color: red"
                        >
                          {{ agent.name }}
                          <template v-if="editableFlag">
                            <v-tooltip top color="#00558C">
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  v-on="on"
                                  color="red"
                                  size="20"
                                  @click="checkForRestoreAccess(agent)"
                                  >mdi-alert</v-icon
                                >
                              </template>
                              <span>Restore Access</span>
                            </v-tooltip>
                          </template>
                        </span>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- </draggable> -->
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-row>

          <v-row>
            <v-col></v-col>
          </v-row>
        </div>
      </v-col>
      <v-col :style="getMainColWidth">
        <v-progress-circular
          indeterminate
          color="green"
          v-if="initFlag || !showSwimLanes"
          size="50"
          class="waitCircle"
        ></v-progress-circular>
        <div style="position: relative">
          <v-row
            id="outerRowBottom"
            v-if="initFlag == false && showSwimLanes"
            style="position: fixed; top: 55px; left: 330px"
          >
            <v-col
              id="buttonCol"
              class="trim"
              style="padding-top: 10px; flex: 1 1 auto"
            >
              <br />
              <!-- <v-layout
                justify-start
                align-start
                align-content-start
                class="trim"
              > -->
              <v-row
                id="buttonRow"
                class="trim"
                :style="getMainColWidth + 'overflow:auto;padding-top:15px;'"
              >
                <v-col style="min-width: 1200px" class="trim">
                  <v-row class="trim" style="display: block !important">
                    <v-btn
                      color="#00558C"
                      style="margin-right: 10px; display: inline-block"
                      dark
                      @click="edit"
                      v-if="!editableFlag && isEditUser"
                      >Edit</v-btn
                    >
                    <v-btn
                      disabled
                      v-if="editableFlag || !isEditUser"
                      style="margin-right: 10px"
                      >Edit</v-btn
                    >

                    <!-- <v-btn
                    color="#00558C"
                    style="margin-right:10px"
                    dark
                    @click="moveAgents"
                    v-if="editableFlag && isEditUser && agentsInHierarchy"
                  >Move Agents</v-btn>
                  <v-btn
                    style="margin-right:10px"
                    disabled
                    v-if="!editableFlag || !agentsInHierarchy || !isEditUser"
                  >Move Agents</v-btn> -->

                    <v-btn
                      color="#00558C"
                      style="margin-right: 10px"
                      dark
                      @click="moveAgents"
                      v-if="editableFlag && isEditUser && agentsInHierarchy"
                      >Move Agents</v-btn
                    >
                    <v-btn
                      style="margin-right: 10px"
                      disabled
                      v-if="!editableFlag || !agentsInHierarchy || !isEditUser"
                      >Move Agents</v-btn
                    >

                    <v-btn
                      color="#00558C"
                      style="margin-right: 10px"
                      dark
                      @click="saveAndContinue"
                      v-if="isEditUser && editableFlag"
                      >Save</v-btn
                    >
                    <v-btn
                      style="margin-right: 10px"
                      disabled
                      v-if="!editableFlag || !isEditUser"
                      >Save</v-btn
                    >

                    <v-btn
                      color="#00558C"
                      style="margin-right: 10px"
                      dark
                      @click="save"
                      v-if="isEditUser && editableFlag"
                      >Save And Close</v-btn
                    >
                    <v-btn
                      style="margin-right: 10px"
                      disabled
                      v-if="!editableFlag || !isEditUser"
                      >Save And Close</v-btn
                    >

                    <v-btn
                      color="#00558C"
                      style="margin-right: 10px"
                      dark
                      @click="revert"
                      v-if="isEditUser && editableFlag"
                      >Revert To Last Save</v-btn
                    >
                    <v-btn
                      disabled
                      style="margin-right: 10px"
                      v-if="!editableFlag || !isEditUser"
                      >Revert To Last Save</v-btn
                    >

                    <v-btn
                      color="#00558C"
                      style="margin-right: 10px"
                      dark
                      v-if="isHomeOfficeUser"
                      @click="$router.push('/hierarchy')"
                      >Return to AO Selection</v-btn
                    >
                  </v-row>
                  <v-row class="trim">
                    <v-checkbox
                      style="
                        margin-left: 10px;
                        margin-bottom: 0px;
                        margin-top: 10px;
                      "
                      v-model="offices[currentIndex].moveHierFlag"
                      label="Move Sub-Hierarchy?"
                    ></v-checkbox>
                    <v-input
                      style="align-items: center; margin-top: 10px; margin-left: 20px;"
                      >Scroll to the right to see complete lead
                      hierarchy</v-input
                    >
                  </v-row>
                </v-col>
              </v-row>
              <!-- </v-layout> -->
            </v-col>
          </v-row>

          <v-row
            style="
              position: fixed;
              top: 165px;
              left: 330px;
              max-width: 100%;
              max-height: 100%;
            "
          >
            <div id="mainRow" :style="calcMainRowStyle + 'padding-top:10px;'">
              <template v-if="offices.length">
                <template v-for="(office, index) in offices">
                  <SwimlanesComponent
                    :key="index"
                    :editableFlag="editableFlag"
                    :moveHierFlag="office.moveHierFlag"
                    :connectorColors="office.connectorColors"
                    :agentLevel="office.agentLevel"
                    :abLevel="ABLevel"
                    :ablLevel="ABLLevel"
                    :officeIndex="index"
                    :aoRevokedFlag="aoRevoked"
                    :scrollToMember="scrollMember"
                    :highlightMember="highlightMember"
                    :style="calcComponentStyle"
                    v-show="index == currentIndex && showSwimLanes"
                  ></SwimlanesComponent>
                  <!-- v-if="initFlag == false" -->
                </template>
              </template>
            </div>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <v-progress-circular
      indeterminate
      color="green"
      v-if="waitFlag"
      size="50"
      class="waitCircle"
    ></v-progress-circular>

    <v-overlay :value="overlay" :absolute="true">
      <v-progress-circular
        indeterminate
        color="green"
        size="50"
        class="waitCircle"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
// import { Auth } from "aws-amplify";
import API, { graphqlOperation } from "@aws-amplify/api";
import * as queries from "@/graphql/queries";
import * as mutations from "@/graphql/mutations";
import AgencyAddress from "@/components/agency-address.vue";
import EventBus from "@/eventBus.js";
import { Sortable, AutoScroll } from "sortablejs/modular/sortable.core.esm.js";
import { HTTP } from "@/http-common.js";
import SwimlanesComponent from "@/components/swimlanes-component.vue";
import utilityMixins from "@/utility-mixins.js";
import AgentSearchBox from "@/components/agent-search-box";
import $j from "jquery";
// import recognizedRoles from "@/roles.js";
// import axios from "axios";

Sortable.mount(new AutoScroll());

import draggable from "vuedraggable";

export default {
  mixins: [utilityMixins],
  components: {
    AgencyAddress,
    SwimlanesComponent,
    draggable,
    AgentSearchBox
  },
  created() {
    this.isMobileCheck();

    window.addEventListener("resize", this.isMobileCheck);
    window.addEventListener("resize", this.recalculateWindowWidth);
    window.addEventListener("resize", this.recalculateWindowHeight);

    // let user = this.$store.state.user;

    // this.token =
    //   user.storage[user.keyPrefix + "." + user.username + "." + "accessToken"];

    // console.log(this.token);

    // Auth.currentSession()
    // .then(data => console.log(data))
    // .catch(err => console.log(err));
  },

  directives: {},

  beforeRouteLeave(to, from, next) {
    if (this.unsavedChanges && to.path != "/logout") {
      this.$modal.show("unsavedChangesDialog");
      this.$nextTick(() => {
        this.$refs.unsavedChangesDialog.$once("closed", () => {
          if (this.navigate == true) {
            return next();
          }
        });
      });
    } else {
      if (this.editableFlag == false) {
        return next();
      } else {
        let SaveTime = new Date();
        HTTP.post(
          "locks",
          {
            aoAgentNum: this.$store.state.currentAO.id,
            editedByNum: this.userPrimaryAgentNum,
            editedByName: this.$store.state.currentUser.name,
            locked: false,
            sessionId: this.$store.state.session,
            lastSaveTime: SaveTime
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
          .then(response => {
            if (
              response.status == 200 &&
              response.data.errorMessage == undefined
            ) {
              this.sendUnlockedMsg();

              return next();
            } else {
              try {
                this.addToErrorLogs(
                  "swimlanes-shell beforeRouteLeave POST /locks",
                  new Error(JSON.stringify(response))
                );
              } catch (e) {
                this.addToErrorLogs(
                  "swimlanes-shell beforeRouteLeave POST /locks",
                  new Error("Response status: " + response.status.toString())
                );
                this.addToErrorLogs(
                  "swimlanes-shell beforeRouteLeave POST /locks",
                  e
                );
              }

              return next();
            }
          })
          .catch(e => {
            this.addToErrorLogs(
              "swimlanes-shell beforeRouteLeave POST /locks",
              e
            );

            return next();
          });
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.isMobileCheck);
    window.removeEventListener("resize", this.recalculateWindowWidth);
    window.removeEventListener("resize", this.recalculateWindowHeight);

    EventBus.$off("addressChange");
    EventBus.$off("addressChangeCancel");
    EventBus.$off("dragEnd");
    EventBus.$off("dragStart");
    EventBus.$off("getDetails");
    EventBus.$off("checkForDelete");
    EventBus.$off("replacePosition");
    EventBus.$off("replaceAO");
    EventBus.$off("createOffice");
    EventBus.$off("revokeAO");
    EventBus.$off("logOutRequest");
    EventBus.$off("restoreMemberAccess");
    EventBus.$off("moveMember");
    EventBus.$off("moveSelected");
    EventBus.$off("searchBoxAction");
    EventBus.$off("reloadHierarchy");
    EventBus.$off("reloadHierarchyOnOverride");
    EventBus.$off("reloadHierarchyDueToSecondLogin");
  },
  mounted() {
    try {
      // this.addToErrorLogs(
      //   "testing swimlanes-shell mounted",
      //   new Error("This is a test of API logging.")
      // );

      // this.addToErrorLogs(
      //   "testing swimlanes-shell mounted",
      //   "this is a second test"
      // );

      this.initialize(false);

      // let ref = this;
      // this.$nextTick(function () {
      //   window.addEventListener("resize", ref.recalculateWindowWidth);
      //   window.addEventListener("resize", ref.recalculateWindowHeight);
      // });

      EventBus.$on(
        "showMsgModal",
        function(msgObj) {
          this.unlockMsgFrom = msgObj.FromName;
          this.unlockMsg = msgObj.Msg;
          this.unlockData = msgObj;

          if (this.unlockData.ToSession == this.$store.state.session) {
            this.$modal.show("msgModal");
          }
        }.bind(this)
      );

      EventBus.$on(
        "reloadHierarchyOnOverride",
        function(AONum, overrideMsg, From, unlockData) {
          if (
            this.editableFlag == true &&
            this.$store.state.currentAO.id == AONum
          ) {
            this.overrideMsg = overrideMsg;
            this.overrideAgentNum = From;
            this.unlockData = unlockData;

            if (
              this.overrideAgentNum == this.$store.state.currentUser.agentNum
            ) {
              if (this.unlockData.ToSession == this.$store.state.session) {
                this.$modal.show("overrideSelfModal");
              }
            } else {
              if (this.unlockData.ToSession == this.$store.state.session) {
                this.$modal.show("overrideModal");
              }
            }
          }
        }.bind(this)
      );

      EventBus.$on(
        "reloadHierarchyDueToSecondLogin",
        function(AONum, unlockAOName, unlockData) {
          if (
            this.editableFlag == true &&
            this.$store.state.currentAO.id == AONum
          ) {
            if (unlockData.ToSession == this.$store.state.session) {
              if (
                this.unlockData != null &&
                this.unlockData.FromSession != null
              ) {
                this.sendUnlockedMsg();
              }
              this.$nextTick().then(() => {
                this.unlockAOName = unlockAOName;
                this.$modal.show("secondLoginModal");
              });
            }
          }
        }.bind(this)
      );

      EventBus.$on(
        "reloadHierarchy",
        function(AONum) {
          if (this.$store.state.currentAO.id == AONum) {
            this.reload();
          }
        }.bind(this)
      );

      EventBus.$on(
        "restoreMemberAccess",
        function(agent) {
          this.checkForRestoreAccess(agent);
        }.bind(this)
      );

      EventBus.$on(
        "logOutRequest",
        function() {
          if (this.unsavedChanges) {
            this.$modal.show("unsavedChangesDialog");
            this.$nextTick(() => {
              this.$refs.unsavedChangesDialog.$once("closed", () => {
                if (this.navigate == true) {
                  EventBus.$emit("logOutOK");
                } else return;
              });
            });
          } else {
            EventBus.$emit("logOutOK");
          }
        }.bind(this)
      );

      EventBus.$on(
        "createOffice",
        async function(member, parentId, level) {
          this.COMember = member;
          this.COParentId = parentId;
          this.COLevel = level;
          this.officeName =
            this.formatName(
              this.offices[this.currentIndex].levels[0].levelMembers[0].name
            ) +
            " Agency " +
            (this.offices.length + 1).toString();
          this.$modal.show("addNewOfficeDialog");
        }.bind(this)
      );

      EventBus.$on(
        "replaceAO",
        function(source, level) {
          this.replaceAO(source, level);
        }.bind(this)
      );

      EventBus.$on(
        "replacePosition",
        function(source, level) {
          this.replacePosition(source, level);
        }.bind(this)
      );

      EventBus.$on(
        "getDetails",
        function(member, level) {
          this.getDetails(member, level);
        }.bind(this)
      );

      EventBus.$on(
        "checkForDelete",
        function(member) {
          this.checkForDelete(member);
        }.bind(this)
      );

      EventBus.$on(
        "revokeAO",
        function(member) {
          this.checkForRevokeAccess(member);
        }.bind(this)
      );

      EventBus.$on(
        "moveMember",
        function(member) {
          this.handleMoveMember(member);
        }.bind(this)
      );

      EventBus.$on(
        "moveSelected",
        function(memberInfo) {
          this.handleMoveSelected(memberInfo);
        }.bind(this)
      );

      EventBus.$on(
        "dragStart",
        function(e) {
          this.dragStart(e);
        }.bind(this)
      );

      EventBus.$on(
        "dragEnd",
        function(e) {
          this.dragEnd(e);
        }.bind(this)
      );

      EventBus.$on(
        "addressChangeCancel",
        function() {
          this.offices[this.currentIndex].addressDialog = false;
        }.bind(this)
      );

      EventBus.$on(
        "addressChange",
        function(address) {
          this.offices[this.currentIndex].addressDialog = false;

          if (!this.offices[this.currentIndex].agencyCode) {
            this.$modal.show("willBeSavedModal");
          } else {
            this.$modal.show("savedModal");
          }

          this.offices[this.currentIndex].name = address.agencyName;
          this.offices[this.currentIndex].agencyAddress1 = address.address;
          this.offices[this.currentIndex].agencyAddress2 = address.address2;
          this.offices[this.currentIndex].agencyCity = address.city;
          this.offices[this.currentIndex].agencyState = address.state;
          this.offices[this.currentIndex].agencyZip = address.zip;
          this.offices[this.currentIndex].agencyCountry = address.country;
          this.offices[this.currentIndex].agencyPhone = address.phone;
          this.offices[this.currentIndex].agencyPhoneExt = address.phoneExt;
          this.offices[this.currentIndex].agencyEmail = address.email;
          this.offices[this.currentIndex].primaryAgencyInd =
            address.primaryAgencyInd;

          if (address.primaryAgencyInd == true) {
            for (let idx = 0; idx < this.offices.length; idx++) {
              if (idx != this.currentIndex) {
                this.offices[idx].primaryAgencyInd = false;
              }
            }
          }
        }.bind(this)
      );

      EventBus.$on(
        "searchBoxAction",
        function(data) {
          this.handleSearchBoxAction(data);
        }.bind(this)
      );
    } catch (e) {
      this.addToErrorLogs("swimlanes-shell mounted", e);
    }
  },

  computed: {
    // isMobile() {
    //   return this.isMobileVar;
    // },
    scrollMember() {
      return this.memberToScrollTo;
    },
    highlightMember() {
      return this.memberToHighlight;
    },

    calcMainRowStyle() {
      let style = "";
      style = "postion: relative; overflow:auto;";
      let width = this.windowWidth - 330;
      style += "min-width:" + width + "px;";

      style += "max-width:" + width + "px;";
      let height = this.windowHeight - 120;
      // console.log(height);
      style += "min-height: " + height + "px;";
      style += "max-height:" + height + "px;";

      return style;
    },
    calcComponentStyle() {
      let style = "";
      style = "";
      let width = this.windowWidth - 330;
      style += "min-width:" + width + "px;";
      style += "max-width:" + width + "px;";

      return style;
    },
    userPrimaryAgentNum() {
      let agentNum;

      if (this.isAgencyUser)
        agentNum = window.sessionStorage.getItem("primaryAgentNum");

      if (!this.isAgencyUser || !agentNum || agentNum == "null")
        agentNum = this.$store.state.currentUser.agentNum;

      return agentNum;
    },

    unsavedChanges() {
      try {
        for (let idx = 0; idx < this.offices.length; idx++) {
          if (this.offices[idx].changeLog.length > 0) return true;
        }

        return false;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell unsavedChanges", e);
        return false;
      }
    },
    calcHeight() {
      return window.innerHeight - 250;
    },
    curLevelReports() {
      try {
        if (
          this.currentIndex != undefined &&
          this.offices[this.currentIndex] != undefined &&
          this.offices[this.currentIndex] != null
        )
          return this.offices[this.currentIndex].levelReports;
        else return [];
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell curLevelReports", e);
        return [];
      }
    },
    curAgentPool() {
      try {
        if (this.currentIndex && this.offices[this.currentIndex])
          return this.offices[this.currentIndex].agentPool;
        else return [];
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell curAgentPool", e);
        return [];
      }
    },
    curLevels() {
      try {
        if (this.currentIndex && this.offices[this.currentIndex])
          return this.offices[this.currentIndex].levels;
        else return [];
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell curLevels", e);
        return [];
      }
    },
    calcAgencyAddrHeight() {
      try {
        let minHeight = 200;
        let height = minHeight;

        let addLines = Math.floor(
          this.offices[this.currentIndex].name.length / 20
        );

        height = height + addLines * 20;

        return "height: " + height.toString() + "px;";
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell calcAgencyAddrHeight", e);
        return "";
      }
    },
    getOfficeName() {
      try {
        if (
          this.offices[this.currentIndex].name.length >= this.nameDisplayLenMax
        ) {
          return (
            this.offices[this.currentIndex].name.substring(
              0,
              this.nameDisplayLenMax - 3
            ) + "..."
          );
        } else return this.offices[this.currentIndex].name;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell getOfficeName", e);
        return "";
      }
    },
    getMainColWidth() {
      try {
        let myWidth = this.windowWidth - 275;
        let myStyle = "max-width: " + myWidth.toString() + "px !important;";

        return myStyle;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell getMainColWidth", e);
        return "";
      }
    },

    officeSelections() {
      try {
        let ret = [];
        let index = 0;
        for (let office of this.offices) {
          ret.push({
            officeName: office.name,
            officeIndex: index
          });

          index++;
        }
        return ret;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell officeSelections", e);
        return [];
      }
    },
    agentsInHierarchy() {
      try {
        for (let level of this.offices[this.currentIndex].levels) {
          if (level.levelOrder == this.offices[this.currentIndex].agentLevel) {
            if (level.levelMembers && level.levelMembers.length > 0)
              return true;
          }
        }

        return false;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell agentsInHierarchy", e);
        return false;
      }
    },
    agentSupervisors() {
      try {
        let ret = [];

        for (let level of this.offices[this.currentIndex].levels) {
          if (level.levelOrder < this.offices[this.currentIndex].agentLevel) {
            for (let member of level.levelMembers) {
              ret.push({ text: member.name, value: member.id });
            }
          }
        }

        let finalRet = [];

        for (let lev of this.offices[this.currentIndex].levels) {
          if (lev.levelOrder == this.offices[this.currentIndex].agentLevel) {
            // Agent level
            for (let member of lev.levelMembers) {
              for (let possibleSup of ret) {
                if (member.parentId == possibleSup.value) {
                  if (
                    finalRet.findIndex(f => f.value == possibleSup.value) < 0
                  ) {
                    finalRet.push(possibleSup);
                  }
                }
              }
            }
          }
        }

        return this.sortByName(finalRet, "text");
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell agentSupervisors", e);
        return [];
      }
    },
    possibleAgentSupervisors() {
      try {
        let ret = [];

        for (let level of this.offices[this.currentIndex].levels) {
          if (
            level.levelOrder < this.offices[this.currentIndex].agentLevel &&
            level.levelOrder != this.AALevel
          ) {
            for (let member of level.levelMembers) {
              ret.push({ text: member.name, value: member.id });
            }
          }
        }
        return this.sortByName(ret, "text");
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell possibleAgentSupervisors", e);
        return [];
      }
    },
    possibleAgentSupervisorsMove() {
      try {
        let ret = [];

        for (let level of this.offices[this.currentIndex].levels) {
          if (
            level.levelOrder < this.offices[this.currentIndex].agentLevel &&
            level.levelOrder != this.AALevel
          ) {
            for (let member of level.levelMembers) {
              ret.push({ text: member.name, value: member.id });
            }
          }
        }
        ret = this.sortByName(ret, "text");
        ret.push({ text: "Agency Transfer Pool", value: "-100" });

        return ret;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell possibleAgentSupervisors", e);
        return [];
      }
    },
    possibleFromMember() {
      try {
        let ret = [];

        for (let level of this.offices[this.currentIndex].levels) {
          if (level.abbr == "AO") continue;
          for (let member of level.levelMembers) {
            ret.push({ text: member.name, value: member.id });
          }
        }
        ret = this.sortByName(ret, "text");
        return ret;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell possibleAgentMoveFrom", e);
        return [];
      }
    },
    possibleSearchAgentsAllOffices() {
      try {
        let ret = [];
        //Agent in transfer pool
        for (let agent of this.offices[this.currentIndex].agentPool) {
          ret.push({
            text: agent.name,
            value: agent.id,
            memberInfo: agent,
            levelOrder: -1,
            newFlag: agent.newFlag,
            terminationDate: agent.terminationDate
          });
        }
        //All agents except AO
        for (let office of this.offices) {
          for (let level of office.levels) {
            if (level.abbr == "AO") continue;
            for (let member of level.levelMembers) {
              ret.push({
                text: member.name,
                value: member.id,
                memberInfo: member,
                levelOrder: level.levelOrder,
                newFlag: member.newFlag,
                terminationDate: member.terminationDate
              });
            }
          }
        }
        ret = this.sortByName(ret, "text");
        return ret;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell possibleSearchAgents", e);
        return [];
      }
    },
    possibleSearchAgents() {
      try {
        let ret = [];
        //Agent in transfer pool
        for (let agent of this.offices[this.currentIndex].agentPool) {
          ret.push({
            text: agent.name,
            value: agent.id,
            memberInfo: agent,
            levelOrder: -1,
            newFlag: agent.newFlag,
            terminationDate: agent.terminationDate
          });
        }
        //All agents except AO
        for (let level of this.offices[this.currentIndex].levels) {
          if (level.abbr == "AO") continue;
          for (let member of level.levelMembers) {
            ret.push({
              text: member.name,
              value: member.id,
              memberInfo: member,
              levelOrder: level.levelOrder,
              newFlag: member.newFlag,
              terminationDate: member.terminationDate
            });
          }
        }
        ret = this.sortByName(ret, "text");
        return ret;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell possibleSearchAgents", e);
        return [];
      }
    },
    revokedAgents() {
      return this.offices[this.currentIndex].revokedAgents;
    },
    csz() {
      try {
        if (
          this.offices[this.currentIndex].agencyCity ||
          this.offices[this.currentIndex].agencyState ||
          this.offices[this.currentIndex].agencyZip
        )
          return (
            this.offices[this.currentIndex].agencyCity +
            ", " +
            this.offices[this.currentIndex].agencyState +
            "  " +
            this.offices[this.currentIndex].agencyZip
          );
        else return "";
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell csz", e);
        return "";
      }
    },
    levelNames() {
      try {
        let ret = [];
        let minLevel = -1;

        if (!this.offices[this.currentIndex].target) return;

        if (this.isAgencyUser) {
          minLevel = this.AALevel;
        }

        for (let level of this.offices[this.currentIndex].levels) {
          for (let mem of level.levelMembers) {
            if (mem.id == this.offices[this.currentIndex].target.id) {
              minLevel = Math.max(level.levelOrder, minLevel);
              if (level.levelOrder == this.ABLevel) {
                minLevel = this.ABLLevel;
              }
            }
          }
        }

        for (let level of this.offices[this.currentIndex].levels) {
          if (level.levelOrder > minLevel)
            ret.push({ text: level.levelName, value: level.levelOrder });

          // if (level.levelNameAlt)
          //   ret.push({ text: level.levelNameAlt, value: level.levelOrderAlt });
        }

        return ret;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell levelNames", e);
        return [];
      }
    },
    sortedAgentPoolAllOffices() {
      try {
        let sortedAgentPool = [];

        for (let office of this.offices) {
          sortedAgentPool.push(...office.agentPool);
        }

        if (sortedAgentPool.length > 1) {
          return this.sortByName(sortedAgentPool, "name");
        } else return sortedAgentPool;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell sortedAgentPoolAllOffices", e);
        return [];
      }
    },

    sortedAgentPool() {
      try {
        let sortedAgentPool = this.offices[this.currentIndex].agentPool;

        if (sortedAgentPool.length > 1) {
          return this.sortByName(sortedAgentPool, "name");
        } else return sortedAgentPool;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell sortedAgentPool", e);
        return [];
      }
    },
    sortedRevokedAgents() {
      try {
        let sortedRevokedAgents = [];

        sortedRevokedAgents.push(
          ...this.offices[this.currentIndex].revokedAgents
        );

        if (sortedRevokedAgents.length > 1) {
          return this.sortByName(sortedRevokedAgents, "name");
        } else return sortedRevokedAgents;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell sortedRevokedAgents", e);
        return [];
      }
    },
    availableAgents() {
      try {
        let ret = [];

        for (let agent of this.offices[this.currentIndex].agentPool) {
          if (agent.id != this.offices[this.currentIndex].replaceMember.id)
            ret.push({
              text: agent.name,
              value: agent.id
            });
        }

        for (let level of this.offices[this.currentIndex].levels) {
          if (level.abbr == "AO") continue;
          if (level.abbr == "AA" && this.isAgencyUser) continue;

          for (let mem of level.levelMembers) {
            if (
              mem.id != this.offices[this.currentIndex].replaceMember.id &&
              mem.id != -1
            ) {
              ret.push({
                text: mem.name,
                value: mem.id
              });
            }
          }
        }
        return this.sortByName(ret, "text");
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell availableAgents", e);
        return [];
      }
    }
  },
  watch: {
    officeName: function() {
      try {
        this.nameDisplayLenMax = 50;

        let name = this.officeName;

        for (let charCnt = 0; charCnt < name.length; charCnt++) {
          let character = name[charCnt];

          if (character == character.toUpperCase()) {
            this.nameDisplayLenMax -= 1;
          }
        }

        if (this.nameDisplayLenMax < 45) this.nameDisplayLenMax = 45;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell watch officeName", e);
      }
    },
    currentIndex() {
      try {
        this.$nextTick(function() {
          if (!this.offices[this.currentIndex]) return;

          //clear selected agents in transfer pool
          this.offices[this.currentIndex].selectedAgents = [];

          EventBus.$emit(
            "indexChange",
            this.offices[this.currentIndex].levelReports,
            this.offices[this.currentIndex].levels,
            this.offices[this.currentIndex].agentPool,
            this.offices[this.currentIndex].revokedAgents,
            this.currentIndex
          );
        });
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell watch currentIndex", e);
      }
    },
    curLevelReports: {
      deep: true,
      handler() {
        EventBus.$emit("levelReports", this.curLevelReports, this.currentIndex);
      }
    },
    curAgentPool: {
      deep: true,
      handler() {
        EventBus.$emit("agentPool", this.curAgentPool, this.currentIndex);
      }
    },
    curLevels: {
      deep: true,
      handler() {
        EventBus.$emit("levels", this.curLevels, this.currentIndex);
      }
    },
    movingFromSupervisor: function(newVal) {
      this.loadChildAgents(newVal);
    }
  },
  data() {
    return {
      unlockData: {},
      unlockMsgFrom: "",
      unlockMsg: "",
      unlockAOName: "",
      replyMsg: "",
      overrideMsg: "",
      overrideAgentNum: "",
      lockedMsg: "",
      lockedRecordEditedBy: "",
      searchAgent: null,
      overlay: false,
      bulkMoveInProgress: false,
      isMobileVar: false,
      enableDeleteDialog: false,
      hierarchyLoadedTime: null,
      navigate: undefined,
      token: null,
      currentLock: {},
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      offices: [],
      currentIndex: 0,
      selectedOffice: 0,
      COMember: null,
      COLevel: null,
      COParentId: null,
      group: {
        name: "agents",
        pull: false,
        put: false
      },
      officeName: null,
      initialPool: null,
      savePool: null,
      crossOfficeMaxLevel: 1,
      crossOfficeAgents: [],
      AOLevel: 0,
      AALevel: 1,
      ABLevel: 2,
      ABLLevel: 3,
      initFlag: true,
      waitFlag: false,
      editableFlag: false,
      aoRevoked: false,
      revokedLog: [],
      multiSelect: true,
      showSwimLanes: false,
      lastModifiedInDb: null,
      movingFromMemberId: null,
      movingToMemberId: null,
      selectedMember: null,
      showMemberSelect: false,
      movingFromSupervisor: null,
      movingToSupervisor: null,
      movingAgentsPool: [],
      selectedMovingRows: [],
      selectedTableHeaders: [
        {
          text: "Agent Name",
          align: "start",
          sortable: true,
          value: "name"
        }
      ],
      memberToScrollTo: null,
      memberToHighlight: null
    };
  },

  methods: {
    async sendReplyMsg() {
      var input = {
        AOAgentNum: this.unlockData.AOAgentNum,
        Msg: this.replyMsg,
        Editing: true,
        From: this.$store.state.currentUser.agentNum,
        FromName: this.$store.state.currentUser.name,
        To: this.unlockData.From,
        FromSession: this.unlockData.ToSession,
        ToSession: this.unlockData.FromSession
      };

      await API.graphql(
        graphqlOperation(mutations.broadcastUnlock, {
          input: input
        })
      )
        .then(() => {
          this.replyMsg = "";
        })
        .catch(e => {
          this.addToErrorLogs(
            "swimlanes-shell.vue sendReplyMsg broadcastUnlock",
            e
          );
          this.overlay = false;
          this.$modal.show("errorModal");
          return;
        });
    },
    sendUnlockedMsg() {
      this.$store.commit("setBroadcastUnlock", true);
      this.$store.commit("setUnlockedHier", this.$store.state.currentAO.id);

      let self = this;

      API.graphql(
        graphqlOperation(mutations.broadcastUnlock, {
          input: {
            AOAgentNum: this.$store.state.currentAO.id,
            Msg: "The hierarchy is now unlocked.",
            Editing: false,
            From: this.$store.state.currentUser.agentNum,
            FromName: "AMT",
            To: "AMT USER",
            FromSession: this.$store.state.session,
            ToSession:
              this.unlockData != null && this.unlockData.FromSession != null
                ? this.unlockData.FromSession
                : ""
          }
        })
      )
        .then(() => {
          self.currentLock.SessionId = "";
        })
        .catch(e => {
          this.addToErrorLogs("swimlanes-shell submitMsg broadcastUnlock", e);
          this.overlay = false;
          this.$modal.show("errorModal");
          return;
        });
    },
    async submitMsg() {
      let unlockObj = {
        AOAgentNum: this.$store.state.currentAO.id,
        AOName: this.$store.state.currentAO.name
      };

      this.$store.commit("setUnlockMsg", unlockObj);
      let self = this;

      await API.graphql(
        graphqlOperation(mutations.broadcastUnlock, {
          input: {
            AOAgentNum: this.$store.state.currentAO.id,
            Msg: this.lockedMsg,
            Editing: true,
            From: this.$store.state.currentUser.agentNum,
            FromName: this.$store.state.currentUser.name,
            To: this.lockedRecordEditedBy,
            FromSession: this.$store.state.session,
            ToSession: this.currentLock.SessionId
          }
        })
      )
        .then(() => {
          self.lockedMsg = "";
        })
        .catch(e => {
          this.addToErrorLogs("swimlanes-shell submitMsg broadcastUnlock", e);
          this.overlay = false;
          this.$modal.show("errorModal");
          return;
        });
    },
    formatName(lastFirst) {
      if (lastFirst.indexOf(",") < 0) return lastFirst;

      var splitName = lastFirst.split(",");
      var name = splitName[1] + " " + splitName[0];

      return name;
    },
    async getRevokedUsers(aoNum, officeIndex) {
      this.offices[officeIndex].dbRevoked = [];
      await HTTP.get("record", {
        params: { aoNum: aoNum, revokedFlag: true },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(response => {
          if (response.status == 200) {
            if (
              response.data &&
              response.data.Items &&
              response.data.Items.length > 0
            ) {
              this.offices[officeIndex].dbRevoked.push(...response.data.Items);
            }
          } else {
            this.$modal.show("errorModal");
          }
        })
        .catch(e => {
          this.$modal.show("errorModal");
          this.addToErrorLogs("swimlanes-shell getRevokedUsers GET /record", e);
          return [];
        });
    },

    async handleNavigation(leave) {
      if (leave && this.editableFlag == true) {
        let SaveTime = new Date();

        await HTTP.post(
          "locks",
          {
            aoAgentNum: this.$store.state.currentAO.id,
            editedByNum: this.userPrimaryAgentNum,
            editedByName: this.$store.state.currentUser.name,
            locked: false,
            sessionId: this.$store.state.session,
            lastSaveTime: SaveTime
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
          .then(response => {
            if (
              response.status == 200 &&
              response.data.errorMessage == undefined
            ) {
              this.sendUnlockedMsg();

              this.navigate = leave;
              this.$modal.hide("unsavedChangesDialog");
            } else {
              try {
                this.addToErrorLogs(
                  "swimlanes-shell handleNavigation POST /locks",
                  new Error(JSON.stringify(response))
                );
              } catch (e) {
                this.addToErrorLogs(
                  "swimlanes-shell handleNavigation POST /locks",
                  new Error("Response status: " + response.status.toString())
                );
                this.addToErrorLogs(
                  "swimlanes-shell handleNavigation POST /locks",
                  e
                );
              }

              this.navigate = leave;
              this.$modal.hide("unsavedChangesDialog");
            }
          })
          .catch(e => {
            this.addToErrorLogs(
              "swimlanes-shell handleNavigation POST /locks",
              e
            );

            this.navigate = leave;
            this.$modal.hide("unsavedChangesDialog");
          });
      } else {
        this.$modal.hide("unsavedChangesDialog");
      }
    },
    timeOutLoop(counter) {
      if (counter == 10) return false;

      if (this.navigate != undefined) {
        if (this.navigate) return true;
        else return false;
      }

      setTimeout(() => {
        return this.timeOutLoop(counter + 1);
      }, 3000);
    },
    isRevoked(id) {
      try {
        if (
          this.offices[this.currentIndex].revokedAgents.findIndex(
            ra => ra.id == id
          ) >= 0
        ) {
          return true;
        }

        return false;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell isRevoked", e);
        return false;
      }
    },
    addToRevokedLog(node, isRevoked) {
      try {
        if (!node || node.id == -1 || node.name == "Home Office") return;

        let change = {
          id: node.id,
          name: node.name,
          accessRevoked: isRevoked
        };

        let idx = this.revokedLog.findIndex(cl => cl.id == node.id);

        if (idx >= 0) this.revokedLog.splice(idx, 1, change);
        else this.revokedLog.push(change);
      } catch (e) {
        this.addToErrorLogs("addToRevokedLog", e);
      }
    },
    async initialize(reloadForEditing) {
      try {
        this.showSwimLanes = false;
        this.initFlag = true;
        this.offices = [];
        this.currentIndex = 0;

        if (!this.$store.state.currentAO.id) this.$router.push("/hierarchy");

        if (this.$store.state.currentAO && this.$store.state.currentAO.id) {
          let agencies = await API.graphql(
            graphqlOperation(queries.getAgenciesByAONum, {
              aoNum: this.$store.state.currentAO.id,
              company: this.$store.state.currentCompany
            })
          ).catch(e => {
            this.addToErrorLogs(
              "swimlanes-shell initialize getAgenciesByAONum",
              e
            );
            this.$modal.show("errorModal");
            return;
          });

          let offices = agencies.data.getAgenciesByAONum;

          let idx = 0;
          for (let office of offices) {
            // console.log(office);

            this.addOffice(this.$store.state.currentAgency.name);

            this.offices[idx].aoId = office.AOAgentNumPrimary;
            this.offices[idx].name = office.AgencyName;
            this.offices[idx].agencyName = office.AgencyName;
            this.offices[idx].agencyAddress1 = office.AddressLine1;
            this.offices[idx].agencyAddress2 = office.AddressLine2;
            this.offices[idx].agencyCity = office.City;
            this.offices[idx].agencyState = office.StateProvinceCode;
            this.offices[idx].agencyZip = office.PostalCode;
            this.offices[idx].agencyPhone = office.AreaCode + office.PhoneNum;
            this.offices[idx].agencyPhoneExt = office.PhoneExtensionNum;
            this.offices[idx].agencyCountry = office.CountryName;
            this.offices[idx].agencyEmail = office.Email;
            this.offices[idx].agencyCode = office.AgencyCode;
            this.offices[idx].companyId = office.GLCompanyID;
            this.offices[idx].countryId = office.GLCountryID;
            this.offices[idx].phoneTypeId = office.GLPhoneTypeID;
            this.offices[idx].addressTypeId = office.GLAddressTypeID;
            this.offices[idx].agencyId = office.EntAgencyID;
            this.offices[idx].primaryAgencyInd = office.PrimaryAgencyInd;

            if (this.offices[idx].agencyPhone == "0") {
              this.offices[idx].agencyPhone = "";
            }

            await this.getEmployees(idx, true);

            this.initFlag = false;
            this.currentIndex = idx;

            idx++;
          }

          if (idx > 1) {
            this.$nextTick(function() {
              this.currentIndex = 0;
            });
          } else {
            this.$nextTick(function() {
              EventBus.$emit(
                "indexChange",
                this.offices[this.currentIndex].levelReports,
                this.offices[this.currentIndex].levels,
                this.offices[this.currentIndex].agentPool,
                this.offices[this.currentIndex].revokedAgents,
                this.currentIndex
              );
            });
          }

          this.$nextTick(function() {
            for (let idx = 0; idx < this.offices.length; idx++) {
              for (let level of this.offices[idx].levels) {
                for (let member of level.levelMembers) {
                  if (member.parentId != null && member.parentId != member.id) {
                    let parent = this.findInHierarchyMultiOffice(
                      member.parentId,
                      idx
                    );

                    if (parent) {
                      let parentLevel = this.findLevelMultiOffice(
                        parent.id,
                        idx
                      );

                      this.addConnector(
                        {
                          level: parentLevel.levelOrder,
                          member: parent
                        },
                        { level: level.levelOrder, member: member },
                        idx
                      );
                    }
                  }
                }
              }
            }

            if (!this.isEditUser) {
              this.$modal.show("readOnlyModal");
            } else {
              if (reloadForEditing == true) {
                EventBus.$emit("editPushed", this.currentIndex);
              }
            }
          });
          this.showSwimLanes = true;
        }
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell initialize", e);
      }
    },
    renameOffice() {
      try {
        this.$modal.hide("renameOfficeDialog");
        this.offices[this.currentIndex].name = this.officeName;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell renameOffice", e);
      }
    },
    recalculateWindowHeight() {
      this.windowHeight = window.innerHeight;
    },
    recalculateWindowWidth() {
      try {
        this.windowWidth = window.innerWidth;
        this.recalculateConnectors();
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell recalculateWindowWidth", e);
      }
    },
    async createOffice() {
      try {
        let rememberSearchAgent = this.searchAgent;

        let previousIndex = this.currentIndex;
        let currentAO = this.offices[this.currentIndex].levels[0]
          .levelMembers[0];

        this.$modal.hide("addNewOfficeDialog");

        let member = this.COMember;
        let level = this.COLevel;
        let parentId = this.COParentId;

        this.COMember = null;
        this.COLevel = null;
        this.COParentId = null;

        this.addOffice(
          this.officeName == ""
            ? currentAO.name + " Agency " + (this.offices.length + 1).toString()
            : this.officeName
        );

        member.parentId = parentId;

        let parent = this.findInHierarchy(parentId);

        let addToNewOffice = [];

        addToNewOffice = this.removeHierarchyCurrentOffice(
          member,
          parent,
          level.levelOrder,
          previousIndex
        );

        this.recalculateConnectors();

        if (this.offices.length > 1) {
          let currentAgency = {
            aoId: this.offices[this.currentIndex].aoId,
            id: this.offices[this.currentIndex].officeId,
            name:
              this.officeName == ""
                ? currentAO.name +
                  " Agency " +
                  (this.offices.length + 1).toString()
                : this.officeName,
            agencyName:
              this.officeName == ""
                ? currentAO.name +
                  " Agency " +
                  (this.offices.length + 1).toString()
                : this.officeName,
            address1: this.offices[this.currentIndex].agencyAddress1,
            address2: this.offices[this.currentIndex].agencyAddress2,
            city: this.offices[this.currentIndex].agencyCity,
            state: this.offices[this.currentIndex].agencyState,
            zip: this.offices[this.currentIndex].agencyZip,
            country: this.offices[this.currentIndex].agencyCountry,
            phone: this.offices[this.currentIndex].agencyPhone,
            phoneExt: this.offices[this.currentIndex].agencyPhoneExt,
            email: this.offices[this.currentIndex].agencyEmail,
            agencyCode: null,
            companyId: this.offices[this.currentIndex].companyId,
            countryId: this.offices[this.currentIndex].countryId,
            phoneTypeId: this.offices[this.currentIndex].phoneTypeId,
            addressTypeId: this.offices[this.currentIndex].addressTypeId,
            agencyId: this.offices[this.currentIndex].agencyId,
            primaryAgencyInd: this.offices[this.currentIndex].primaryAgencyInd
          };

          this.$store.commit("setAgency", currentAgency);
        }

        this.currentIndex = this.offices.length - 1;

        this.offices[
          this.currentIndex
        ].name = this.$store.state.currentAgency.name;
        this.offices[
          this.currentIndex
        ].agencyAddress1 = this.$store.state.currentAgency.address1;
        this.offices[
          this.currentIndex
        ].agencyAddress2 = this.$store.state.currentAgency.address2;
        this.offices[
          this.currentIndex
        ].agencyCity = this.$store.state.currentAgency.city;
        this.offices[
          this.currentIndex
        ].agencyState = this.$store.state.currentAgency.state;
        this.offices[
          this.currentIndex
        ].agencyZip = this.$store.state.currentAgency.zip;
        this.offices[
          this.currentIndex
        ].agencyPhone = this.$store.state.currentAgency.phone;
        this.offices[
          this.currentIndex
        ].agencyPhoneExt = this.$store.state.currentAgency.phoneExt;
        this.offices[
          this.currentIndex
        ].agencyCountry = this.$store.state.currentAgency.country;
        this.offices[
          this.currentIndex
        ].agencyEmail = this.$store.state.currentAgency.email;
        this.offices[this.currentIndex].agencyCode = null;
        this.offices[
          this.currentIndex
        ].companyId = this.$store.state.currentAgency.companyId;
        this.offices[
          this.currentIndex
        ].countryId = this.$store.state.currentAgency.countryId;
        this.offices[
          this.currentIndex
        ].phoneTypeId = this.$store.state.currentAgency.phoneTypeId;
        this.offices[
          this.currentIndex
        ].addressTypeId = this.$store.state.currentAgency.addressTypeId;
        this.offices[
          this.currentIndex
        ].agencyId = this.$store.state.currentAgency.agencyId;
        this.offices[this.currentIndex].primaryAgencyInd = false;

        this.offices[
          this.currentIndex
        ].aoId = this.$store.state.currentAgency.aoId;

        await this.getEmployees(this.currentIndex, false);

        let AO = this.offices[this.currentIndex].levels[0].levelMembers[0];
        if (!AO || AO.id != currentAO) {
          this.offices[this.currentIndex].levels[0].levelMembers = [];
          this.offices[this.currentIndex].levels[0].levelMembers.push(
            currentAO
          );

          this.addToChangeLogMultiOffice(
            currentAO,
            currentAO,
            this.offices[this.currentIndex].levels[0],
            false,
            this.currentIndex
          );
        }

        for (let addition of addToNewOffice) {
          let newParent = this.findInHierarchy(addition.member.parentId);
          if (!newParent || !newParent.id) {
            if (addition.levelOrder == 2) {
              // moving Agency Builder and new parent missing
              // report to AO of office

              newParent = this.offices[this.currentIndex].levels[0]
                .levelMembers[0];
            }
          }

          if (newParent) {
            this.copyNodeToHier(
              addition.member,
              newParent,
              addition.levelOrder
            );
          }
        }

        for (let addition of addToNewOffice) {
          // remove Agency Builder and his/her hierarchy from the other agent pools
          this.removeFromOtherAgentPools(addition.member.id);
        }

        // Agency Administrators Copy Marker

        for (let AA of this.offices[previousIndex].levels[this.AALevel]
          .levelMembers) {
          let found = this.findInHierarchy(AA.id);

          if (!found)
            this.copyNodeToHier(
              AA,
              this.offices[this.currentIndex].levels[0].levelMembers[0],
              this.AALevel
            );
        }

        for (let revoked of this.offices[previousIndex].revokedAgents) {
          this.copyToRevoked(revoked);
        }

        //copy agent pool
        for (let agent of this.offices[previousIndex].agentPool) {
          this.copyToUnassigned(agent);
        }

        this.$nextTick(function() {
          for (let idx = 0; idx < this.offices.length; idx++) {
            for (let level of this.offices[idx].levels) {
              for (let member of level.levelMembers) {
                if (member.parentId != null && member.parentId != member.id) {
                  let parent = this.findInHierarchyMultiOffice(
                    member.parentId,
                    idx
                  );
                  let parentLevel = this.findLevelMultiOffice(parent.id, idx);

                  this.addConnector(
                    {
                      level: parentLevel.levelOrder,
                      member: parent
                    },
                    { level: level.levelOrder, member: member },
                    idx
                  );
                }
              }
            }
          }
        });

        if (
          rememberSearchAgent &&
          this.findLevelMultiOffice(rememberSearchAgent.id, this.currentIndex)
        ) {
          this.searchAgent = rememberSearchAgent;

          this.$nextTick().then(() => {
            this.memberToHighlight = null;
            this.$nextTick().then(() => {
              this.memberToHighlight = this.searchAgent;
            });
          });
        }
      } catch (e) {
        this.$modal.show("errorModal");
        this.addToErrorLogs("swimlanes-shell createOffice", e);
      }
    },
    addOffice(officeName) {
      try {
        let newOffice = {
          revokedAgents: [],
          restoreMember: null,
          name: officeName,
          nameDisplayLenMax: officeName ? officeName.length : 0,
          officeId: this.PseudoGuid(),
          aoId: this.$store.state.currentAO.id,
          agentLevel: 4,
          currentMoveSupervisor: null,
          selectedMoveSupervisor: null,
          selectedSupervisor: null,
          agentsToAdd: [],
          selectedAgents: [],
          agencyName: null,
          agencyCode: null,
          agencyAddress1: null,
          agencyAddress2: null,
          agencyCity: null,
          agencyState: null,
          agencyZip: null,
          agencyCountry: null,
          agencyPhone: null,
          agencyPhoneExt: null,
          agencyEmail: null,
          addressDialog: false,
          companyId: null,
          countryId: null,
          phoneTypeId: null,
          addressTypeId: null,
          primaryAgencyInd: null,
          // editableFlag: false,
          moveHierFlag: false,
          maxLevel: 4,
          levelSelectionDialog: false,
          source: null,
          target: null,
          selectedLevel: null,
          detailsLevel: null,
          deleteMember: null,
          detailsMember: null,
          replaceAO: false,
          replaceLevel: null,
          replaceMember: null,
          selectedReplacement: null,
          connectorColors: [
            "#9174a1",
            "#74a177",
            "#FFBD33",
            "#4682b4",
            "#a1747b"
          ],

          agentPool: [],
          connectors: [],
          isMounted: false,
          levelReports: [],
          changeLog: [],
          levels: [
            {
              levelColor: "#e8e8e8",
              levelOrder: 0,
              levelName: "AGENCY OWNER",
              description: "Agency Owner",
              abbr: "AO",
              descriptionDetails: [
                "Will have the ability to assign and view leads within their Agency.",
                "Will have permission to assign Agency Builder (AB), Agency Builder Limited (ABL), and Agents their roles and rights in Salesforce.",
                "Will have access to all reporting on Sales Professional Home via FHLConnect.",
                "Will need to submit a FHD Agency Administrator Change Request Form to the Sr. Director of Sales Technology in order to make any changes to the Administrator role in AMT."
              ],
              levelMembers: []
            },
            {
              levelColor: "lightgrey",
              levelOrder: 1,
              levelName: "AGENCY ADMINISTRATOR",
              description: "Agency Administrator",
              abbr: "AA",
              descriptionDetails: [
                "If CRM Agency Administrator (AA), will have ability to assign and view leads within their Agency.",
                "If CRM Agency Administrator (AA), will have ability to assign Agency Builder (AB), Agency Builder Limited (ABL), and Agents their roles and rights in Salesforce.",
                "If Administrator only (non-CRM) for Two-Factor Authentication purposes, will have access to all reporting except Financials on Sales Professional Home via FHLConnect. Would not have access to Salesforce or Data Axle.",
                "Can be both CRM Administrator (AA) and Administrator for Agency (non-CRM)."
              ],
              levelMembers: []
            },
            {
              levelColor: "#e8e8e8",
              levelOrder: 2,
              levelName: "AGENCY BUILDER",
              description: "Agency Builder",
              abbr: "AB",
              descriptionDetails: [
                "Will have ability to assign and view leads of Agents under their AMT Leads Hierarchy, assigned to them by AO/AA.",
                "Does not reflect commission structure, overrides, or FHD Career Track."
              ],
              levelMembers: []
            },
            {
              levelColor: "lightgrey",
              levelOrder: 3,
              levelName: "AGENCY BUILDER LIMITED",
              description: "Agency Builder Limited",
              abbr: "ABL",
              descriptionDetails: [
                "Will have ability to assign and view leads of Agents under their AMT Leads Hierarchy, assigned to them by AO/AA.",
                "Does not reflect commission structure, overrides, or FHD Career Track."
              ],
              levelMembers: []
            },
            {
              levelColor: "lightgrey", // "#e8e8e8",
              levelOrder: 4,
              levelName: "AGENT",
              description: "Agent",
              abbr: "Agt",
              descriptionDetails: [
                "Will have ability to view and work leads assigned to them by their AO/AA/AB/ABL."
              ],

              levelMembers: []
            }
          ]
        };

        this.offices.push(newOffice);
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell addOffice", e);
      }
    },
    moveAgents_Old() {
      this.$modal.show("moveAgentsDialog");
    },
    selectAll() {
      for (let i = 0; i < this.sortedAgentPool.length; i++) {
        if (this.offices[this.currentIndex].selectedAgents.indexOf(i) < 0) {
          this.offices[this.currentIndex].selectedAgents.push(i);
        }
      }
    },
    moveAgents() {
      EventBus.$emit("moveSelected", null);
    },
    moveTransferPoolAgents() {
      let memberInfo = {};
      memberInfo.selectedSupervisor = {
        text: "Agency Transfer Pool",
        value: "-100"
      };
      memberInfo.selectedAgents = this.offices[
        this.currentIndex
      ].selectedAgents;
      EventBus.$emit("moveSelected", memberInfo);
    },
    loadChildAgents(supervisorId) {
      this.movingAgentsPool = [];
      this.selectedMovingRows = [];
      let agentsToMove = [];
      //From Agency Transfer Pool, load from currentIndex.selectedAgents
      if (supervisorId == -100) {
        for (let idx of this.offices[this.currentIndex].selectedAgents) {
          agentsToMove.push(this.sortedAgentPool[idx]);
        }
        this.movingAgentsPool = agentsToMove;
        return;
      }
      //From Supervisor
      for (let level of this.offices[this.currentIndex].levels) {
        if (level.levelOrder == this.offices[this.currentIndex].agentLevel) {
          for (let member of level.levelMembers) {
            if (member.parentId == supervisorId) {
              agentsToMove.push(member);
            }
          }
        }
      }
      this.movingAgentsPool = agentsToMove;
    },
    listClick(e) {
      try {
        this.$refs.assignmentPool.$el.focus();

        if (e.shiftKey) {
          let id;

          try {
            // id = e.path[1].id.split('_')[1];
            id = e.target.id.split("_")[1];
          } catch {
            id = null;
          }

          if (id) {
            let idx = this.sortedAgentPool.findIndex(a => a.id == id);

            if (idx >= 0) {
              let closestValue = 0;

              for (let sel of this.offices[this.currentIndex].selectedAgents) {
                if (sel > closestValue && sel < idx) {
                  closestValue = sel;
                }
              }

              for (let i = closestValue; i < idx; i++) {
                if (
                  this.offices[this.currentIndex].selectedAgents.indexOf(i) < 0
                )
                  this.offices[this.currentIndex].selectedAgents.push(i);
              }
            }
          }
        }
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell listClick", e);
      }
    },
    findOffset(levelOrder, numMembers) {
      try {
        let style = "";

        if (levelOrder == 0) return "";

        if (levelOrder % 2 == 0) style = "margin-left:";
        else style = "margin-right:";

        if (numMembers > 1) {
          let offset = 10 + levelOrder * 2;

          return style + offset.toString() + "px;";
        }

        let offset = levelOrder * 75 + levelOrder * 55;

        if (levelOrder < 3) offset -= 100;

        if (offset < 10) offset = 10;

        style += offset.toString() + "px;";

        return style;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell findOffset", e);
        return "";
      }
    },
    findOfficeIndex(searchAgent) {
      if (searchAgent == null) return this.currentIndex;

      let idx = 0;

      if (this.findLevelMultiOffice(searchAgent.id, this.currentIndex) != null)
        return this.currentIndex;

      for (let office of this.offices) {
        let level = this.findLevelMultiOffice(searchAgent.id, idx);

        if (office != null && level != null) {
          return idx;
        }

        idx++;
      }

      return this.currentIndex;
    },
    navigateToAgent(member) {
      this.memberToScrollTo = member;
      this.memberToHighlight = member;
    },
    handleSearchBoxAction(data) {
      if (!data.agent) {
        this.searchAgent = null;
        this.memberToScrollTo = null;
        this.memberToHighlight = null;
        return;
      }

      this.searchAgent = data.agent.memberInfo;

      let memberOfficeIndex = this.findOfficeIndex(data.agent.memberInfo);

      if (memberOfficeIndex != this.currentIndex) {
        this.currentIndex = memberOfficeIndex;
      }

      this.$nextTick().then(() => {
        let memberInfo = data.agent.memberInfo;
        let action = data.action.toLowerCase();
        let level = this.findLevel(data.agent.value);

        if (action == "navigate") {
          // trigger change
          this.navigateToAgent(null);
          this.$nextTick().then(() => {
            this.navigateToAgent(memberInfo);
          });
        } else {
          this.navigateToAgent(memberInfo);
        }
        switch (action) {
          case "getdetails":
            this.getDetails(memberInfo, level);
            break;
          case "checkfordelete":
            this.checkForDelete(memberInfo);
            break;
          case "checkforrevoke":
            this.checkForRevokeAccess(memberInfo);
            break;
          case "replaceposition":
            this.replacePosition(memberInfo, level);
            break;
          case "restorememberaccess":
            this.checkForRestoreAccess(memberInfo);
            break;
          case "movemember":
            this.moveMember(memberInfo);
            break;
          case "createoffice":
            EventBus.$emit(
              "createOffice",
              memberInfo,
              memberInfo.parentId,
              level
            );
            break;
        }
      });
    },
    moveMember(member) {
      this.handleMoveMember(member);
    },
    handleMoveMember(member) {
      this.selectedMember = member;
      this.movingFromMemberId = member ? member.id : null;
      this.showMemberSelect = !member;
      this.$modal.show("moveMemberDialog");
    },
    handleMoveSelected(memberInfo) {
      this.movingFromSupervisor = null;
      this.movingToSupervisor = null;
      if (memberInfo) {
        this.movingFromSupervisor = memberInfo.selectedSupervisor.value;
        if (this.movingFromSupervisor == -100) {
          //reload data, watcher delay
          this.loadChildAgents(this.movingFromSupervisor);
        }
      }
      this.$modal.show("moveSelectedDialog");
    },
    tryMoveMember() {
      this.$modal.hide("moveMemberDialog");
      if (!this.movingFromMemberId || !this.movingToMemberId) return;
      let sourceId = this.movingFromMemberId;
      let targetId = this.movingToMemberId;
      if (sourceId == targetId) return;

      this.handleDragEnd(sourceId, targetId);
      this.selectedMember = null;
      this.movingFromMemberId = null;
      this.movingToMemberId = null;
    },
    moveSelectedToSupervisor() {
      if (
        this.$refs.moveSelectedForm &&
        !this.$refs.moveSelectedForm.validate()
      )
        return;
      if (
        this.movingFromSupervisor != -100 &&
        this.selectedMovingRows.length == 0
      )
        return;
      this.bulkMoveInProgress = true;
      EventBus.$emit("bulkMoveInProgress", this.bulkMoveInProgress);

      this.waitFlag = true;

      //From Agency Transfer Pool to supervisor
      if (this.movingFromSupervisor == -100) {
        let firstAgent = this.movingAgentsPool[0];
        this.handleDragEnd(firstAgent.id, this.movingToSupervisor);
      }

      //From supervisor to other supervisor or transfer pool
      if (this.movingFromSupervisor != -100) {
        //To transfer pool
        if (this.movingToSupervisor == -100) {
          for (let agent of this.selectedMovingRows) {
            this.moveToUnassigned(agent);
          }
        }
        //To other supervisor
        if (this.movingToSupervisor != -100) {
          //find supervisor
          let supe = null;
          for (let level of this.offices[this.currentIndex].levels) {
            for (let member of level.levelMembers) {
              if (member.id == this.movingToSupervisor) {
                supe = member;
              }
            }
          }
          for (let agent of this.selectedMovingRows) {
            // move will be logged in moveSourceToTarget
            this.moveSourceToTarget(
              agent,
              supe,
              this.offices[this.currentIndex].agentLevel
            );
          }
        }
      }

      this.bulkMoveInProgress = false;
      EventBus.$emit("bulkMoveInProgress", this.bulkMoveInProgress);
      this.$modal.hide("moveSelectedDialog");
      this.waitFlag = false;
    },
    moveAgentsToSelectedSupervisor() {
      try {
        if (this.$refs.moveAgentsForm && !this.$refs.moveAgentsForm.validate())
          return;

        this.$modal.hide("moveAgentsDialog");

        this.$nextTick(() => {
          this.bulkMoveInProgress = true;
          this.waitFlag = true;
          let unassign = false;

          let supe = null;

          if (this.offices[this.currentIndex].selectedMoveSupervisor != -100) {
            for (let level of this.offices[this.currentIndex].levels) {
              for (let member of level.levelMembers) {
                if (
                  member.id ==
                  this.offices[this.currentIndex].selectedMoveSupervisor
                ) {
                  supe = member;
                }
              }
            }
          } else {
            unassign = true;
          }

          let agentsToMove = [];

          for (let level of this.offices[this.currentIndex].levels) {
            if (
              level.levelOrder == this.offices[this.currentIndex].agentLevel
            ) {
              for (let member of level.levelMembers) {
                if (
                  member.parentId ==
                  this.offices[this.currentIndex].currentMoveSupervisor
                ) {
                  agentsToMove.push(member);
                }
              }
            }
          }

          for (let agent of agentsToMove) {
            if (supe) {
              // move will be logged in moveSourceToTarget
              this.moveSourceToTarget(
                agent,
                supe,
                this.offices[this.currentIndex].agentLevel
              );
            } else if (unassign) {
              this.moveToUnassigned(agent);
            }
          }

          if (this.$refs.moveAgentsForm) this.$refs.moveAgentsForm.reset();
          this.waitFlag = false;
          this.bulkMoveInProgress = false;
        });
      } catch (e) {
        this.addToErrorLogs(
          "swimlanes-shell moveAgentsToSelectedSupervisor",
          e
        );
      }
    },
    addAgentsToSelectedSupervisor() {
      try {
        let supe = null;

        if (!this.$refs.addAgentsForm.validate()) return;

        this.$modal.hide("addAgentsDialog");
        this.waitFlag = true;

        for (let level of this.offices[this.currentIndex].levels) {
          for (let member of level.levelMembers) {
            if (
              member.id == this.offices[this.currentIndex].selectedSupervisor
            ) {
              supe = member;
            }
          }
        }

        this.crossOfficeAgents = [];
        for (let agent of this.offices[this.currentIndex].agentsToAdd) {
          if (this.isInCrossOfficeRole(agent.id)) {
            this.crossOfficeAgents.push(agent.name);
          } else {
            if (supe) {
              // move will be logged in moveSourceToTarget
              this.moveSourceToTarget(
                agent,
                supe,
                this.offices[this.currentIndex].agentLevel
              );
            }
          }
        }
        if (this.crossOfficeAgents.length)
          this.$modal.show("crossOfficeMaxLevelExceeded");

        this.offices[this.currentIndex].selectedAgents = [];
        this.offices[this.currentIndex].agentsToAdd = [];
        this.waitFlag = false;
      } catch (e) {
        this.waitFlag = false;
        this.$modal.show("errorModal");
        this.addToErrorLogs("swimlanes-shell addAgentsToSelectedSupervisor", e);
      }
    },
    addAgents() {
      try {
        for (let idx of this.offices[this.currentIndex].selectedAgents) {
          this.offices[this.currentIndex].agentsToAdd.push(
            this.sortedAgentPool[idx]
          );
        }

        if (this.offices[this.currentIndex].agentsToAdd.length)
          this.$modal.show("addAgentsDialog");
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell addAgents", e);
      }
    },
    async overrideLock() {
      try {
        this.$modal.hide("overrideSelfLockModal");
        this.$modal.hide("overrideLockDialog");
        this.waitFlag = true;

        EventBus.$emit("overridePushed", this.$store.state.currentAO.id);

        await API.graphql(
          graphqlOperation(mutations.broadcastUnlock, {
            input: {
              AOAgentNum: this.$store.state.currentAO.id,
              Msg:
                "Your edit lock on " +
                this.$store.state.currentAO.name +
                "'s hierarchy has been overriden by " +
                this.$store.state.currentUser.name +
                ".",
              Editing: true,
              From: this.$store.state.currentUser.agentNum,
              FromName: "OVERRIDE",
              To: this.currentLock.EditedByAgentNum,
              FromSession: this.$store.state.session,
              ToSession: this.currentLock.SessionId
            }
          })
        ).catch(e => {
          this.addToErrorLogs(
            "swimlanes-shell overrideLock broadcastUnlock",
            e
          );
          this.overlay = false;
          this.$modal.show("errorModal");
          return;
        });

        HTTP.post(
          "locks",
          {
            aoAgentNum: this.$store.state.currentAO.id,
            editedByNum: this.userPrimaryAgentNum,
            editedByName: this.$store.state.currentUser.name,
            locked: true,
            sessionId: this.$store.state.session
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
          .then(async response => {
            if (
              response.status == 200 &&
              response.data.errorMessage == undefined
            ) {
              this.waitFlag = false;
              await this.reloadForEdit();
              this.$modal.show("editLock");
              this.editableFlag = true;
            } else {
              this.waitFlag = false;
              this.$modal.show("errorModal");

              try {
                this.addToErrorLogs(
                  "swimlanes-shell overrideLock POST /locks",
                  new Error(JSON.stringify(response))
                );
              } catch (e) {
                this.addToErrorLogs(
                  "swimlanes-shell overrideLock POST /locks",
                  new Error("Response status: " + response.status.toString())
                );
                this.addToErrorLogs(
                  "swimlanes-shell overrideLock POST /locks",
                  e
                );
              }
            }
          })
          .catch(e => {
            this.waitFlag = false;
            this.$modal.show("errorModal");
            this.addToErrorLogs("swimlanes-shell overrideLock POST /locks", e);
          });
      } catch (e) {
        this.waitFlag = false;
        this.addToErrorLogs("swimlanes-shell overrideLock", e);
      }
    },
    edit() {
      try {
        this.waitFlag = true;

        HTTP.get("locks", {
          params: {
            AOAgentNum: this.$store.state.currentAO.id
          },
          headers: {
            "Content-Type": "application/json"
          }
        })
          .then(async response => {
            if (
              response.status == 200 &&
              response.data.errorMessage == undefined
            ) {
              if (
                response.data &&
                response.data.Items &&
                response.data.Items.length
              ) {
                let lockRecord = response.data.Items[0];

                if (lockRecord.IsLocked) {
                  this.lockedRecordEditedBy = lockRecord.EditedByAgentNum;

                  if (lockRecord.EditedByAgentNum != this.userPrimaryAgentNum) {
                    this.currentLock = lockRecord;
                    this.waitFlag = false;

                    // if (
                    //   this.offices[this.currentIndex].aoId ==
                    //     this.userPrimaryAgentNum ||
                    //   !this.isAgencyUser
                    // ) {
                    //   this.$nextTick(function() {
                    //     this.$modal.show("overrideLockDialog");
                    //   });
                    // } else {
                    //   this.$nextTick(function() {
                    //     this.$modal.show("editingLockedDialog");
                    //     EventBus.$emit("editPushed", this.currentIndex);
                    //   });
                    // }

                    this.$nextTick(function() {
                      this.$modal.show("overrideLockDialog");
                    });

                    return;
                  }

                  if (
                    lockRecord.SessionId &&
                    lockRecord.SessionId != this.$store.state.session
                  ) {
                    this.currentLock = lockRecord;
                    this.waitFlag = false;
                    this.$nextTick(function() {
                      this.$modal.show("overrideSelfLockModal");
                    });
                    return;
                  }
                }

                let skipDialog = false;

                if (lockRecord) {
                  let today = new Date();
                  let todayMMDDYY = this.$options.filters.mmddyyyy(today);

                  let compDate = lockRecord.EditStartDateTime;
                  let compDateMMDDYY = this.$options.filters.mmddyyyy(compDate);

                  if (
                    lockRecord.EditedByAgentNum == this.userPrimaryAgentNum &&
                    todayMMDDYY == compDateMMDDYY
                  ) {
                    skipDialog = true;
                  }
                  //   if (
                  //     !lockRecord.IsLocked &&
                  //     lockRecord.EditedByAgentNum == this.userPrimaryAgentNum &&
                  //     todayMMDDYY == compDateMMDDYY
                  //   ) {
                  //     await this.reloadForEdit();
                  //   } else if (lockRecord.LastSaveTime) {
                  //     let lastSaveTime = new Date(lockRecord.LastSaveTime);

                  //     if (lastSaveTime > this.hierarchyLoadedTime) {
                  //       await this.reloadForEdit();
                  //     }
                  //   }
                }

                HTTP.post(
                  "locks",
                  {
                    aoAgentNum: this.$store.state.currentAO.id,
                    editedByNum: this.userPrimaryAgentNum,
                    editedByName: this.$store.state.currentUser.name,
                    locked: true,
                    sessionId: this.$store.state.session
                  },
                  {
                    headers: {
                      "Content-Type": "application/json"
                    }
                  }
                )
                  .then(async response => {
                    if (
                      response.status == 200 &&
                      response.data.errorMessage == undefined
                    ) {
                      this.waitFlag = false;
                      await this.reloadForEdit();
                      if (!skipDialog) {
                        this.$modal.show("editLock");
                      }
                      this.editableFlag = true;
                    } else {
                      this.waitFlag = false;
                      this.$modal.show("errorModal");

                      try {
                        this.addToErrorLogs(
                          "swimlanes-shell edit POST /locks",
                          new Error(JSON.stringify(response))
                        );
                      } catch (e) {
                        this.addToErrorLogs(
                          "swimlanes-shell edit POST /locks",
                          new Error(
                            "Response status: " + response.status.toString()
                          )
                        );
                        this.addToErrorLogs(
                          "swimlanes-shell edit POST /locks",
                          e
                        );
                      }
                    }
                  })
                  .catch(e => {
                    this.waitFlag = false;
                    this.$modal.show("errorModal");
                    this.addToErrorLogs("swimlanes-shell edit POST /locks", e);
                  });
              } else {
                HTTP.post(
                  "locks",
                  {
                    aoAgentNum: this.$store.state.currentAO.id,
                    editedByNum: this.userPrimaryAgentNum,
                    editedByName: this.$store.state.currentUser.name,
                    locked: true,
                    sessionId: this.$store.state.session
                  },
                  {
                    headers: {
                      "Content-Type": "application/json"
                    }
                  }
                )
                  .then(async response => {
                    if (
                      response.status == 200 &&
                      response.data.errorMessage == undefined
                    ) {
                      this.waitFlag = false;
                      await this.reloadForEdit();
                      this.$modal.show("editLock");
                      this.editableFlag = true;
                    } else {
                      this.waitFlag = false;
                      this.$modal.show("errorModal");

                      try {
                        this.addToErrorLogs(
                          "swimlanes-shell edit POST /locks",
                          new Error(JSON.stringify(response))
                        );
                      } catch (e) {
                        this.addToErrorLogs(
                          "swimlanes-shell edit POST /locks",
                          new Error(
                            "Response status: " + response.status.toString()
                          )
                        );
                        this.addToErrorLogs(
                          "swimlanes-shell edit POST /locks",
                          e
                        );
                      }
                    }
                  })
                  .catch(e => {
                    this.waitFlag = false;
                    this.$modal.show("errorModal");
                    this.addToErrorLogs("swimlanes-shell edit POST /locks", e);
                  });
              }
            } else {
              this.waitFlag = false;
              this.$modal.show("errorModal");

              try {
                this.addToErrorLogs(
                  "swimlanes-shell edit GET /locks",
                  new Error(JSON.stringify(response))
                );
              } catch (e) {
                this.addToErrorLogs(
                  "swimlanes-shell edit GET /locks",
                  new Error("Response status: " + response.status.toString())
                );
                this.addToErrorLogs("swimlanes-shell edit GET /locks", e);
              }
            }
          })
          .catch(e => {
            this.waitFlag = false;
            this.$modal.show("errorModal");
            this.addToErrorLogs("swimlanes-shell edit GET /locks", e);
          });
      } catch (e) {
        this.waitFlag = false;
        this.$modal.show("errorModal");
        this.addToErrorLogs("swimlanes-shell edit", e);
      }
    },
    save() {
      this.overlay = true;
      let unassignedAgents = false;

      for (let idx = 0; idx < this.offices.length; idx++) {
        if (this.offices[idx].agentPool.length > 0) unassignedAgents = true;
      }

      if (unassignedAgents) {
        this.overlay = false;
        this.$modal.show("cannotSaveModal");
        return;
      }

      try {
        HTTP.get("locks", {
          params: {
            AOAgentNum: this.$store.state.currentAO.id
          },
          headers: {
            "Content-Type": "application/json"
          }
        })
          .then(async response => {
            if (
              response.data &&
              response.data.Items &&
              response.data.Items.length
            ) {
              let lockRecord = response.data.Items[0];

              if (lockRecord.IsLocked) {
                if (lockRecord.EditedByAgentNum != this.userPrimaryAgentNum) {
                  this.currentLock = lockRecord;
                  this.overlay = false;
                  this.$modal.show("lockWasOverriden");
                  return;
                }

                if (
                  lockRecord.SessionId &&
                  lockRecord.SessionId != this.$store.state.session
                ) {
                  this.currentLock = lockRecord;
                  this.overlay = false;
                  this.$modal.show("selfLockWasOverriden");
                  return;
                }
              } else {
                this.overlay = false;
                this.$modal.show("lockWasInvalidated");
                return;
              }
            }

            // Check last save time:

            let lastModified = await API.graphql(
              graphqlOperation(queries.getLastModified, {
                aoNum: this.offices[this.currentIndex].aoId
              })
            ).catch(e => {
              this.addToErrorLogs("swimlanes-shell save getLastModified", e);
              this.overlay = false;
              this.$modal.show("errorModal");
              return;
            });

            let lastModDate = new Date(lastModified.data.getLastModified);

            if (lastModDate.getTime() > this.hierarchyLoadedTime.getTime()) {
              this.lastModifiedInDb = lastModDate;
              this.overlay = false;
              this.$modal.show("saveError");
              return;
            }

            for (let index = 0; index < this.offices.length; index++) {
              let agency = this.offices[index];
              if (
                agency.agencyCode == null ||
                agency.agencyCode == undefined ||
                agency.agencyCode == ""
              ) {
                // console.log("saving agency");
                // console.log(agency);

                let OtherAgencies = [];

                if (agency.PrimaryAgencyInd == true) {
                  let AOsAgencies = await API.graphql(
                    graphqlOperation(queries.getAgenciesByAONum, {
                      aoNum: agency.aoId,
                      company: this.$store.state.currentCompany
                    })
                  ).catch(e => {
                    this.addToErrorLogs(
                      "swimlanes-shell getAgenciesByAONum",
                      e
                    );
                  });

                  if (AOsAgencies.data.getAgenciesByAONum.length) {
                    OtherAgencies = AOsAgencies.data.getAgenciesByAONum;
                  }
                }

                let agencyInput = {
                  CompanyID: agency.companyId,
                  AOAgentNumPrimary: agency.aoId,
                  Name: agency.name,
                  Email: agency.agencyEmail,
                  CreatedBy:
                    "AMT: " +
                    this.$store.state.currentUser.name +
                    " (" +
                    this.$store.state.currentUser.agentNum +
                    ")",
                  AgencyCode: null,
                  AddressTypeID: agency.addressTypeId,
                  AddressLine1: agency.agencyAddress1,
                  AddressLine2: agency.agencyAddress2,
                  City: agency.agencyCity,
                  StateProvinceCode: agency.agencyState,
                  PostalCode: agency.agencyZip,
                  GLCountryID: agency.countryId,
                  GLPhoneTypeID: agency.phoneTypeId,
                  AreaCode:
                    agency.agencyPhone.length == 10
                      ? agency.agencyPhone.substr(0, 3)
                      : "",
                  PhoneNum:
                    agency.agencyPhone.length == 10
                      ? agency.agencyPhone.substr(3)
                      : agency.agencyPhone,
                  PhoneExtensionNum: agency.agencyPhoneExt,
                  PrimaryAgencyInd: agency.primaryAgencyInd
                };

                try {
                  let saveIds = await API.graphql(
                    graphqlOperation(mutations.createAgency, {
                      input: agencyInput
                    })
                  ).catch(e => {
                    this.addToErrorLogs("swimlanes-shell save createAgency", e);
                    this.overlay = false;
                    this.$modal.show("errorModal");
                    return;
                  });

                  if (saveIds && saveIds.data.createAgency.agencyCode) {
                    agency.agencyCode = saveIds.data.createAgency.agencyCode;
                    this.offices[index].agencyCode =
                      saveIds.data.createAgency.agencyCode;
                  }

                  if (agency.PrimaryAgencyInd == true) {
                    let AOsAgencies = await API.graphql(
                      graphqlOperation(queries.getAgenciesByAONum, {
                        aoNum: this.aoId,
                        company: this.$store.state.currentCompany
                      })
                    ).catch(e => {
                      this.addToErrorLogs(
                        "agency-address getAgenciesByAONum",
                        e
                      );
                    });

                    let OtherChangedAgencies = [];

                    if (AOsAgencies.data.getAgenciesByAONum.length) {
                      OtherChangedAgencies =
                        AOsAgencies.data.getAgenciesByAONum;
                    }

                    for (let original of OtherAgencies) {
                      for (let updated of OtherChangedAgencies) {
                        if (
                          original.AgencyCode == updated.AgencyCode &&
                          original.PrimaryAgencyInd != updated.PrimaryAgencyInd
                        ) {
                          let agencyUpdatesInfoPAI = {
                            company: this.$store.state.currentCompany,
                            agencyId: updated.AgencyCode,
                            agencyName: updated.AgencyName,
                            agencyNameOrig: original.AgencyName,
                            agencyEmailOrig: original.Email,
                            agencyEmail: updated.Email,
                            aoNum: updated.AOAgentNumPrimary,
                            aoName: this.offices[this.currentIndex].levels[0]
                              .levelMembers[0].name,
                            aoNumOrig: original.AOAgentNumPrimary,
                            aoNameOrig: this.offices[this.currentIndex]
                              .levels[0].levelMembers[0].name,
                            agencyAddress1Orig: original.AddressLine1,
                            agencyAddress1: updated.AddressLine1,
                            agencyAddress2Orig: original.AddressLine2,
                            agencyAddress2: updated.AddressLine2,
                            agencyCityOrig: original.City,
                            agencyCity: updated.City,
                            agencyStateProvinceOrig: original.StateProvinceCode,
                            agencyStateProvince: updated.StateProvinceCode,
                            agencyPostalCodeOrig: original.PostalCode,
                            agencyPostalCode: updated.PostalCode,
                            agencyCountryOrig: original.CountryName,
                            agencyCountry: updated.CountryName,
                            agencyAreaCode: updated.AreaCode,
                            agencyAreaCodeOrig: original.AreaCode,
                            agencyPhoneOrig: original.PhoneNum,
                            agencyPhone: updated.PhoneNum,
                            agencyPhoneExtOrig: original.PhoneExtensionNum,
                            agencyPhoneExt: updated.PhoneExtensionNum,
                            updatedBy:
                              this.$store.state.currentUser.name +
                              " (" +
                              this.$store.state.currentUser.agentNum +
                              ")",
                            primaryAgencyInd: updated.PrimaryAgencyInd,
                            primaryAgencyIndOrig: original.PrimaryAgencyInd
                          };

                          try {
                            HTTP.post("history", agencyUpdatesInfoPAI, {
                              headers: {
                                "Content-Type": "application/json"
                              }
                            })
                              .then(response => {
                                if (response.status != 200) {
                                  this.addToErrorLogs(
                                    "agency-address.vue submit post history",
                                    JSON.stringify(response)
                                  );
                                }
                              })
                              .catch(e => {
                                this.addToErrorLogs(
                                  "agency-address.vue submit post history",
                                  e
                                );
                              });
                          } catch (e) {
                            this.addToErrorLogs("agency-address.vue submit", e);
                          }
                        }
                      }
                    }
                  }
                } catch (e) {
                  this.addToErrorLogs("swimlanes-shell save createAgency", e);
                  this.overlay = false;
                  this.$modal.show("errorModal");
                  return;
                }
              }
            }

            let roles;

            roles = await API.graphql(
              graphqlOperation(queries.getHierarchyRoles)
            ).catch(e => {
              this.addToErrorLogs("swimlanes-shell save getHierarchyRoles", e);
              this.overlay = false;
              this.$modal.show("errorModal");
              return;
            });

            let hiers = [];

            for (let idx = 0; idx < this.offices.length; idx++) {
              if (
                this.offices[idx].agencyCode &&
                this.offices[idx].agencyCode != ""
              ) {
                for (let save of this.offices[idx].changeLog) {
                  let role;

                  if (roles.data && roles.data.getHierarchyRoles) {
                    role = roles.data.getHierarchyRoles.find(
                      r => r.roleAbbr == save.abbr
                    );
                  }

                  let agentRole;

                  if (roles.data && roles.data.getHierarchyRoles) {
                    agentRole = roles.data.getHierarchyRoles.find(
                      r => r.roleAbbr == "Agt"
                    );
                  }
                  if (!save.unassigned && role) {
                    let mutation = {
                      agentNum: save.id,
                      AgencyCode: this.offices[idx].agencyCode,
                      ManagerAgentNumPrimary: save.parentId,
                      AOAgentNumPrimary: this.offices[idx].levels[0]
                        .levelMembers[0].id,
                      GLHierarchyTypeRoleID: role.roleId,
                      IsUnassigned: save.unassigned,
                      CreatedBy:
                        "AMT: " +
                        this.$store.state.currentUser.name +
                        " (" +
                        this.$store.state.currentUser.agentNum +
                        ")"
                    };

                    if (!this.mutationMatchesOriginal(mutation))
                      hiers.push(mutation);
                  } else if (save.unassigned && (agentRole || role)) {
                    let mutation = {
                      agentNum: save.id,
                      AgencyCode: this.offices[idx].agencyCode,
                      ManagerAgentNumPrimary: this.offices[idx].levels[0]
                        .levelMembers[0].id,
                      AOAgentNumPrimary: this.offices[idx].levels[0]
                        .levelMembers[0].id,
                      GLHierarchyTypeRoleID: agentRole
                        ? agentRole.roleId
                        : role.roleId,
                      IsUnassigned: save.unassigned,
                      CreatedBy:
                        "AMT: " +
                        this.$store.state.currentUser.name +
                        " (" +
                        this.$store.state.currentUser.agentNum +
                        ")"
                    };
                    if (!this.mutationMatchesOriginal(mutation))
                      hiers.push(mutation);
                  }
                }
              }
            }

            // let success = false;

            if (hiers && hiers.length) {
              // console.log(hiers);
              // marker 50
              if (hiers.length > 50) this.$modal.show("longSaveModal");

              await API.graphql(
                graphqlOperation(mutations.updateHierarchy, {
                  input: { hiers: hiers }
                })
              ).catch(e => {
                this.addToErrorLogs("swimlanes-shell save updateHierarchy", e);
              });

              let idx = 0;

              this.CheckSaveWithWait(idx).then(success => {
                if (success == true) {
                  //show success dialog
                  // console.log('got here');

                  this.$modal.hide("longSaveModal");
                  this.$modal.show("saveSuccessDialog");

                  for (let hier of hiers) {
                    this.updateSavePool(hier, roles);
                  }

                  for (let idx = 0; idx < this.offices.length; idx++) {
                    this.offices[idx].changeLog = [];
                  }

                  let SaveTime = new Date();
                  this.hierarchyLoadedTime = SaveTime;

                  HTTP.post(
                    "locks",
                    {
                      aoAgentNum: this.$store.state.currentAO.id,
                      editedByNum: this.userPrimaryAgentNum,
                      editedByName: this.$store.state.currentUser.name,
                      locked: false,
                      sessionId: this.$store.state.session,
                      lastSaveTime: SaveTime
                    },
                    {
                      headers: {
                        "Content-Type": "application/json"
                      }
                    }
                  )
                    .then(response => {
                      if (
                        response.status == 200 &&
                        response.data.errorMessage == undefined
                      ) {
                        this.$modal.hide("longSaveModal");
                        this.overlay = false;
                        this.editableFlag = false;

                        this.sendUnlockedMsg();
                      } else {
                        this.$modal.hide("longSaveModal");
                        this.overlay = false;
                        this.$modal.show("errorModal");
                        try {
                          this.addToErrorLogs(
                            "swimlanes-shell save POST /locks",
                            new Error(JSON.stringify(response))
                          );
                        } catch (e) {
                          this.addToErrorLogs(
                            "swimlanes-shell save POST /locks",
                            new Error(
                              "Response status: " + response.status.toString()
                            )
                          );
                          this.addToErrorLogs(
                            "swimlanes-shell save POST /locks",
                            e
                          );
                        }
                        return;
                      }
                    })
                    .catch(e => {
                      this.overlay = false;
                      this.$modal.hide("longSaveModal");
                      this.editableFlag = false;
                      this.$modal.show("errorModal");
                      this.addToErrorLogs(
                        "swimlanes-shell save POST /locks",
                        e
                      );
                      return;
                    });
                } else {
                  this.$modal.hide("longSaveModal");
                  this.overlay = false;
                  this.$modal.show("errorModal");
                  return;
                }

                return;
              });

              //  let hiersChunk = [];
              //  let chunkCount = 0;

              //  success = true;

              //  for (let idx=0; idx<hiers.length; idx++)
              //  {
              //    hiersChunk.push(hiers[idx]);
              //    chunkCount++;

              //    if (chunkCount==50 || (idx == hiers.length-1)){
              //       let res = await API.graphql(
              //             graphqlOperation(mutations.updateHierarchy, {
              //             input: { hiers: hiersChunk }
              //         })
              //       ).catch(e => {
              //         this.addToErrorLogs("swimlanes-shell save updateHierarchy", e);
              //         this.overlay = false;
              //         this.$modal.show("errorModal");
              //         return;
              //       });

              //       if (res.data.updateHierarchy.result==false)
              //         success = false;

              //       chunkCount = 0;
              //       hiersChunk = [];

              //    }

              //  }
            } else {
              //show success dialog
              this.$modal.show("saveSuccessDialog");

              for (let hier of hiers) {
                this.updateSavePool(hier, roles);
              }

              for (let idx = 0; idx < this.offices.length; idx++) {
                this.offices[idx].changeLog = [];
              }

              let SaveTime = new Date();
              this.hierarchyLoadedTime = SaveTime;

              HTTP.post(
                "locks",
                {
                  aoAgentNum: this.$store.state.currentAO.id,
                  editedByNum: this.userPrimaryAgentNum,
                  editedByName: this.$store.state.currentUser.name,
                  locked: false,
                  sessionId: this.$store.state.session,
                  lastSaveTime: SaveTime
                },
                {
                  headers: {
                    "Content-Type": "application/json"
                  }
                }
              )
                .then(response => {
                  if (
                    response.status == 200 &&
                    response.data.errorMessage == undefined
                  ) {
                    this.overlay = false;
                    this.editableFlag = false;

                    this.sendUnlockedMsg();
                  } else {
                    this.overlay = false;
                    this.$modal.show("errorModal");
                    try {
                      this.addToErrorLogs(
                        "swimlanes-shell save POST /locks",
                        new Error(JSON.stringify(response))
                      );
                    } catch (e) {
                      this.addToErrorLogs(
                        "swimlanes-shell save POST /locks",
                        new Error(
                          "Response status: " + response.status.toString()
                        )
                      );
                      this.addToErrorLogs(
                        "swimlanes-shell save POST /locks",
                        e
                      );
                    }
                    return;
                  }
                })
                .catch(e => {
                  this.overlay = false;
                  this.editableFlag = false;
                  this.$modal.show("errorModal");
                  this.addToErrorLogs("swimlanes-shell save POST /locks", e);
                  return;
                });
            }

            // else{
            //  if (hiers && hiers.length) {

            //     let res = await API.graphql(
            //     graphqlOperation(mutations.updateHierarchy, {
            //       input: { hiers: hiers }
            //     })
            //   ).catch(e => {
            //     this.addToErrorLogs("swimlanes-shell save updateHierarchy", e);
            //     this.overlay = false;
            //     this.$modal.show("errorModal");
            //     return;
            //   });

            //   success = res.data.updateHierarchy.result;

            // }
            // else {
            //   success = true;
            // }

            // if (success) {
            //   //show success dialog
            //   this.$modal.show("saveSuccessDialog");

            //   for (let hier of hiers) {
            //     this.updateSavePool(hier, roles);
            //   }

            //   for (let idx = 0; idx < this.offices.length; idx++) {
            //     this.offices[idx].changeLog = [];
            //   }

            //   let SaveTime = new Date();
            //   this.hierarchyLoadedTime = SaveTime;

            //   HTTP.post(
            //     "locks",
            //     {
            //       aoAgentNum: this.$store.state.currentAO.id,
            //       editedByNum: this.userPrimaryAgentNum,
            //       editedByName: this.$store.state.currentUser.name,
            //       locked: false,
            //       sessionId: this.$store.state.session,
            //       lastSaveTime: SaveTime
            //     },
            //     {
            //       headers: {

            //         "Content-Type": "application/json"
            //       }
            //     }
            //   )
            //     .then(response => {
            //       if (
            //         response.status == 200 &&
            //         response.data.errorMessage == undefined
            //       ) {
            //         this.overlay = false;
            //         this.editableFlag = false;
            //       } else {
            //         this.overlay = false;
            //         this.$modal.show("errorModal");
            //         try {
            //           this.addToErrorLogs(
            //             "swimlanes-shell save POST /locks",
            //             new Error(JSON.stringify(response))
            //           );
            //         } catch (e) {
            //           this.addToErrorLogs(
            //             "swimlanes-shell save POST /locks",
            //             new Error(
            //               "Response status: " + response.status.toString()
            //             )
            //           );
            //           this.addToErrorLogs(
            //             "swimlanes-shell save POST /locks",
            //             e
            //           );
            //         }
            //         return;
            //       }
            //     })
            //     .catch(e => {
            //       this.overlay = false;
            //       this.editableFlag = false;
            //       this.$modal.show("errorModal");
            //       this.addToErrorLogs("swimlanes-shell save POST /locks", e);
            //       return;
            //     });
            // }
            // }
          })
          .catch(e => {
            this.overlay = false;
            this.$modal.show("errorModal");
            this.addToErrorLogs("swimlanes-shell save GET /locks", e);
            return;
          });
      } catch (e) {
        this.overlay = false;
        this.editableFlag = false;
        this.$modal.show("errorModal");
        this.addToErrorLogs("swimlanes-shell save", e);
        return;
      }
    },
    saveAndContinue() {
      this.overlay = true;
      let unassignedAgents = false;

      for (let idx = 0; idx < this.offices.length; idx++) {
        if (this.offices[idx].agentPool.length > 0) unassignedAgents = true;
      }

      if (unassignedAgents) {
        this.overlay = false;
        this.$modal.show("cannotSaveModal");
        return;
      }

      try {
        HTTP.get("locks", {
          params: {
            AOAgentNum: this.$store.state.currentAO.id
          },
          headers: {
            "Content-Type": "application/json"
          }
        })
          .then(async response => {
            if (
              response.data &&
              response.data.Items &&
              response.data.Items.length
            ) {
              let lockRecord = response.data.Items[0];

              if (lockRecord.IsLocked) {
                if (lockRecord.EditedByAgentNum != this.userPrimaryAgentNum) {
                  this.currentLock = lockRecord;
                  this.overlay = false;
                  this.$modal.show("lockWasOverriden");
                  return;
                }

                if (
                  lockRecord.SessionId &&
                  lockRecord.SessionId != this.$store.state.session
                ) {
                  this.currentLock = lockRecord;
                  this.overlay = false;
                  this.$modal.show("selfLockWasOverriden");
                  return;
                }
              } else {
                this.overlay = false;
                this.$modal.show("lockWasInvalidated");
                return;
              }
            }

            // Check last save time:

            let lastModified = await API.graphql(
              graphqlOperation(queries.getLastModified, {
                aoNum: this.offices[this.currentIndex].aoId
              })
            ).catch(e => {
              this.addToErrorLogs("swimlanes-shell save getLastModified", e);
              this.overlay = false;
              this.$modal.show("errorModal");
              return;
            });

            let lastModDate = new Date(lastModified.data.getLastModified);

            if (lastModDate.getTime() > this.hierarchyLoadedTime.getTime()) {
              this.lastModifiedInDb = lastModDate;
              this.overlay = false;
              this.$modal.show("saveError");
              return;
            }

            for (let index = 0; index < this.offices.length; index++) {
              let agency = this.offices[index];

              if (
                agency.agencyCode == null ||
                agency.agencyCode == undefined ||
                agency.agencyCode == ""
              ) {
                let OtherAgencies = [];

                if (agency.PrimaryAgencyInd == true) {
                  let AOsAgencies = await API.graphql(
                    graphqlOperation(queries.getAgenciesByAONum, {
                      aoNum: agency.aoId,
                      company: this.$store.state.currentCompany
                    })
                  ).catch(e => {
                    this.addToErrorLogs(
                      "swimlanes-shell getAgenciesByAONum",
                      e
                    );
                  });
                  if (AOsAgencies.data.getAgenciesByAONum.length) {
                    OtherAgencies = AOsAgencies.data.getAgenciesByAONum;
                  }
                }

                let agencyInput = {
                  CompanyID: agency.companyId,
                  AOAgentNumPrimary: agency.aoId,
                  Name: agency.name,
                  Email: agency.agencyEmail,
                  CreatedBy:
                    "AMT: " +
                    this.$store.state.currentUser.name +
                    " (" +
                    this.$store.state.currentUser.agentNum +
                    ")",
                  AgencyCode: null,
                  AddressTypeID: agency.addressTypeId,
                  AddressLine1: agency.agencyAddress1,
                  AddressLine2: agency.agencyAddress2,
                  City: agency.agencyCity,
                  StateProvinceCode: agency.agencyState,
                  PostalCode: agency.agencyZip,
                  GLCountryID: agency.countryId,
                  GLPhoneTypeID: agency.phoneTypeId,
                  AreaCode:
                    agency.agencyPhone.length == 10
                      ? agency.agencyPhone.substr(0, 3)
                      : "",
                  PhoneNum:
                    agency.agencyPhone.length == 10
                      ? agency.agencyPhone.substr(3)
                      : agency.agencyPhone,
                  PhoneExtensionNum: agency.agencyPhoneExt,
                  PrimaryAgencyInd: agency.primaryAgencyInd
                };

                try {
                  let saveIds = await API.graphql(
                    graphqlOperation(mutations.createAgency, {
                      input: agencyInput
                    })
                  ).catch(e => {
                    this.addToErrorLogs("swimlanes-shell save createAgency", e);
                    this.overlay = false;
                    this.$modal.show("errorModal");
                    return;
                  });

                  if (saveIds && saveIds.data.createAgency.agencyCode) {
                    agency.agencyCode = saveIds.data.createAgency.agencyCode;
                    this.offices[index].agencyCode =
                      saveIds.data.createAgency.agencyCode;
                  }

                  if (agency.PrimaryAgencyInd == true) {
                    let AOsAgencies = await API.graphql(
                      graphqlOperation(queries.getAgenciesByAONum, {
                        aoNum: this.aoId,
                        company: this.$store.state.currentCompany
                      })
                    ).catch(e => {
                      this.addToErrorLogs(
                        "agency-address getAgenciesByAONum",
                        e
                      );
                    });

                    let OtherChangedAgencies = [];

                    if (AOsAgencies.data.getAgenciesByAONum.length) {
                      OtherChangedAgencies =
                        AOsAgencies.data.getAgenciesByAONum;
                    }

                    for (let original of OtherAgencies) {
                      for (let updated of OtherChangedAgencies) {
                        if (
                          original.AgencyCode == updated.AgencyCode &&
                          original.PrimaryAgencyInd != updated.PrimaryAgencyInd
                        ) {
                          let agencyUpdatesInfoPAI = {
                            company: this.$store.state.currentCompany,
                            agencyId: updated.AgencyCode,
                            agencyName: updated.AgencyName,
                            agencyNameOrig: original.AgencyName,
                            agencyEmailOrig: original.Email,
                            agencyEmail: updated.Email,
                            aoNum: updated.AOAgentNumPrimary,
                            aoName: this.offices[this.currentIndex].levels[0]
                              .levelMembers[0].name,
                            aoNumOrig: original.AOAgentNumPrimary,
                            aoNameOrig: this.offices[this.currentIndex]
                              .levels[0].levelMembers[0].name,
                            agencyAddress1Orig: original.AddressLine1,
                            agencyAddress1: updated.AddressLine1,
                            agencyAddress2Orig: original.AddressLine2,
                            agencyAddress2: updated.AddressLine2,
                            agencyCityOrig: original.City,
                            agencyCity: updated.City,
                            agencyStateProvinceOrig: original.StateProvinceCode,
                            agencyStateProvince: updated.StateProvinceCode,
                            agencyPostalCodeOrig: original.PostalCode,
                            agencyPostalCode: updated.PostalCode,
                            agencyCountryOrig: original.CountryName,
                            agencyCountry: updated.CountryName,
                            agencyAreaCode: updated.AreaCode,
                            agencyAreaCodeOrig: original.AreaCode,
                            agencyPhoneOrig: original.PhoneNum,
                            agencyPhone: updated.PhoneNum,
                            agencyPhoneExtOrig: original.PhoneExtensionNum,
                            agencyPhoneExt: updated.PhoneExtensionNum,
                            updatedBy:
                              this.$store.state.currentUser.name +
                              " (" +
                              this.$store.state.currentUser.agentNum +
                              ")",
                            primaryAgencyInd: updated.PrimaryAgencyInd,
                            primaryAgencyIndOrig: original.PrimaryAgencyInd
                          };

                          try {
                            HTTP.post("history", agencyUpdatesInfoPAI, {
                              headers: {
                                "Content-Type": "application/json"
                              }
                            })
                              .then(response => {
                                if (response.status != 200) {
                                  this.addToErrorLogs(
                                    "agency-address.vue submit post history",
                                    JSON.stringify(response)
                                  );
                                }
                              })
                              .catch(e => {
                                this.addToErrorLogs(
                                  "agency-address.vue submit post history",
                                  e
                                );
                              });
                          } catch (e) {
                            this.addToErrorLogs("agency-address.vue submit", e);
                          }
                        }
                      }
                    }
                  }
                } catch (e) {
                  this.addToErrorLogs("swimlanes-shell save createAgency", e);
                  this.overlay = false;
                  this.$modal.show("errorModal");
                  return;
                }
              }
            }

            let roles;

            roles = await API.graphql(
              graphqlOperation(queries.getHierarchyRoles)
            ).catch(e => {
              this.addToErrorLogs("swimlanes-shell save getHierarchyRoles", e);
              this.overlay = false;
              this.$modal.show("errorModal");
              return;
            });

            let hiers = [];

            for (let idx = 0; idx < this.offices.length; idx++) {
              if (
                this.offices[idx].agencyCode &&
                this.offices[idx].agencyCode != ""
              ) {
                for (let save of this.offices[idx].changeLog) {
                  let role;

                  if (roles.data && roles.data.getHierarchyRoles) {
                    role = roles.data.getHierarchyRoles.find(
                      r => r.roleAbbr == save.abbr
                    );
                  }

                  let agentRole;

                  if (roles.data && roles.data.getHierarchyRoles) {
                    agentRole = roles.data.getHierarchyRoles.find(
                      r => r.roleAbbr == "Agt"
                    );
                  }
                  if (!save.unassigned && role) {
                    let mutation = {
                      agentNum: save.id,
                      AgencyCode: this.offices[idx].agencyCode,
                      ManagerAgentNumPrimary: save.parentId,
                      AOAgentNumPrimary: this.offices[idx].levels[0]
                        .levelMembers[0].id,
                      GLHierarchyTypeRoleID: role.roleId,
                      IsUnassigned: save.unassigned,
                      CreatedBy:
                        "AMT: " +
                        this.$store.state.currentUser.name +
                        " (" +
                        this.$store.state.currentUser.agentNum +
                        ")"
                    };

                    if (!this.mutationMatchesOriginal(mutation))
                      hiers.push(mutation);
                  } else if (save.unassigned && (agentRole || role)) {
                    let mutation = {
                      agentNum: save.id,
                      AgencyCode: this.offices[idx].agencyCode,
                      ManagerAgentNumPrimary: this.offices[idx].levels[0]
                        .levelMembers[0].id,
                      AOAgentNumPrimary: this.offices[idx].levels[0]
                        .levelMembers[0].id,
                      GLHierarchyTypeRoleID: agentRole
                        ? agentRole.roleId
                        : role.roleId,
                      IsUnassigned: save.unassigned,
                      CreatedBy:
                        "AMT: " +
                        this.$store.state.currentUser.name +
                        " (" +
                        this.$store.state.currentUser.agentNum +
                        ")"
                    };
                    if (!this.mutationMatchesOriginal(mutation))
                      hiers.push(mutation);
                  }
                }
              }
            }

            // let success = false;

            if (hiers && hiers.length) {
              // console.log(hiers);
              // marker 50
              if (hiers.length > 50) this.$modal.show("longSaveModal");

              await API.graphql(
                graphqlOperation(mutations.updateHierarchy, {
                  input: { hiers: hiers }
                })
              ).catch(e => {
                this.addToErrorLogs("swimlanes-shell save updateHierarchy", e);
              });

              let idx = 0;

              this.CheckSaveWithWait(idx).then(success => {
                if (success == true) {
                  //show success dialog
                  // console.log('got here');

                  this.$modal.hide("longSaveModal");
                  // this.$modal.show("saveSuccessDialog");

                  for (let hier of hiers) {
                    this.updateSavePool(hier, roles);
                  }

                  for (let idx = 0; idx < this.offices.length; idx++) {
                    this.offices[idx].changeLog = [];
                  }

                  let SaveTime = new Date();
                  this.hierarchyLoadedTime = SaveTime;
                  this.$modal.hide("longSaveModal");
                  this.overlay = false;
                } else {
                  this.$modal.hide("longSaveModal");
                  this.overlay = false;
                  this.$modal.show("errorModal");
                  return;
                }

                return;
              });
            } else {
              //show success dialog
              // this.$modal.show("saveSuccessDialog");

              for (let hier of hiers) {
                this.updateSavePool(hier, roles);
              }

              for (let idx = 0; idx < this.offices.length; idx++) {
                this.offices[idx].changeLog = [];
              }

              let SaveTime = new Date();
              this.hierarchyLoadedTime = SaveTime;
              this.overlay = false;
            }
          })
          .catch(e => {
            this.overlay = false;
            this.$modal.show("errorModal");
            this.addToErrorLogs("swimlanes-shell save GET /locks", e);
            return;
          });
      } catch (e) {
        this.overlay = false;
        this.editableFlag = false;
        this.$modal.show("errorModal");
        this.addToErrorLogs("swimlanes-shell save", e);
        return;
      }
    },
    async CheckSaveWithWait(counter) {
      return new Promise(resolve => {
        // console.log('CheckSaveWithWait')
        if (counter == 6) return resolve(false);

        this.checkLongSaveStatus().then(inProgress => {
          if (inProgress == true) {
            setTimeout(() => {
              return resolve(this.CheckSaveWithWait(counter + 1));
            }, 30 * 1000);
          } else return resolve(true);
        });
      });
    },

    async checkLongSaveStatus() {
      return new Promise((resolve, reject) => {
        HTTP.get("locks", {
          params: {
            AOAgentNum: this.$store.state.currentAO.id
          },
          headers: {
            "Content-Type": "application/json"
          }
        })
          .then(async response => {
            // console.log(response);
            if (response.status == 200) {
              if (
                response.data &&
                response.data.Items &&
                response.data.Items.length
              ) {
                let lockRecord = response.data.Items[0];
                // console.log(lockRecord);
                // console.log(lockRecord.UpdateInProgress);

                return resolve(lockRecord.UpdateInProgress);
              }
            }
          })
          .catch(e => {
            // console.log(e);
            reject(e);
          });
      });
    },
    updateSavePool(mutation, roles) {
      let role;
      if (roles.data && roles.data.getHierarchyRoles) {
        role = roles.data.getHierarchyRoles.find(
          r => r.roleId == mutation.GLHierarchyTypeRoleID
        );
      }

      let node = {
        AgentNumPrimary: mutation.agentNum,
        AgencyCode: mutation.AgencyCode,
        ManagerAgentNumPrimary: mutation.ManagerAgentNumPrimary,
        AOAgentNumPrimary: mutation.AOAgentNumPrimary,
        RoleId: mutation.GLHierarchyTypeRoleID,
        RoleAbbr: role.roleAbbr,
        IsUnassigned: mutation.IsUnassigned
      };

      if (node.RoleAbbr == "AO" || node.RoleAbbr == "AA") {
        // replace only the one agency's entry
        let agentIdx = this.savePool.findIndex(
          sp =>
            sp.AgentNumPrimary == mutation.agentNum &&
            sp.AgencyCode == mutation.AgencyCode
        );

        if (agentIdx >= 0) {
          this.savePool.splice(agentIdx, 1, node);
        } else {
          this.savePool.push(node);
        }
      } else {
        // replace all agencies' entries

        let agencyAgents = this.savePool.filter(
          sp => sp.AgentNumPrimary == mutation.agentNum
        );

        for (let agencyAgent of agencyAgents) {
          let idx = this.savePool.findIndex(
            sp => sp.AgentNumPrimary == agencyAgent.AgentNumPrimary
          );
          if (idx >= 0) this.savePool.splice(idx, 1);
        }

        this.savePool.push(node);
      }
    },
    mutationMatchesOriginal(mutation) {
      let agents = this.savePool;
      for (let agent of agents) {
        if (
          mutation.agentNum == agent.AgentNumPrimary &&
          mutation.AgencyCode == agent.AgencyCode &&
          mutation.ManagerAgentNumPrimary == agent.ManagerAgentNumPrimary &&
          mutation.AOAgentNumPrimary == agent.AOAgentNumPrimary &&
          mutation.GLHierarchyTypeRoleID == agent.RoleId &&
          mutation.IsUnassigned == agent.IsUnassigned
        ) {
          return true;
        }
      }

      return false;
    },
    revert() {
      this.$modal.show("revertChangesDialog");
    },
    reload() {
      try {
        this.waitFlag = true;

        HTTP.get("locks", {
          params: {
            AOAgentNum: this.$store.state.currentAO.id
          },
          headers: {
            "Content-Type": "application/json"
          }
        })
          .then(async response => {
            if (response.status == 200) {
              if (
                response.data &&
                response.data.Items &&
                response.data.Items.length
              ) {
                let lockRecord = response.data.Items[0];

                if (lockRecord.IsLocked) {
                  if (
                    lockRecord.EditedByAgentNum == this.userPrimaryAgentNum &&
                    (!lockRecord.SessionId ||
                      lockRecord.SessionId == this.$store.state.session)
                  ) {
                    HTTP.post(
                      "locks",
                      {
                        aoAgentNum: this.$store.state.currentAO.id,
                        editedByNum: this.userPrimaryAgentNum,
                        editedByName: this.$store.state.currentUser.name,
                        locked: false,
                        sessionId: this.$store.state.session
                      },
                      {
                        headers: {
                          "Content-Type": "application/json"
                        }
                      }
                    )
                      .then(response => {
                        if (
                          response.status == 200 &&
                          response.data.errorMessage == undefined
                        ) {
                          this.sendUnlockedMsg();
                          this.cleanUpOnReload();
                          this.waitFlag = false;
                        } else {
                          this.waitFlag = false;
                          this.$modal.show("errorModal");
                          try {
                            this.addToErrorLogs(
                              "swimlanes-shell reload POST /locks",
                              new Error(JSON.stringify(response))
                            );
                          } catch (e) {
                            this.addToErrorLogs(
                              "swimlanes-shell reload POST /locks",
                              new Error(
                                "Response status: " + response.status.toString()
                              )
                            );
                            this.addToErrorLogs(
                              "swimlanes-shell reload POST /locks",
                              e
                            );
                          }
                        }
                      })
                      .catch(e => {
                        this.waitFlag = false;
                        this.$modal.show("errorModal");
                        this.addToErrorLogs(
                          "swimlanes-shell reload POST /locks",
                          e
                        );
                      });
                  } else {
                    this.cleanUpOnReload();
                    this.waitFlag = false;
                  }
                } else {
                  this.cleanUpOnReload();
                  this.waitFlag = false;
                }
              }
            } else {
              this.waitFlag = false;
              this.$modal.show("errorModal");

              try {
                this.addToErrorLogs(
                  "swimlanes-shell reload GET /locks",
                  new Error(JSON.stringify(response))
                );
              } catch (e) {
                this.addToErrorLogs(
                  "swimlanes-shell reload GET /locks",
                  new Error("Response status: " + response.status.toString())
                );
                this.addToErrorLogs("swimlanes-shell reload GET /locks", e);
              }
            }
          })
          .catch(e => {
            this.addToErrorLogs("swimlanes-shell reload GET /locks", e);
            this.waitFlag = false;
            this.$modal.show("errorModal");
          });
      } catch (e) {
        this.waitFlag = false;
        this.addToErrorLogs("swimlanes-shell reload", e);
      }
    },

    cleanUpOnReload() {
      try {
        EventBus.$emit("clearConnectors", this.currentIndex);

        for (let office of this.offices) {
          for (let level of office.levels) {
            level.levelMembers.splice(0);
          }
          office.agentPool.splice(0);
          office.levelReports.splice(0);
          office.changeLog.splice(0);
        }

        this.initialize(false);
        this.editableFlag = false;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell cleanUpOnReload", e);
      }
    },

    async reloadForEdit() {
      try {
        this.waitFlag = true;
        EventBus.$emit("clearConnectors", this.currentIndex);

        for (let office of this.offices) {
          for (let level of office.levels) {
            level.levelMembers.splice(0);
          }
          office.agentPool.splice(0);
          office.levelReports.splice(0);
          office.changeLog.splice(0);
        }

        await this.initialize(true);

        this.waitFlag = false;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell cleanUpOnReload", e);
      }
    },

    // Called when clicking the swap icon on a non-AO node
    replacePosition(source, level) {
      try {
        this.offices[this.currentIndex].replaceMember = source; // set the replacemember as the node clicked on
        this.offices[this.currentIndex].replaceLevel = level; // set the replace level as node's level
        this.offices[this.currentIndex].replaceAO = false;
        this.$modal.show("replaceDialog"); // open the replacement dialog to find the new role level
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell replacePosition", e);
      }
    },
    // Called when clicking the swap icon on the AO node
    replaceAO(source, level) {
      try {
        this.offices[this.currentIndex].replaceMember = source; // set the replacemember as the node clicked on
        this.offices[this.currentIndex].replaceLevel = level; // set the replace level as node's level
        this.offices[this.currentIndex].replaceAO = true;
        this.$modal.show("replaceDialog"); // open the replacement dialog to find the new role level
        //this.offices[this.currentIndex].replaceDialog = true; // open the replacement dialog to find the new role level
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell replaceAO", e);
      }
    },
    cancelReplace() {
      this.offices[this.currentIndex].replaceMember = undefined;
      this.offices[this.currentIndex].replaceLevel = undefined;
      this.offices[this.currentIndex].replaceAO = false;
      this.$modal.hide("replaceDialog");
    },
    // Move the hierarchy tree of a node to a new parent, and place the node in the level with newLevelOrder
    moveHierarchy(node, newParent, newLevelOrder) {
      try {
        // Find the current node's level
        let currentLevel = this.findLevel(node.id);
        var children = [];

        let lateralABMove = false;
        let moveChildrenToSupe = false;
        let parentLevel = this.findLevel(newParent.id);
        let currParent;

        if (currentLevel.levelOrder == newLevelOrder) {
          moveChildrenToSupe = true;
        }

        if (
          (currentLevel.levelOrder == this.ABLevel ||
            currentLevel.levelOrder == this.ABLLevel) &&
          (newLevelOrder == this.ABLevel || newLevelOrder == this.ABLLevel) &&
          parentLevel.levelOrder == this.AOLevel &&
          this.offices[this.currentIndex].moveHierFlag == true
        ) {
          lateralABMove = true;
        }

        // Has children?

        for (let level of this.offices[this.currentIndex].levels) {
          for (let member of level.levelMembers) {
            if (member.id == node.parentId) {
              currParent = JSON.parse(JSON.stringify(member));
            } else if (member.parentId == node.id) {
              children.push({
                child: JSON.parse(JSON.stringify(member)),
                level: this.findLevel(member.id)
              });
            }
          }
        }

        // ...remove the node from its current level's members array
        this.removeFromHierarchy(node);

        for (let child of children) {
          this.removeFromHierarchy(child.child);
        }

        // ...and push it onto the members array of the new level

        if (lateralABMove == true) {
          for (let level of this.offices[this.currentIndex].levels) {
            if (level.levelOrder == newLevelOrder) {
              node.parentId = newParent.id;
              node.newFlag = false; // set the new flag to false
              level.levelMembers.push(node);
            } else {
              for (let child of children) {
                if (level.levelOrder == child.level.levelOrder) {
                  child.child.newFlag = false;
                  child.child.parentId = node.id;
                  level.levelMembers.push(child.child);
                }
              }
            }
          }
        } else if (moveChildrenToSupe == true) {
          for (let level of this.offices[this.currentIndex].levels) {
            if (level.levelOrder == newLevelOrder) {
              node.parentId = newParent.id;
              node.newFlag = false; // set the new flag to false
              level.levelMembers.push(node);
            }
          }

          for (let child of children) {
            child.child.newFlag = false;
            child.child.parentId = currParent.id;
            for (let level of this.offices[this.currentIndex].levels) {
              if (level.levelOrder == child.level.levelOrder) {
                level.levelMembers.push(child.child);
              }
            }
          }
        } else {
          for (let level of this.offices[this.currentIndex].levels) {
            if (level.levelOrder == newLevelOrder) {
              node.parentId = newParent.id;
              node.newFlag = false; // set the new flag to false
              level.levelMembers.push(node);

              for (let child of children) {
                child.child.newFlag = false;
                child.child.parentId = newParent.id;
                level.levelMembers.push(child.child);
              }
            }
          }
        }

        // Change the level reports to reflect the node's new parent
        for (let levRep of this.offices[this.currentIndex].levelReports) {
          if (levRep.childId == node.id) {
            levRep.parentId = newParent.id;
          }

          for (let child of children) {
            if (levRep.childId == child.child.id) {
              if (lateralABMove == true) {
                levRep.parentId = node.id;
              } else if (moveChildrenToSupe) {
                levRep.parentId = currParent.id;
              } else {
                levRep.parentId = newParent.id;
              }
            }
          }
        }

        // Change the connectors to reflect the node's new parent
        EventBus.$emit(
          "changeConnectorParent",
          node,
          newParent,
          this.currentIndex
        );

        for (let child of children) {
          if (lateralABMove == true) {
            EventBus.$emit(
              "changeConnectorParent",
              child.child,
              node,
              this.currentIndex
            );
          } else if (moveChildrenToSupe) {
            EventBus.$emit(
              "changeConnectorParent",
              child.child,
              currParent,
              this.currentIndex
            );
          } else {
            EventBus.$emit(
              "changeConnectorParent",
              child.child,
              newParent,
              this.currentIndex
            );
          }
        }

        let selLevel = this.findLevel(node.id);

        // If the node's existing parent connector was not found (it may have come from an agent sub-list)
        // add a connector for its new parent
        this.addConnector(
          { level: parentLevel.levelOrder, member: newParent },
          { level: selLevel.levelOrder, member: node },
          this.currentIndex
        );

        for (let child of children) {
          if (lateralABMove == true) {
            this.addConnector(
              { level: selLevel.levelOrder, member: node },
              { level: child.level.levelOrder, member: child.child },
              this.currentIndex
            );
          } else if (moveChildrenToSupe) {
            let childLevel = this.findLevel(child.id);
            let currParentLevel = this.findLevel(currParent.id);
            this.addConnector(
              { level: currParentLevel.levelOrder, member: currParent },
              { level: childLevel.levelOrder, member: child.child },
              this.currentIndex
            );
          } else {
            this.addConnector(
              { level: parentLevel.levelOrder, member: newParent },
              { level: selLevel.levelOrder, member: child.child },
              this.currentIndex
            );
          }
        }

        this.$nextTick().then(() => {
          this.memberToHighlight = null;
          this.$nextTick().then(() => {
            this.recalculateConnectors();
            this.memberToHighlight = this.searchAgent;
          });
        });

        this.addToChangeLogMultiOffice(
          node,
          newParent,
          selLevel,
          false,
          this.currentIndex
        );

        for (let child of children) {
          if (lateralABMove == true) {
            this.addToChangeLogMultiOffice(
              child.child,
              node,
              child.level,
              false,
              this.currentIndex
            );
          } else if (moveChildrenToSupe) {
            this.addToChangeLogMultiOffice(
              child.child,
              currParent,
              child.level,
              false,
              this.currentIndex
            );
          } else {
            this.addToChangeLogMultiOffice(
              child.child,
              newParent,
              selLevel,
              false,
              this.currentIndex
            );
          }
        }
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell moveHierarchy", e);
      }
    },
    removeHierarchyCurrentOffice(node, newParent, newLevelOrder, currentIndex) {
      try {
        let returnArray = [];

        let currentParentId = node.parentId;

        returnArray.push({
          member: {
            id: node.id,
            parentId: newParent.id,
            name: node.name,
            terminationDate: node.terminationDate,
            // title: node.title,
            spriteCssClass: node.spriteCssClass
          },
          levelOrder: newLevelOrder
        });

        // ...remove the node from its current level's members array
        this.removeFromHierarchy(node);
        this.offices[this.currentIndex].agentPool.push(node);

        // log the move
        this.addToChangeLogMultiOffice(
          node,
          this.offices[this.currentIndex].levels[0].levelMembers[0],
          null,
          true,
          currentIndex
        );

        this.removeFromChangeLogMultiOffice(node, currentIndex);

        // remove the levelReports where this node is the child:
        let remArray = [];

        for (let levRep of this.offices[currentIndex].levelReports) {
          if (levRep.childId == node.id) {
            remArray.push(levRep);
          }
        }

        for (let rem of remArray) {
          let idx = this.offices[currentIndex].levelReports.findIndex(
            o => o.childId == rem.childId && o.parentId == rem.parentId
          );

          if (idx >= 0) this.offices[currentIndex].levelReports.splice(idx, 1);
        }

        EventBus.$emit("removeParentConnectors", node, this.currentIndex);

        let children = [];

        for (let level of this.offices[currentIndex].levels) {
          for (let member of level.levelMembers) {
            if (member.parentId == node.id) {
              children.push({
                child: member,
                level: this.findLevel(member.id)
              });
            }
          }
        }

        if (this.offices[this.currentIndex].moveHierFlag) {
          for (let child of children) {
            returnArray.push(
              ...this.removeHierarchyCurrentOffice(
                child.child,
                node,
                child.level.levelOrder,
                currentIndex
              )
            );
          }
        } else {
          // Not moving the sub-hierarchy, adjust the child hierarchy
          // to point to the node's previous parent

          let previousParent = this.findInHierarchy(currentParentId);

          for (let child of children) {
            this.moveHierarchy(
              child.child,
              previousParent,
              child.level.levelOrder
            );

            this.addToChangeLogMultiOffice(
              child.child,
              previousParent,
              child.level,
              false,
              currentIndex
            );
          }
        }

        return returnArray;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell removeHierarchyCurrentOffice", e);
        return [];
      }
    },
    // Remove the level report for a node where the node is the child node
    removeLevelReport(node) {
      try {
        let idx = this.offices[this.currentIndex].levelReports.find(
          l => l.childId == node.id
        );
        if (idx >= 0)
          this.offices[this.currentIndex].levelReports.splice(idx, 1);
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell removeLevelReport", e);
      }
    },
    // Remove the node from its current level members array
    removeFromHierarchy(node) {
      try {
        for (let level of this.offices[this.currentIndex].levels) {
          let idx = level.levelMembers.findIndex(l => l.id == node.id);
          if (idx >= 0) {
            level.levelMembers.splice(idx, 1);
            break;
          }
        }
        this.addToChangeLogMultiOffice(
          node,
          this.offices[this.currentIndex].levels[0].levelMembers[0],
          null,
          true,
          this.currentIndex
        );
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell removeFromHierarchy", e);
      }
    },
    // Find the node in the unassigned list based on its id
    findInUnassigned(id) {
      try {
        for (let agent of this.offices[this.currentIndex].agentPool) {
          if (agent.id == id) {
            return agent;
          }
        }
        return null;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell findInUnassigned", e);
        return null;
      }
    },
    // Find the node in the hierarchy based on its id
    findInHierarchy(id) {
      try {
        for (let level of this.offices[this.currentIndex].levels) {
          for (let mem of level.levelMembers) {
            if (mem.id == id) {
              return mem;
            }
          }
        }
        return null;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell findInHierarchy", e);
        return null;
      }
    },
    // Find the hierarchy level of a node based on its id
    findLevel(id) {
      try {
        for (let level of this.offices[this.currentIndex].levels) {
          for (let mem of level.levelMembers) {
            if (mem.id == id) {
              return level;
            }
          }
        }
        return null;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell findLevel", e);
        return null;
      }
    },
    // Swap out a node (this.replaceMember) with another node (id: this.selectedReplacement)
    moveNodes() {
      try {
        let inHier = false;

        // find the selected replacement in the unassigned agents list
        let selReplacement = this.findInUnassigned(
          this.offices[this.currentIndex].selectedReplacement
        );

        // if it's not there, look for it in the hierarchy instead
        if (!selReplacement) {
          selReplacement = this.findInHierarchy(
            this.offices[this.currentIndex].selectedReplacement
          );
          if (selReplacement) inHier = true;
        }

        // find the parent of the node-to-be-replaced in the hierarchy
        let parent = this.findInHierarchy(
          this.offices[this.currentIndex].replaceMember.parentId
        );

        // if there's a parent, find the parent's level in the hierarchy
        let parentLevel;
        if (parent) parentLevel = this.findLevel(parent.id);

        // find the existing level of the node-to-be-replaced in the hierarchy
        let selLevel = this.findLevel(
          this.offices[this.currentIndex].replaceMember.id
        );

        if (inHier) {
          if (
            this.isInCrossOfficeRole(
              this.offices[this.currentIndex].selectedReplacement
            )
          ) {
            // if (selLevel.levelOrder > this.crossOfficeMaxLevel) {
            this.crossOfficeAgents = [selReplacement.name];
            this.waitFlag = false;
            this.$modal.show("crossOfficeMaxLevelExceeded");
            // Cannot drop AO/AA in lower level
            return;
            // }
          }
        }

        // if trying to relocate a hierarchy tree to an incompatible level of the
        // hierarchy, show error dialog (from moveAllowed) and return
        if (!this.moveAllowed(selReplacement, selLevel.levelOrder)) return;

        // if (
        //   this.searchAgent &&
        //   (selReplacement.id == this.searchAgent.id ||
        //     this.offices[this.currentIndex].replaceMember.id ==
        //       this.searchAgent.id)
        // ) {
        //   $j("div").removeClass("highlight");
        // }

        if (
          this.offices[this.currentIndex].moveHierFlag &&
          selLevel.levelOrder == this.AALevel
        ) {
          let hasChildren = false;

          for (let levRep of this.offices[this.currentIndex].levelReports) {
            if (
              levRep.parentId ==
              this.offices[this.currentIndex].selectedReplacement
            )
              hasChildren = true;
          }

          if (hasChildren) {
            this.$modal.show("dropPreventedAA2");
            this.waitFlag = false;
            return;
          }
        }

        if (inHier) {
          // if we're moving the entire hierarchy or the replacement node
          // is the child of the member to be replaced:

          if (
            this.offices[this.currentIndex].moveHierFlag ||
            selReplacement.parentId ==
              this.offices[this.currentIndex].replaceMember.id
          ) {
            // remove the selected node from its current level

            this.removeFromHierarchy(selReplacement);

            EventBus.$emit(
              "removeParentConnectors",
              selReplacement,
              this.currentIndex
            );

            let idx = this.offices[this.currentIndex].levelReports.findIndex(
              l => (l.childId = selReplacement.id)
            );
            if (idx >= 0)
              this.offices[this.currentIndex].levelReports.splice(idx, 1);

            // add it to the replacement node's level
            for (let level of this.offices[this.currentIndex].levels) {
              if (level.levelOrder == selLevel.levelOrder) {
                selReplacement.parentId = this.offices[
                  this.currentIndex
                ].replaceMember.parentId;
                selReplacement.newFlag = false;
                level.levelMembers.push(selReplacement);
              }
            }

            this.addToChangeLogMultiOffice(
              selReplacement,
              { id: this.offices[this.currentIndex].replaceMember.parentId },
              selLevel,
              false,
              this.currentIndex
            );
          } else {
            // else if the parent of the member to be replaced is defined
            // and NOT equal to the selected replacement node

            if (parent && parent.id != selReplacement.id) {
              this.moveToUnassigned(selReplacement);
              this.moveSourceToTarget(
                selReplacement,
                parent,
                selLevel.levelOrder
              );

              this.addToChangeLogMultiOffice(
                selReplacement,
                parent,
                selLevel,
                false,
                this.currentIndex
              );
            } else {
              // either the selected replacement has no parent
              // or it's the parent of the member to be replaced.

              this.moveToUnassigned(selReplacement);

              // find the new parent of the node
              let revisedMember = this.findInHierarchy(
                this.offices[this.currentIndex].replaceMember.id
              );
              let newParent = this.findInHierarchy(revisedMember.parentId);

              // move the replacement node from the unassigned list to the new parent of the
              // member-to-be-replaced
              this.moveSourceToTarget(
                selReplacement,
                newParent,
                selLevel.levelOrder
              );

              this.addToChangeLogMultiOffice(
                selReplacement,
                newParent,
                selLevel,
                false,
                this.currentIndex
              );
            }
          }
        } else {
          // if the node is in the unassigned list, add it to the node-to-be-replaced's
          // level under the node-to-be-replaced's parent

          this.moveSourceToTarget(selReplacement, parent, selLevel.levelOrder);
          this.addToChangeLogMultiOffice(
            selReplacement,
            parent,
            selLevel,
            false,
            this.currentIndex
          );
        }

        // move the hierarchy of the node-to-be-replaced to the replacement node,
        // which is now in the hierarchy
        let children = [];

        for (let level of this.offices[this.currentIndex].levels) {
          for (let mem of level.levelMembers) {
            if (
              mem.parentId == this.offices[this.currentIndex].replaceMember.id
            ) {
              children.push({ child: mem, level: level });
            }
          }
        }

        for (let child of children) {
          this.moveHierarchy(
            child.child,
            selReplacement,
            child.level.levelOrder
          );
          this.addToChangeLogMultiOffice(
            child.child,
            selReplacement,
            child.level,
            false,
            this.currentIndex
          );
        }

        // adjust the level reports, if the child id is the node-to-be-replaced
        // swap it out for the selected replacement

        for (let levelReport of this.offices[this.currentIndex].levelReports) {
          if (
            levelReport.child ==
            this.offices[this.currentIndex].replaceMember.id
          ) {
            levelReport.child = selReplacement.id;
          }
        }

        // if the node-to-be-replaced originally had a parent, add a connector back in
        // pointing to the selected replacement as the child

        if (parent) {
          this.addConnector(
            { level: parentLevel.levelOrder, member: parent },
            { level: selLevel.levelOrder, member: selReplacement },
            this.currentIndex
          );
        }

        // remove the node-to-be-replaced from the level members
        this.removeFromHierarchy(this.offices[this.currentIndex].replaceMember);

        // remove the connectors to the node-to-be-replaced

        EventBus.$emit(
          "removeConnectors",
          this.offices[this.currentIndex].replaceMember,
          this.currentIndex
        );

        // remove the level reports of the node-to-be-replaced
        this.removeLevelReport(this.offices[this.currentIndex].replaceMember);

        // add the node-to-be-replaced back to the unassigned pool
        if (this.offices[this.currentIndex].replaceMember.id != -1) {
          this.offices[this.currentIndex].agentPool.push(
            this.offices[this.currentIndex].replaceMember
          );

          this.addToChangeLogMultiOffice(
            this.offices[this.currentIndex].replaceMember,
            null,
            null,
            true,
            this.currentIndex
          );
        }

        // recalculate the connector positions
        // this.recalc();

        if (this.replaceAO == true || selLevel.levelOrder == this.AALevel) {
          for (let idx = 0; idx < this.offices.length; idx++) {
            if (idx != this.currentIndex) {
              this.moveNodesMultiOffice(idx);
            }
          }

          this.offices[this.currentIndex].selectedReplacement = null;
          this.$refs.replacementForm.reset();
        } else if (this.offices[this.currentIndex].replaceMember.id) {
          this.addToOtherAgentPools(
            this.offices[this.currentIndex].replaceMember.id
          );
          this.offices[this.currentIndex].selectedReplacement = null;
          this.$refs.replacementForm.reset();
        }
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell moveNodes", e);
      }
    },

    replaceWithSelection() {
      try {
        if (!this.$refs.replacementForm.validate()) {
          return;
        }
        this.$modal.hide("replaceDialog");
        return this.moveNodes();
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell replaceWithSelection", e);
      }
    },
    getDetails(member, level) {
      try {
        if (level && level.levelOrder == this.ABLevel) {
          let ablevel = this.findLevel(member.id);
          if (ablevel.levelOrder == this.ABLLevel) {
            for (let lev of this.offices[this.currentIndex].levels) {
              if (lev.levelOrder == this.ABLLevel) {
                this.offices[this.currentIndex].detailsLevel = lev;
              }
            }
          } else this.offices[this.currentIndex].detailsLevel = level;
        } else {
          this.offices[this.currentIndex].detailsLevel = level;
        }
        this.offices[this.currentIndex].detailsMember = member;

        this.$nextTick(function() {
          this.$modal.show("detailsDialog");
        });
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell getDetails", e);
      }
    },
    checkForDelete(member) {
      try {
        this.offices[this.currentIndex].deleteMember = member;

        this.$nextTick(() => {
          this.$modal.show("deleteDialog");
        });
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell checkForDelete", e);
      }
    },
    checkForRevokeAccess(member) {
      try {
        this.offices[this.currentIndex].deleteMember = member;
        this.$nextTick(() => {
          this.$modal.show("revokeAccessDialog");
        });
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell checkForRevokeAccess", e);
      }
    },
    checkForRestoreAccess(member) {
      try {
        this.offices[this.currentIndex].restoreMember = JSON.parse(
          JSON.stringify(member)
        );

        this.$nextTick(() => {
          this.$modal.show("restoreAccessDialog");
        });
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell checkForRestoreAccess", e);
      }
    },
    recalc() {
      try {
        this.recalculateConnectors();
        return 0;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell recalc", e);
        return 0;
      }
    },
    findMemberSupervisor(member) {
      try {
        if (member.parentId == null || member.parentId == member.id)
          return false;

        for (let level of this.offices[this.currentIndex].levels) {
          for (let mem of level.levelMembers) {
            if (mem.id == member.parentId) {
              member.supervisor = mem;
              member.supervisor.level = level.levelName;

              return true;
            }
          }
        }

        return false;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell findMemberSupervisor", e);
        return false;
      }
    },
    restoreMemberAccess(member) {
      this.waitFlag = true;
      // revoked marker
      HTTP.post(
        "revoke",
        {
          agentNum: member.id.toString(),
          company: this.$store.state.currentCompany,
          revokeFlag: false,
          updatedBy: this.$store.state.currentUser.name,
          updatedTime: new Date().toISOString()
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
        .then(response => {
          if (response.status == 200) {
            if (response.data.body) {
              let ret = JSON.parse(response.data.body);

              if (ret.get.data == "Active") {
                HTTP.post(
                  "record",
                  {
                    agentNum: member.id.toString(),
                    company: this.$store.state.currentCompany,
                    revokeFlag: false,
                    aoNum: this.offices[this.currentIndex].aoId,
                    updatedBy: this.$store.state.currentUser.name,
                    updatedTime: new Date().toISOString()
                  },
                  {
                    headers: {
                      "Content-Type": "application/json"
                    }
                  }
                ).then(response => {
                  if (response.status == 200) {
                    this.restoreMemberAccessUI(member);
                  } else {
                    this.$modal.show("errorModal");
                  }

                  this.waitFlag = false;
                });
              } else {
                this.waitFlag = false;
                this.$modal.show("errorModal");

                try {
                  this.addToErrorLogs(
                    "swimlanes-shell moveToRevoked POST /revoke",
                    new Error(JSON.stringify(response))
                  );
                } catch (e) {
                  this.addToErrorLogs(
                    "swimlanes-shell moveToRevoked POST /revoke",
                    new Error("Response status: " + response.status.toString())
                  );
                  this.addToErrorLogs(
                    "swimlanes-shell moveToRevoked POST /revoke",
                    e
                  );
                }
              }
            }
          }
        })
        .catch(e => {
          this.waitFlag = false;
          this.$modal.show("errorModal");
          this.addToErrorLogs("swimlanes-shell moveToRevoked POST /revoke", e);
        });
    },
    restoreMemberAccessUI(member) {
      try {
        for (
          let officeIndex = 0;
          officeIndex < this.offices.length;
          officeIndex++
        ) {
          let revokedIdx = this.offices[officeIndex].revokedAgents.findIndex(
            r => r.id == member.id
          );

          if (revokedIdx >= 0)
            this.offices[officeIndex].revokedAgents.splice(revokedIdx, 1);

          this.addToRevokedLog(member, false);

          EventBus.$emit(
            "indexChange",
            this.offices[this.currentIndex].levelReports,
            this.offices[this.currentIndex].levels,
            this.offices[this.currentIndex].agentPool,
            this.offices[this.currentIndex].revokedAgents,
            this.currentIndex
          );

          // let curAO_Id = this.offices[officeIndex].levels[0].levelMembers[0].id;

          // if (member.id != curAO_Id) {
          // member.parentId = curAO_Id;
          // this.offices[officeIndex].agentPool.push(member);

          // this.addToChangeLogMultiOffice(
          //   member,
          //   this.offices[officeIndex].levels[0].levelMembers[0],
          //   null,
          //   true,
          //   officeIndex,
          //   false
          // );
          // } else {
          //   EventBus.$emit("setAORevokedStatus", false);

          //   // AO
          //   this.addToChangeLogMultiOffice(
          //     member,
          //     null,
          //     0,
          //     false,
          //     officeIndex,
          //     false
          //   );
          // }
        }
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell restoreMemberAccess", e);
      }
    },
    moveToRevoked(memberIn, retry) {
      this.waitFlag = true;
      // revoked marker
      HTTP.post(
        "revoke",
        {
          agentNum: memberIn.id.toString(),
          company: this.$store.state.currentCompany,
          revokeFlag: true,
          updatedBy: this.$store.state.currentUser.name,
          updatedTime: new Date().toISOString()
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
        .then(response => {
          if (
            response.data &&
            response.data.errorMessage == "Request failed with status code 404"
          ) {
            this.addToErrorLogs(
              "swimlanes-shell moveToRevoked revoke post",
              response.data.errorMessage
            );
            this.$modal.show("revokeNotFoundModal");
            this.waitFlag = false;
            return;
          }

          if (response.status == 200) {
            if (response.data && response.data.body) {
              let ret = JSON.parse(response.data.body);

              if (ret.message == "Request failed with status code 404") {
                this.addToErrorLogs(
                  "swimlanes-shell moveToRevoked revoke post",
                  ret.message
                );
                this.$modal.show("revokeNotFoundModal");
                this.waitFlag = false;
                return;
              }

              if (ret && ret.get && ret.get.data == "InActive") {
                HTTP.post(
                  "record",
                  {
                    agentNum: memberIn.id.toString(),
                    company: this.$store.state.currentCompany,
                    revokeFlag: true,
                    aoNum: this.offices[this.currentIndex].aoId,
                    updatedBy: this.$store.state.currentUser.name,
                    updatedTime: new Date().toISOString()
                  },
                  {
                    headers: {
                      "Content-Type": "application/json"
                    }
                  }
                ).then(async response => {
                  if (response.status == 200) {
                    // revoke marker
                    await API.graphql(
                      graphqlOperation(mutations.broadcastRevoke, {
                        input: {
                          id: memberIn.id,
                          FirstName: "",
                          MiddleName: "",
                          LastName: memberIn.name,
                          TMKClientID: "",
                          AgencyCode: this.offices[this.currentIndex]
                            .agencyCode,
                          AgentNum: memberIn.agentNum,
                          AgentNumPrimary: memberIn.agentNum,
                          ManagerAgentNumPrimary: memberIn.parentId,
                          AOAgentNumPrimary: this.offices[this.currentIndex]
                            .aoId,
                          IsUnassigned: memberIn.IsUnassigned,
                          ModifiedDate: new Date(),
                          RoleId: 0,
                          RoleAbbr: ""
                        }
                      })
                    ).catch(e => {
                      this.addToErrorLogs(
                        "swimlanes-shell moveToRevoked broadcastRevoke",
                        e
                      );
                      // this.$modal.show("errorModal");
                      return;
                    });

                    this.moveToRevokedUIUpdates(memberIn);
                  } else {
                    this.$modal.show("errorModal");
                    this.addToErrorLogs(
                      "swimlanes-shell moveToRevoked broadcastRevoke",
                      new Error(JSON.stringify(response))
                    );
                  }

                  this.waitFlag = false;
                });
              } else {
                this.addToErrorLogs(
                  "swimlanes-shell moveToRevoked POST /revoke",
                  new Error("Response status: " + response.status.toString())
                );
                this.$modal.show("errorModal");
              }
            } else {
              this.addToErrorLogs(
                "swimlanes-shell moveToRevoked POST /revoke",
                new Error("Response status: " + response.status.toString())
              );
              this.$modal.show("errorModal");
            }
            this.waitFlag = false;
          } else {
            this.waitFlag = false;
            this.$modal.show("errorModal");

            try {
              this.addToErrorLogs(
                "swimlanes-shell moveToRevoked POST /revoke",
                new Error(JSON.stringify(response))
              );
            } catch (e) {
              this.addToErrorLogs(
                "swimlanes-shell moveToRevoked POST /revoke",
                new Error("Response status: " + response.status.toString())
              );
              this.addToErrorLogs(
                "swimlanes-shell moveToRevoked POST /revoke",
                e
              );
            }
          }
        })
        .catch(e => {
          if (retry == 0) return this.moveToRevoked(memberIn, 1);

          this.waitFlag = false;
          this.$modal.show("errorModal");
          this.addToErrorLogs("swimlanes-shell moveToRevoked POST /revoke", e);
        });
    },
    moveToRevokedUIUpdates(memberIn) {
      try {
        let member = JSON.parse(JSON.stringify(memberIn));

        for (
          let officeIndex = 0;
          officeIndex < this.offices.length;
          officeIndex++
        ) {
          let revokedIdx = this.offices[officeIndex].revokedAgents.findIndex(
            r => r.id == member.id
          );
          if (revokedIdx < 0) {
            let idx = this.offices[officeIndex].agentPool.findIndex(
              a => a.id == member.id
            );

            if (idx >= 0) {
              // this.offices[officeIndex].agentPool.splice(idx, 1);
              // this.offices[officeIndex].agentPool[idx].newFlag = false;
              this.offices[officeIndex].revokedAgents.push(member);

              EventBus.$emit(
                "indexChange",
                this.offices[this.currentIndex].levelReports,
                this.offices[this.currentIndex].levels,
                this.offices[this.currentIndex].agentPool,
                this.offices[this.currentIndex].revokedAgents,
                this.currentIndex
              );

              this.addToRevokedLog(member, true);
            } else {
              let officeMember = this.findInHierarchyMultiOffice(
                member.id,
                officeIndex
              );

              if (officeMember) {
                // let parent = null;
                let parentId = officeMember.parentId;

                // if removing agency owner, replace with home office
                // if (parentId == null && member.id != -1) {
                //   for (let level of this.offices[officeIndex].levels) {
                //     if (level.levelOrder == 0) {
                //       level.levelMembers.push({
                //         id: -1,
                //         name: "Home Office",
                //         parentId: null
                //       });

                //       parentId = -1;
                //     }
                //   }
                // }

                // if not revoking AO access:
                // if (parentId != null) {
                // // find the member's parent
                // for (let level of this.offices[officeIndex].levels) {
                //   if (!parent)
                //     parent = level.levelMembers.find((l) => l.id == parentId);
                // }
                // // move the member's children to the member's parent
                // for (let level of this.offices[officeIndex].levels) {
                //   for (let mem of level.levelMembers) {
                //     if (mem.parentId == officeMember.id) {
                //       this.moveHierarchyMultiOffice(
                //         mem,
                //         parent,
                //         level.levelOrder,
                //         officeIndex
                //       );
                //     }
                //   }
                // }
                // this.removeFromHierarchyMultiOffice(officeMember, officeIndex);
                // this.removeLevelReportMultiOffice(officeMember, officeIndex);
                // EventBus.$emit("removeConnectors", officeMember, officeIndex);
                // } else {
                if (parentId == null || parentId == officeMember.id) {
                  this.aoRevoked = true;
                  EventBus.$emit("setAORevokedStatus", true);
                }

                this.offices[officeIndex].revokedAgents.push(officeMember);

                EventBus.$emit(
                  "indexChange",
                  this.offices[this.currentIndex].levelReports,
                  this.offices[this.currentIndex].levels,
                  this.offices[this.currentIndex].agentPool,
                  this.offices[this.currentIndex].revokedAgents,
                  this.currentIndex
                );

                this.addToRevokedLog(officeMember, true);

                // recalculate the connector positions
                if (officeIndex == this.currentIndex) this.recalc();
              } else {
                this.offices[officeIndex].revokedAgents.push(member);

                EventBus.$emit(
                  "indexChange",
                  this.offices[this.currentIndex].levelReports,
                  this.offices[this.currentIndex].levels,
                  this.offices[this.currentIndex].agentPool,
                  this.offices[this.currentIndex].revokedAgents,
                  this.currentIndex
                );

                this.addToRevokedLog(member, true);
              }
            }
          }
        }
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell moveToRevoked", e);
      }
    },

    copyToRevoked(memberIn) {
      try {
        let member = JSON.parse(JSON.stringify(memberIn));

        let revokedIdx = this.offices[
          this.currentIndex
        ].revokedAgents.findIndex(r => r.id == member.id);

        if (revokedIdx < 0) {
          this.offices[this.currentIndex].revokedAgents.push(member);

          EventBus.$emit(
            "indexChange",
            this.offices[this.currentIndex].levelReports,
            this.offices[this.currentIndex].levels,
            this.offices[this.currentIndex].agentPool,
            this.offices[this.currentIndex].revokedAgents,
            this.currentIndex
          );

          this.addToRevokedLog(member, true);

          let parentId = member.parentId;

          if (parentId == null || parentId == member.id) {
            this.aoRevoked = true;
            EventBus.$emit("setAORevokedStatus", true);
          }

          this.recalc();
        }
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell moveToRevoked", e);
      }
    },
    copyToUnassigned(member) {
      try {
        let agentIdx = this.offices[this.currentIndex].agentPool.findIndex(
          r => r.id == member.id
        );

        if (agentIdx < 0) {
          this.offices[this.currentIndex].agentPool.push(member);
        }
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell copyToUnassigned", e);
      }
    },
    moveToUnassigned(member) {
      try {
        let parent = null;
        let parentId = member.parentId;

        if (this.searchAgent && member.id == this.searchAgent.id) {
          $j("div").removeClass("highlight");
        }

        let level = this.findLevel(member.id);
        if (this.isAgencyUser && level.levelOrder <= this.AALevel) return;

        // if removing agency owner, replace with home office
        if ((parentId == null || parentId == member.id) && member.id != -1) {
          for (let level of this.offices[this.currentIndex].levels) {
            if (level.levelOrder == 0) {
              level.levelMembers.push({
                id: -1,
                name: "Home Office",
                parentId: null,
                newFlag: false
              });

              parentId = -1;
            }
          }
        }

        // find the member's parent
        for (let level of this.offices[this.currentIndex].levels) {
          if (!parent) parent = level.levelMembers.find(l => l.id == parentId);
        }

        let children = [];

        //move the member's children to the member's parent ***
        for (let level of this.offices[this.currentIndex].levels) {
          for (let mem of level.levelMembers) {
            if (mem.parentId == member.id) {
              children.push({ child: mem, level: level });
            }
          }
        }

        for (let child of children) {
          this.moveHierarchy(child.child, parent, child.level.levelOrder);
        }

        this.removeFromHierarchy(member);
        this.removeLevelReport(member);

        EventBus.$emit("removeConnectors", member, this.currentIndex);

        this.offices[this.currentIndex].agentPool.push(member);

        if (level.levelOrder > this.crossOfficeMaxLevel) {
          // AB, ABL or Agent, add back to pool in every office
          this.addToOtherAgentPools(member.id);
        }

        if (level.levelOrder == this.crossOfficeMaxLevel) {
          // AA
          for (let idx = 0; idx < this.offices.length; idx++) {
            if (idx != this.currentIndex) {
              this.moveToUnassignedMultiOffice(member, idx, true);
              this.removeFromChangeLogMultiOffice(member, idx);
            }
          }
        }

        this.addToChangeLogMultiOffice(
          member,
          this.offices[this.currentIndex].levels[0].levelMembers[0],
          null,
          true,
          this.currentIndex
        );
        // recalculate the connector positions
        // this.recalc();
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell moveToUnassigned", e);
      }
    },
    moveAllowed(agent, selectedLevelOrder) {
      try {
        if (this.findInHierarchy(agent.id) == null) return true;

        for (let level of this.offices[this.currentIndex].levels) {
          for (let member of level.levelMembers) {
            if (member.parentId == agent.id) {
              if (level.levelOrder < selectedLevelOrder) {
                if (
                  (level.levelOrder == this.ABLLevel ||
                    level.levelOrder == this.ABLevel) &&
                  (selectedLevelOrder == this.ABLLevel ||
                    selectedLevelOrder == this.ABLevel)
                ) {
                  continue;
                }
                this.$modal.show("minLevelExceeded");

                // this.offices[this.currentIndex].minLevelExceeded = true;
                return false;
              }
            }
          }
        }
        return true;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell moveAllowed", e);
        return false;
      }
    },
    dragStart() {
      try {
        if (!this.multiSelect)
          this.offices[this.currentIndex].selectedAgents = [];
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell dragStart", e);
      }
    },
    dragEnd(e) {
      if (e.originalEvent.target == null) return;
      this.waitFlag = true;
      // find source element
      let sourceId = e.item.id.split("_")[1];
      // if (!sourceId) sourceId = e.items[0].id.replace("_", "");
      let targetId = e.originalEvent.target.id.split("_")[1];

      if (sourceId == targetId) {
        this.waitFlag = false;
        return;
      }
      this.handleDragEnd(sourceId, targetId);
    },
    handleDragEnd(sourceId, targetId) {
      try {
        if (sourceId == this.offices[this.currentIndex].aoId) {
          this.waitFlag = false;
          this.$modal.show("dropPreventedAO");
          return;
        }

        for (let level of this.offices[this.currentIndex].levels) {
          for (let mem of level.levelMembers) {
            if (mem.id == sourceId) {
              if (agent == undefined) {
                agent = mem;
                if (level.levelOrder == this.AOLevel) {
                  this.waitFlag = false;
                  return;
                } else if (
                  level.levelOrder == this.AALevel &&
                  this.isAgencyUser
                ) {
                  this.waitFlag = false;
                  this.$modal.show("dropPreventedFromAA");
                  return;
                }
              }
            }
          }
        }

        let agent = this.offices[this.currentIndex].agentPool.find(
          a => a.id == sourceId
        );

        if (agent && this.isAgencyUser && agent.levelOrder == this.AALevel) {
          this.waitFlag = false;
          this.$modal.show("dropPreventedAA");
          return;
        }

        if (agent && this.multiSelect) {
          for (let idx of this.offices[this.currentIndex].selectedAgents) {
            this.offices[this.currentIndex].agentsToAdd.push(
              this.sortedAgentPool[idx]
            );
          }

          if (
            this.offices[this.currentIndex].agentsToAdd.findIndex(
              a => a.id == agent.id
            ) < 0
          ) {
            this.offices[this.currentIndex].agentsToAdd.push(agent);
          }

          let dropTarget = null;
          let dropTargetLevel = null;

          for (let level of this.offices[this.currentIndex].levels) {
            for (let mem of level.levelMembers) {
              if (mem.id == sourceId) {
                if (agent == undefined) {
                  agent = mem;
                  if (level.levelOrder == 0) {
                    this.waitFlag = false;
                    return;
                  }
                }
              }
              if (mem.id == targetId) {
                dropTarget = mem;
                dropTargetLevel = level.levelOrder;
              }
            }
          }

          if (dropTargetLevel == this.AALevel) {
            this.$modal.show("dropPreventedAA");
            this.waitFlag = false;
            return;
          }

          if (dropTargetLevel == this.offices[this.currentIndex].maxLevel) {
            // this.offices[this.currentIndex].maxLevelExceeded = true;
            this.waitFlag = false;
            this.$modal.show("maxLevelExceeded");
            return;
          }

          // marker

          this.offices[this.currentIndex].source = agent;
          this.offices[this.currentIndex].target = dropTarget;

          if (
            !this.offices[this.currentIndex].source ||
            !this.offices[this.currentIndex].target
          ) {
            this.waitFlag = false;
            return;
          }
          // levelNames represents the number of levels that this agent can
          // potentially be dropped into, 1 means only the agent level is possible,
          // so allow an auto-drop.
          if (this.levelNames.length == 1) {
            let supe = null;

            for (let level of this.offices[this.currentIndex].levels) {
              for (let member of level.levelMembers) {
                if (member.id == this.offices[this.currentIndex].target.id) {
                  supe = member;
                }
              }
            }

            this.crossOfficeAgents = [];
            for (let agent of this.offices[this.currentIndex].agentsToAdd) {
              if (this.isInCrossOfficeRole(agent.id)) {
                this.crossOfficeAgents.push(agent.name);
              } else {
                if (supe) {
                  // move will be logged in moveSourceToTarget
                  this.moveSourceToTarget(
                    agent,
                    supe,
                    this.offices[this.currentIndex].agentLevel
                  );
                }
              }
            }
            if (this.crossOfficeAgents.length)
              this.$modal.show("crossOfficeMaxLevelExceeded");

            this.offices[this.currentIndex].selectedAgents = [];
            this.offices[this.currentIndex].agentsToAdd = [];

            this.waitFlag = false;
          } else {
            this.offices[this.currentIndex].levelSelectionDialog = true;
            this.waitFlag = false;
            this.$modal.show("levelSelectionDialog");

            if (this.$refs.selectionForm) this.$refs.selectionForm.reset();
          }
        } else {
          let dropTarget = null;
          let dropTargetLevel = null;

          for (let level of this.offices[this.currentIndex].levels) {
            for (let mem of level.levelMembers) {
              if (mem.id == sourceId) {
                if (agent == undefined) {
                  agent = mem;
                  if (level.levelOrder == 0) return;
                }
              }
              if (mem.id == targetId) {
                dropTarget = mem;
                dropTargetLevel = level.levelOrder;
              }
            }
          }

          if (this.isInCrossOfficeRole(sourceId)) {
            if (dropTargetLevel > this.crossOfficeMaxLevel) {
              this.crossOfficeAgents = [agent.name];
              this.waitFlag = false;
              this.$modal.show("crossOfficeMaxLevelExceeded");
              // Cannot drop AO/AA in lower level

              return;
            }
          }

          if (dropTargetLevel == this.AALevel) {
            this.waitFlag = false;
            this.$modal.show("dropPreventedAA");
            return;
          }

          if (dropTargetLevel == this.offices[this.currentIndex].maxLevel) {
            // this.offices[this.currentIndex].maxLevelExceeded = true;
            this.waitFlag = false;
            this.$modal.show("maxLevelExceeded");
            return;
          }

          this.offices[this.currentIndex].source = agent;
          this.offices[this.currentIndex].target = dropTarget;

          if (
            !this.offices[this.currentIndex].source ||
            !this.offices[this.currentIndex].target
          ) {
            this.waitFlag = false;
            return;
          }
          // levelNames represents the number of levels that this agent can
          // potentially be dropped into, 1 means only the agent level is possible,
          // so allow an auto-drop.
          if (this.levelNames.length == 1) {
            this.offices[
              this.currentIndex
            ].selectedLevel = this.levelNames[0].value;

            if (
              this.moveAllowed(
                agent,
                this.offices[this.currentIndex].selectedLevel
              )
            ) {
              this.moveSourceToTarget(
                agent,
                dropTarget,
                this.levelNames[0].value
              );
            }
            this.waitFlag = false;
          } else {
            this.offices[this.currentIndex].levelSelectionDialog = true;
            this.waitFlag = false;
            this.$modal.show("levelSelectionDialog");

            if (this.$refs.selectionForm) this.$refs.selectionForm.reset();
          }
        }
      } catch (e) {
        this.waitFlag = false;
        this.$modal.show("errorModal");
        this.addToErrorLogs("swimlanes-shell dragEnd", e);
      }
    },
    removeFromOtherAgentPools(id) {
      try {
        for (let index = 0; index < this.offices.length; index++) {
          if (index != this.currentIndex) {
            let idx = this.offices[index].agentPool.findIndex(
              ap => ap.id == id
            );

            if (idx >= 0) this.offices[index].agentPool.splice(idx, 1);

            // remove from change log for this office:
            this.removeFromChangeLogMultiOffice({ id: id }, index);
          }
        }
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell removeFromOtherAgentPools", e);
      }
    },
    addToOtherAgentPools(id) {
      try {
        let node = this.findInUnassigned(id);

        if (node) {
          for (let index = 0; index < this.offices.length; index++) {
            if (index != this.currentIndex) {
              let localNode = this.findInUnassignedMultiOffice(id, index);

              if (localNode == null) {
                this.offices[index].agentPool.push(node);

                this.addToChangeLogMultiOffice(
                  node,
                  this.offices[index].levels[0].levelMembers[0],
                  null,
                  true,
                  index
                );
              }
            }
          }
        }
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell addToOtherAgentPools", e);
      }
    },
    isNotInAnyOfficeHierarchy(id) {
      try {
        let node = null;

        for (let index = 0; index < this.offices.length; index++) {
          if (!node) node = this.findInHierarchyMultiOffice(id, index);
        }

        if (node) {
          return false;
        }

        return true;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell isNotInAnyOfficeHierarchy", e);
        return true;
      }
    },
    isInCrossOfficeRole(id) {
      if (this.offices.length < 2) return false;

      try {
        for (let index = 0; index < this.offices.length; index++) {
          if (index != this.currentIndex) {
            let node = this.findInHierarchyMultiOffice(id, index);

            if (node) {
              let level = this.findLevelMultiOffice(node.id, index);

              if (level.levelOrder <= this.crossOfficeMaxLevel) {
                return true;
              }
            }
          }
        }

        return false;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell isInCrossOfficeRole", e);
        return false;
      }
    },
    isInSingularOfficeRole(id) {
      try {
        for (let index = 0; index < this.offices.length; index++) {
          if (index != this.currentIndex) {
            let node = this.findInHierarchyMultiOffice(id, index);

            if (node) {
              let level = this.findLevelMultiOffice(node.id, index);

              if (level.levelOrder > this.crossOfficeMaxLevel) {
                return true;
              }
            }
          }
        }

        return false;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell isInSingularOfficeRole", e);
        return false;
      }
    },
    roleSelected() {
      try {
        // if there's more than one available role
        // and the role wasn't selected, return

        if (
          this.levelNames.length > 1 &&
          this.offices[this.currentIndex].levelSelectionDialog &&
          this.$refs.selectionForm &&
          !this.$refs.selectionForm.validate()
        ) {
          return;
        }

        this.waitFlag = true;
        // close the dialog
        this.offices[this.currentIndex].levelSelectionDialog = false;
        this.$modal.hide("levelSelectionDialog");

        let agent = this.offices[this.currentIndex].agentPool.find(
          a => a.id == this.offices[this.currentIndex].source.id
        );

        // if (this.offices[this.currentIndex].selectedLevel < 0) {
        //   for (let level of this.offices[this.currentIndex].levels) {
        //     if (
        //       level.levelOrderAlt ==
        //       this.offices[this.currentIndex].selectedLevel
        //     ) {
        //       agent.levelOrderAlt = level.levelOrderAlt;
        //       agent.levelNameAlt = level.levelNameAlt;
        //       this.offices[this.currentIndex].selectedLevel = level.levelOrder;
        //     }
        //   }
        // }

        // if moving to AA level with hierarchy and the move node has children
        // don't allow the move

        if (
          this.offices[this.currentIndex].moveHierFlag &&
          this.offices[this.currentIndex].selectedLevel == this.AALevel
        ) {
          let hasChildren = false;

          for (let levRep of this.offices[this.currentIndex].levelReports) {
            if (levRep.parentId == this.offices[this.currentIndex].source.id)
              hasChildren = true;
          }

          if (hasChildren) {
            this.$modal.show("dropPreventedAA2");
            this.waitFlag = false;
            return;
          }
        }

        if (this.multiSelect && agent) {
          // marker 2

          let supe = null;

          for (let level of this.offices[this.currentIndex].levels) {
            for (let member of level.levelMembers) {
              if (member.id == this.offices[this.currentIndex].target.id) {
                supe = member;
              }
            }
          }

          this.crossOfficeAgents = [];
          for (let agent of this.offices[this.currentIndex].agentsToAdd) {
            if (this.isInCrossOfficeRole(agent.id)) {
              this.crossOfficeAgents.push(agent.name);
            } else {
              if (supe) {
                // move will be logged in moveSourceToTarget
                this.moveSourceToTarget(
                  agent,
                  supe,
                  this.offices[this.currentIndex].selectedLevel
                );

                if (
                  this.offices[this.currentIndex].selectedLevel == this.AALevel
                ) {
                  // adding an AA, add to all other agencies under the AO:
                  for (let idx = 0; idx < this.offices.length; idx++) {
                    if (idx != this.currentIndex) {
                      this.moveSourceToTargetMultiOffice(
                        agent,
                        supe,
                        this.AALevel,
                        idx
                      );
                    }
                  }
                }
              }
            }
          }
          if (this.crossOfficeAgents.length)
            this.$modal.show("crossOfficeMaxLevelExceeded");

          this.offices[this.currentIndex].selectedAgents = [];
          this.offices[this.currentIndex].agentsToAdd = [];
        } else {
          if (
            this.isInCrossOfficeRole(this.offices[this.currentIndex].source.id)
          ) {
            if (
              this.offices[this.currentIndex].selectedLevel >
              this.crossOfficeMaxLevel
            ) {
              this.crossOfficeAgents = [
                this.offices[this.currentIndex].source.name
              ];
              this.waitFlag = false;
              this.$modal.show("crossOfficeMaxLevelExceeded");
              // Cannot drop AO/AA in lower level
              return;
            }
          }

          // move the agent to the new role
          this.moveSourceToTarget(
            this.offices[this.currentIndex].source,
            this.offices[this.currentIndex].target,
            this.offices[this.currentIndex].selectedLevel
          );

          if (this.offices[this.currentIndex].selectedLevel == this.AALevel) {
            // adding an AA, add to all other agencies under the AO:
            for (let idx = 0; idx < this.offices.length; idx++) {
              if (idx != this.currentIndex) {
                this.moveSourceToTargetMultiOffice(
                  this.offices[this.currentIndex].source,
                  this.offices[idx].levels[0].levelMembers[0],
                  this.AALevel,
                  idx
                );
              }
            }
          }
        }
        this.waitFlag = false;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell roleSelected", e);
      }
    },
    moveSourceToTarget(child, parent, newLevel) {
      try {
        if (child == null || newLevel == null) {
          return;
        }
        if (this.offices[this.currentIndex].moveHierFlag) {
          if (
            this.offices[this.currentIndex].agentPool.find(
              a => a.id == child.id
            ) == undefined
          ) {
            // if the agent is in the hierarchy, move him/her to the unassigned pool
            if (this.moveAllowed(child, newLevel) && parent) {
              this.moveHierarchy(child, parent, newLevel);
            }
          } else {
            // moving un-assigned agent into hierarchy
            this.moveFromUnassignedToHier(child, parent, newLevel);
          }
        } else {
          if (
            this.offices[this.currentIndex].agentPool.find(
              a => a.id == child.id
            ) == undefined
          ) {
            // if the agent is in the hierarchy, move him/her to the unassigned pool
            this.moveToUnassigned(child); // re-assign the children of the child to the next parent up and move the child to the unassigned pool
            this.moveFromUnassignedToHier(child, parent, newLevel); // move from the unassigned pool back into the hierarchy in the new position
          } else {
            // moving un-assigned agent into hierarchy
            this.moveFromUnassignedToHier(child, parent, newLevel);
          }
        }

        let selectedLevel = this.offices[this.currentIndex].levels.find(
          l => l.levelOrder == newLevel
        );

        if (newLevel > this.crossOfficeMaxLevel) {
          this.removeFromOtherAgentPools(child.id);
        }

        this.addToChangeLogMultiOffice(
          child,
          parent,
          selectedLevel,
          false,
          this.currentIndex
        );
        // if (this.searchAgent && child.id == this.searchAgent.id) {
        //   this.$nextTick().then(() => {
        //     this.memberToScrollTo = null;
        //     this.$nextTick().then(() => {
        //       this.memberToScrollTo = child;
        //       this.searchAgent = child;
        //     });
        //   });
        // }
        this.$nextTick().then(() => {
          this.memberToHighlight = null;
          this.$nextTick().then(() => {
            this.memberToHighlight = this.searchAgent;
          });
        });
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell moveSourceToTarget", e);
      }
    },

    moveFromUnassignedToHier(unassignedNode, newParent, newLevel) {
      try {
        // find the unassigned node in the agent pool
        let agentIdx = this.offices[this.currentIndex].agentPool.findIndex(
          a => a.id == unassignedNode.id
        );

        // find the level of the new parent
        let parentLevelOrder = 0;

        if (newParent) {
          for (let level of this.offices[this.currentIndex].levels) {
            for (let member of level.levelMembers) {
              if (member.id == newParent.id) {
                parentLevelOrder = level.levelOrder;
              }
            }
          }

          // set the unassigned node's parent id to the new parent's id
          unassignedNode.parentId = newParent.id;
        } else {
          unassignedNode.parentId = null;
        }

        // set the new flag to false since we're moving to the hierarchy
        unassignedNode.newFlag = false;

        // add the unassigned node to the new level's level members
        this.offices[this.currentIndex].levels
          .find(l => l.levelOrder == newLevel)
          .levelMembers.push(unassignedNode);

        // add the report between the unassigned node and its new parent

        if (newParent) {
          this.offices[this.currentIndex].levelReports.push({
            parentId: newParent.id,
            childId: unassignedNode.id
          });

          // add the connector between the newParent and the unassigned node
          this.addConnector(
            { level: parentLevelOrder, member: newParent },
            { level: newLevel, member: unassignedNode },
            this.currentIndex
          );
        }
        // recalculate the positions of the connectors

        // this.recalc();

        // remove the now assigned agent from the unassigned agent pool
        if (agentIdx >= 0)
          this.offices[this.currentIndex].agentPool.splice(agentIdx, 1);

        this.addToChangeLogMultiOffice(
          unassignedNode,
          newParent,
          this.offices[this.currentIndex].levels[newLevel],
          false,
          this.currentIndex
        );

        // if (this.searchAgent && this.searchAgent.id == unassignedNode.id) {
        //   this.$nextTick().then(() => {
        //     this.memberToScrollTo = null;
        //     this.$nextTick().then(() => {
        //       this.memberToScrollTo = unassignedNode;
        //       this.searchAgent = unassignedNode;
        //     });
        //   });
        // }
        this.$nextTick().then(() => {
          this.memberToHighlight = null;
          this.$nextTick().then(() => {
            this.memberToHighlight = this.searchAgent;
          });
        });
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell moveFromUnassignedToHier", e);
      }
    },

    copyNodeToHier(node, newParent, newLevel) {
      try {
        // find the level of the new parent
        let parentLevelOrder = 0;

        if (newParent) {
          for (let level of this.offices[this.currentIndex].levels) {
            for (let member of level.levelMembers) {
              if (member.id == newParent.id) {
                parentLevelOrder = level.levelOrder;
              }
            }
          }

          // set the unassigned node's parent id to the new parent's id
          node.parentId = newParent.id;
        } else {
          node.parentId = null;
        }

        // set the new flag to false since we're moving to the hierarchy
        node.newFlag = false;

        // add the unassigned node to the new level's level members
        this.offices[this.currentIndex].levels
          .find(l => l.levelOrder == newLevel)
          .levelMembers.push(node);

        // add the report between the unassigned node and its new parent

        if (newParent) {
          this.offices[this.currentIndex].levelReports.push({
            parentId: newParent.id,
            childId: node.id
          });

          // add the connector between the newParent and the unassigned node
          this.addConnector(
            { level: parentLevelOrder, member: newParent },
            { level: newLevel, member: node },
            this.currentIndex
          );
        }
        // recalculate the positions of the connectors

        // this.recalc();

        this.addToChangeLogMultiOffice(
          node,
          newParent,
          this.offices[this.currentIndex].levels[newLevel],
          false,
          this.currentIndex
        );
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell copyNodeToHier", e);
      }
    },

    async getEmployees(officeIndex, reload) {
      // reload = from database, !reload = office addition
      try {
        let employees;

        if (this.initialPool == null || reload) {
          employees = await API.graphql(
            graphqlOperation(queries.getUsersByAO, {
              aoNum: this.$store.state.currentAO.id,
              company: this.$store.state.currentCompany
            })
          ).catch(e => {
            this.addToErrorLogs("swimlanes-shell getEmployees", e);
            this.$modal.show("errorModal");
            return;
          });

          this.hierarchyLoadedTime = new Date();

          this.initialPool = [];
          this.initialPool = employees;
          this.savePool = [];
          this.savePool = employees.data.getUsersByAO;
        } else {
          employees = this.initialPool;
        }

        var aWeekAgo = new Date();
        aWeekAgo.setHours(aWeekAgo.getHours() - 7 * 24);

        await this.getRevokedUsers(this.$store.state.currentAO.id, officeIndex);

        for (let emp of employees.data.getUsersByAO) {
          // for (let emp of employees) {
          if (emp.AgencyCode != this.offices[officeIndex].agencyCode) {
            continue;
          }

          //           await API.graphql(
          //             graphqlOperation(queries.getNewIndicatorForAgentNum, {
          //               agentNum: emp.AgentNum,
          //               days: '7',
          //             })
          //           ).then(results =>{
          // console.log(results);

          //           }).catch((e) => {
          //             this.addToErrorLogs("swimlanes-shell getNewIndicatorForAgentNum", e);
          //             this.$modal.show("errorModal");
          //             return;
          //           });

          let newFlag;
          let modDate;
          try {
            modDate = new Date(emp.ModifiedDate);
            if (modDate > aWeekAgo && emp.IsUnassigned) {
              newFlag = true;
            }
          } catch (e) {
            this.addToErrorLogs("getEmployees", e);
            newFlag = false;
          }

          let found = this.findInHierarchyMultiOffice(
            emp.AgentNum,
            officeIndex
          );

          if (!found) {
            for (let level of this.offices[officeIndex].levels) {
              if (level.abbr == emp.RoleAbbr) {
                let node = {
                  id: parseInt(emp.AgentNumPrimary),
                  parentId: emp.ManagerAgentNumPrimary,
                  name:
                    emp.LastName == "Office" && emp.FirstName == "Home"
                      ? "Home Office"
                      : (
                          (
                            (emp.LastName ? emp.LastName : "") +
                            ", " +
                            (emp.FirstName ? emp.FirstName : "")
                          ).trim() +
                          " " +
                          (emp.MiddleName ? emp.MiddleName : "")
                        ).trim(),
                  agencyCode: emp.AgencyCode,
                  agentNum: emp.AgentNumPrimary,
                  spriteCssClass: "mdi mdi-account",
                  newFlag: newFlag,
                  terminationDate:
                    emp.TerminationDate != null && emp.TerminationDate != "null"
                      ? emp.TerminationDate
                      : "",
                  isUnassigned: false
                };

                // if (node.agentNum == "32456" || node.agentNum == "49940") {
                //   node.newFlag = true;
                // }

                level.levelMembers.push(node);

                if (
                  this.offices[officeIndex].dbRevoked.findIndex(
                    r => r.PrimaryAgentNum == node.agentNum
                  ) >= 0
                ) {
                  this.offices[officeIndex].revokedAgents.push(node);
                }

                this.offices[officeIndex].levelReports.push({
                  parentId: node.parentId,
                  childId: node.id
                });

                if (!reload) {
                  // if office add, make sure we have a change log for saving:
                  this.addToChangeLogMultiOffice(
                    node,
                    { id: node.parentId },
                    level,
                    false,
                    officeIndex
                  );
                }
              }
            }
          }
        }

        if (this.offices[officeIndex].levels[0].levelMembers.length == 0) {
          this.offices[officeIndex].levels[0].levelMembers.push({
            id: this.$store.state.currentAO.id,
            name: this.$store.state.currentAO.name,
            parentId: null,
            agencyCode: "",
            agentNum: "",
            newFlag: false,
            terminationDate: ""
          });
        }
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell getEmployees", e);
      }
    },
    addConnector(parent, child, officeIndex) {
      try {
        EventBus.$emit("addConnector", parent, child, officeIndex);
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell addConnector", e);
      }
    },
    recalculateConnectors() {
      try {
        EventBus.$emit("recalculateConnectors", this.currentIndex);
        return 0;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell recalculateConnectors", e);
        return 0;
      }
    },
    buildStyle(connector) {
      try {
        if (connector.style == undefined) return "";

        for (let level of this.offices[this.currentIndex].levels) {
          for (let member of level.levelMembers) {
            if (connector.ele1ref == this.buildRef(member)) {
              connector.color = this.offices[this.currentIndex].connectorColors[
                level.levelOrder
              ];
            }
          }
        }

        let top = connector.style.originY + 15; // + connector.style.adj1hp;

        return (
          "left: " +
          connector.style.originX +
          "px;" +
          "height: " +
          connector.style.l +
          "px;" +
          "width: 0px;" +
          "top: " +
          top +
          "px;" +
          "-webkit-transform: " +
          "rotate(" +
          connector.style.angle +
          "deg);" +
          "-moz-transform: " +
          "rotate(" +
          connector.style.angle +
          "deg);" +
          "-o-transform:  " +
          "rotate(" +
          connector.style.angle +
          "deg);" +
          "-ms-transform:  " +
          "rotate(" +
          connector.style.angle +
          "deg);" +
          "transform:  " +
          "rotate(" +
          connector.style.angle +
          "deg);" +
          "transform-origin: '0 " +
          -1 * connector.style.adj1hp +
          "px';" +
          "border-left: 3px dashed " +
          connector.color +
          ";"
        );
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell buildStyle", e);
      }
    },
    removeLevelReportMultiOffice(node, officeIndex) {
      try {
        let idx = this.offices[officeIndex].levelReports.find(
          l => l.childId == node.id
        );
        if (idx >= 0) this.offices[officeIndex].levelReports.splice(idx, 1);
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell removeLevelReportMultiOffice", e);
      }
    },

    removeFromChangeLogMultiOffice(node, officeIndex) {
      try {
        if (!node || node.id == -1 || node.name == "Home Office") return;

        let idx = this.offices[officeIndex].changeLog.findIndex(
          cl => cl.id == node.id
        );

        if (idx >= 0) {
          this.offices[officeIndex].changeLog.splice(idx, 1);
        }
      } catch (e) {
        this.addToErrorLogs(
          "swimlanes-shell removeFromChangeLogMultiOffice",
          e
        );
      }
    },
    addToChangeLogMultiOffice(
      node,
      newparent,
      newlevel,
      unassignedFlag,
      officeIndex
    ) {
      try {
        if (!node || node.id == -1 || node.name == "Home Office") return;

        // try {
        //   if (newlevel && !newlevel.levelname) {
        //     if (!isNaN(parseInt(newlevel))) {
        //       newlevel = this.offices[officeIndex].levels[parseInt(newlevel)];
        //     }
        //   }
        // } catch (e) {
        //   this.addToErrorLogs("swimlanes-shell addToChangeLogMultiOffice", e);
        //   newlevel = null;
        // }

        if (unassignedFlag == true) {
          newlevel = this.offices[officeIndex].levels[
            this.offices[officeIndex].agentLevel
          ];
        } else if (!newlevel || !newlevel.levelName) {
          let change = {
            node: node,
            newparent: newparent,
            newlevel: newlevel,
            unassignedFlag: unassignedFlag,
            officeIndex: officeIndex
          };

          this.addToErrorLogs(
            "addToChangeLogMultiOffice",
            new Error("new level not specified: " + JSON.stringify(change))
          );
        }

        let change = {
          id: node.id,
          name: node.name,
          parentId: newparent ? newparent.id : null,
          level: newlevel && newlevel.levelName ? newlevel.levelName : null,
          abbr: newlevel && newlevel.abbr ? newlevel.abbr : null,
          unassigned: unassignedFlag
        };

        let idx = this.offices[officeIndex].changeLog.findIndex(
          cl => cl.id == node.id
        );

        if (idx >= 0)
          this.offices[officeIndex].changeLog.splice(idx, 1, change);
        else this.offices[officeIndex].changeLog.push(change);
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell addToChangeLogMultiOffice", e);
      }
    },
    removeFromHierarchyMultiOffice(node, officeIndex) {
      try {
        for (let level of this.offices[officeIndex].levels) {
          let idx = level.levelMembers.findIndex(l => l.id == node.id);
          if (idx >= 0) {
            level.levelMembers.splice(idx, 1);
            break;
          }

          this.addToChangeLogMultiOffice(
            node,
            this.offices[officeIndex].levels[0].levelMembers[0],
            null,
            true,
            officeIndex
          );
        }
      } catch (e) {
        this.addToErrorLogs(
          "swimlanes-shell removeFromHierarhcyMultiOffice",
          e
        );
      }
    },
    // Find the node in the unassigned list based on its id
    findInUnassignedMultiOffice(id, officeIndex) {
      try {
        for (let agent of this.offices[officeIndex].agentPool) {
          if (agent.id == id) {
            return agent;
          }
        }
        return null;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell findInUnassignedMultiOffice", e);
        return null;
      }
    },
    // Find the node in the hierarchy based on its id
    findInHierarchyMultiOffice(id, officeIndex) {
      try {
        for (let level of this.offices[officeIndex].levels) {
          for (let mem of level.levelMembers) {
            if (mem.id == id) {
              return mem;
            }
          }
        }
        return null;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell findInHierarchyMultiOffice", e);
        return null;
      }
    },
    // Find the hierarchy level of a node based on its id
    findLevelMultiOffice(id, officeIndex) {
      try {
        for (let level of this.offices[officeIndex].levels) {
          for (let mem of level.levelMembers) {
            if (mem.id == id) {
              return level;
            }
          }
        }
        return null;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell findLevelMultiOffice", e);
        return null;
      }
    },
    // Swap out a node (this.replaceMember) with another node (id: this.selectedReplacement)
    moveNodesMultiOffice(officeIndex) {
      try {
        let inHier = false;

        // find the selected replacement in the unassigned agents list
        let selReplacement = this.findInUnassignedMultiOffice(
          this.offices[this.currentIndex].selectedReplacement, // from the current replacement
          officeIndex
        );

        // if it's not there, look for it in the hierarchy instead
        if (!selReplacement) {
          selReplacement = this.findInHierarchyMultiOffice(
            this.offices[this.currentIndex].selectedReplacement, // from the current replacement
            officeIndex
          );
          if (selReplacement) inHier = true;
        }

        if (!selReplacement) {
          this.offices[officeIndex].agentPool.push(
            this.offices[this.currentIndex].selectedReplacement
          );
          // copy from current hierarchy into agent pool
          selReplacement = this.findInUnassignedMultiOffice(
            this.offices[this.currentIndex].selectedReplacement, // from the current replacement
            this.currentIndex
          );
        }

        let memberToReplace = this.findInHierarchyMultiOffice(
          this.offices[this.currentIndex].replaceMember.id,
          officeIndex
        );

        if (!memberToReplace) return;

        // find the parent of the node-to-be-replaced in the hierarchy

        let parent = this.findInHierarchyMultiOffice(
          memberToReplace.parentId,
          officeIndex
        );

        // find the existing level of the node-to-be-replaced in the hierarchy
        let selLevel = this.findLevelMultiOffice(
          memberToReplace.id,
          officeIndex
        );

        // if trying to relocate a hierarchy tree to an incompatible level of the
        // hierarchy, show error dialog (from moveAllowed) and return
        if (
          !this.moveAllowedMultiOffice(
            selReplacement,
            selLevel.levelOrder,
            officeIndex
          )
        )
          return;

        if (inHier) {
          // if we're moving the entire hierarchy or the replacement node
          // is the child of the member to be replaced:

          if (
            this.offices[officeIndex].moveHierFlag ||
            selReplacement.parentId == memberToReplace.id
          ) {
            // remove the selected node from its current level

            this.removeFromHierarchyMultiOffice(selReplacement, officeIndex);
            EventBus.$emit(
              "removeParentConnectors",
              selReplacement,
              officeIndex
            );

            let idx = this.offices[officeIndex].levelReports.findIndex(
              l => (l.childId = selReplacement.id)
            );
            if (idx >= 0) this.offices[officeIndex].levelReports.splice(idx, 1);

            // add it to the replacement node's level
            for (let level of this.offices[officeIndex].levels) {
              if (level.levelOrder == selLevel.levelOrder) {
                selReplacement.parentId = memberToReplace.parentId;
                selReplacement.newFlag = false;
                level.levelMembers.push(selReplacement);
              }
            }

            this.addToChangeLogMultiOffice(
              selReplacement,
              {
                id: memberToReplace.parentId
              },
              selLevel,
              false,
              officeIndex
            );
          } else {
            // else if the parent of the member to be replaced is defined
            // and NOT equal to the selected replacement node

            if (parent && parent.id != selReplacement.id) {
              this.moveToUnassignedMultiOffice(
                selReplacement,
                officeIndex,
                true
              );
              this.moveSourceToTargetMultiOffice(
                selReplacement,
                parent,
                selLevel.levelOrder,
                officeIndex
              );

              this.addToChangeLogMultiOffice(
                selReplacement,
                parent,
                selLevel,
                false,
                officeIndex
              );
            } else {
              // either the selected replacement has no parent
              // or it's the parent of the member to be replaced.

              this.moveToUnassignedMultiOffice(
                selReplacement,
                officeIndex,
                true
              );

              // find the new parent of the node
              let revisedMember = this.findInHierarchyMultiOffice(
                memberToReplace.id,
                officeIndex
              );

              let newParent = this.findInHierarchyMultiOffice(
                revisedMember.parentId,
                officeIndex
              );

              // move the replacement node from the unassigned list to the new parent of the
              // member-to-be-replaced
              this.moveSourceToTargetMultiOffice(
                selReplacement,
                newParent,
                selLevel.levelOrder,
                officeIndex
              );

              this.addToChangeLogMultiOffice(
                selReplacement,
                newParent,
                selLevel,
                false,
                officeIndex
              );
            }
          }
        } else {
          // if the node is in the unassigned list, add it to the node-to-be-replaced's
          // level under the node-to-be-replaced's parent

          this.moveSourceToTargetMultiOffice(
            selReplacement,
            parent,
            selLevel.levelOrder,
            officeIndex
          );
          this.addToChangeLogMultiOffice(
            selReplacement,
            parent,
            selLevel,
            false,
            officeIndex
          );
        }

        // move the hierarchy of the node-to-be-replaced to the replacement node,
        // which is now in the hierarchy

        for (let level of this.offices[officeIndex].levels) {
          for (let mem of level.levelMembers) {
            if (mem.parentId == memberToReplace.id) {
              this.moveHierarchyMultiOffice(
                mem,
                selReplacement,
                level.levelOrder,
                officeIndex
              );
              this.addToChangeLogMultiOffice(
                mem,
                selReplacement,
                level,
                false,
                officeIndex
              );
            }
          }
        }

        // adjust the level reports, if the child id is the node-to-be-replaced
        // swap it out for the selected replacement

        for (let levelReport of this.offices[officeIndex].levelReports) {
          if (levelReport.child == memberToReplace.id) {
            levelReport.child = selReplacement.id;
          }
        }

        // remove the node-to-be-replaced from the level members
        this.removeFromHierarchyMultiOffice(memberToReplace, officeIndex);

        // remove the connectors to the node-to-be-replaced
        EventBus.$emit("removeConnectors", memberToReplace, officeIndex);

        // remove the level reports of the node-to-be-replaced
        this.removeLevelReportMultiOffice(memberToReplace, officeIndex);

        // add the node-to-be-replaced back to the unassigned pool
        if (memberToReplace.id != -1) {
          this.offices[officeIndex].agentPool.push(memberToReplace);
          // this.addToOtherAgentPools(memberToReplace.id);

          this.addToChangeLogMultiOffice(
            memberToReplace,
            this.offices[officeIndex].levels[0].levelMembers[0],
            null,
            true,
            officeIndex
          );
        }
        // recalculate the connector positions
        // this.recalcMultiOffice(officeIndex);
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell moveNodesMultiOffice", e);
      }
    },
    getDetailsMultiOffice(member, level, officeIndex) {
      try {
        if (level.levelOrder == this.ABLevel) {
          let ablevel = this.findLevel(member.id);
          if (ablevel.levelOrder == this.ABLLevel) {
            for (let lev of this.offices[officeIndex].levels) {
              if (lev.levelOrder == this.ABLLevel) {
                this.offices[officeIndex].detailsLevel = lev;
              }
            }
          }
        } else {
          this.offices[officeIndex].detailsLevel = level;
        }
        this.offices[officeIndex].detailsMember = member;
        this.offices[officeIndex].detailsDialog = true;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell getDetailsMultiOffice", e);
      }
    },
    checkForDeleteMultiOffice(member, officeIndex) {
      try {
        this.offices[officeIndex].deleteMember = member;
        this.$modal.show("deleteDialog");
        // this.offices[officeIndex].deleteDialog = true;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell checkForDeleteMultiOffice", e);
      }
    },
    findMemberSupervisorMultiOffice(member, officeIndex) {
      try {
        if (member.parentId == null || member.id == member.parentId)
          return false;

        for (let level of this.offices[officeIndex].levels) {
          for (let mem of level.levelMembers) {
            if (mem.id == member.parentId) {
              member.supervisor = mem;
              member.supervisor.level = level.levelName;

              return true;
            }
          }
        }

        return false;
      } catch (e) {
        this.addToErrorLogs(
          "swimlanes-shell findMemberSupervisorMultiOffice",
          e
        );
        return false;
      }
    },
    moveToUnassignedMultiOffice(member, officeIndex, skipSaveLog) {
      try {
        let parent = null;
        let parentId = member.parentId;

        // if removing agency owner, replace with home office
        if ((parentId == null || parentId == member.id) && member.id != -1) {
          for (let level of this.offices[officeIndex].levels) {
            if (level.levelOrder == 0) {
              level.levelMembers.push({
                id: -1,
                name: "Home Office",
                parentId: null,
                newFlag: false
              });

              parentId = -1;
            }
          }
        }

        // find the member's parent
        for (let level of this.offices[officeIndex].levels) {
          if (!parent) parent = level.levelMembers.find(l => l.id == parentId);
        }

        // move the member's children to the member's parent
        for (let level of this.offices[officeIndex].levels) {
          for (let mem of level.levelMembers) {
            if (mem.parentId == member.id) {
              this.moveHierarchyMultiOffice(
                mem,
                parent,
                level.levelOrder,
                officeIndex
              );
            }
          }
        }

        this.removeFromHierarchyMultiOffice(member, officeIndex);
        this.removeLevelReportMultiOffice(member, officeIndex);

        EventBus.$emit("removeConnectors", member, officeIndex);

        if (
          this.offices[officeIndex].agentPool.findIndex(
            ap => ap.id == member.id
          ) < 0
        )
          this.offices[officeIndex].agentPool.push(member);

        if (!skipSaveLog) {
          this.addToChangeLogMultiOffice(
            member,
            this.offices[officeIndex].levels[0].levelMembers[0],
            null,
            true,
            officeIndex
          );
        }

        // recalculate the connector positions
        //this.recalcMultiOffice(officeIndex);
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell moveToUnassignedMultiOffice", e);
      }
    },
    moveAllowedMultiOffice(agent, selectedLevelOrder, officeIndex) {
      try {
        if (!this.offices[officeIndex].moveHierFlag) return true;
        if (this.findInHierarchyMultiOffice(agent.id, officeIndex) == null)
          return true;

        for (let level of this.offices[officeIndex].levels) {
          for (let member of level.levelMembers) {
            if (member.parentId == agent.id) {
              if (level.levelOrder <= selectedLevelOrder) {
                this.$modal.show("minLevelExceeded");
                return false;
              }
            }
          }
        }
        return true;
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell moveAllowedMultiOffice", e);
        return false;
      }
    },
    moveSourceToTargetMultiOffice(child, parent, newLevel, officeIndex) {
      try {
        if (child == null || newLevel == null) {
          return;
        }
        if (this.offices[officeIndex].moveHierFlag) {
          if (
            this.offices[officeIndex].agentPool.find(a => a.id == child.id) ==
            undefined
          ) {
            // if the agent is in the hierarchy
            if (
              this.moveAllowedMultiOffice(child, newLevel, officeIndex) &&
              parent
            ) {
              this.moveHierarchyMultiOffice(
                child,
                parent,
                newLevel,
                officeIndex
              );
            }
          } else {
            // moving un-assigned agent into hierarchy
            this.moveFromUnassignedToHierMultiOffice(
              child,
              parent,
              newLevel,
              officeIndex
            );
          }
        } else {
          if (
            this.offices[officeIndex].agentPool.find(a => a.id == child.id) ==
            undefined
          ) {
            // if the agent is in the hierarchy, move him/her to the unassigned pool
            this.moveToUnassignedMultiOffice(child, officeIndex); // re-assign the children of the child to the next parent up and move the child to the unassigned pool
            this.moveFromUnassignedToHierMultiOffice(
              child,
              parent,
              newLevel,
              officeIndex
            ); // move from the unassigned pool back into the hierarchy in the new position
          } else {
            // moving un-assigned agent into hierarchy

            this.moveFromUnassignedToHierMultiOffice(
              child,
              parent,
              newLevel,
              officeIndex
            );
          }
        }

        let selectedLevel = this.offices[officeIndex].levels.find(
          l => l.levelOrder == newLevel
        );

        this.addToChangeLogMultiOffice(
          child,
          parent,
          selectedLevel,
          false,
          officeIndex
        );

        // if (this.searchAgent && child.id == this.searchAgent.id) {
        //   this.$nextTick().then(() => {
        //     this.memberToScrollTo = null;
        //     this.$nextTick().then(() => {
        //       this.memberToScrollTo = child;
        //       this.searchAgent = child;
        //     });
        //   });
        // }
        this.$nextTick().then(() => {
          this.memberToHighlight = null;
          this.$nextTick().then(() => {
            this.memberToHighlight = this.searchAgent;
          });
        });
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell moveSourceToTargetMultiOffice", e);
      }
    },
    moveHierarchyMultiOffice(node, newParent, newLevelOrder, officeIndex) {
      try {
        // Find the current node's level
        let currentLevel = this.findLevelMultiOffice(node.id, officeIndex);

        // if the current node's level is not the same as the new level
        if (currentLevel.levelOrder != newLevelOrder) {
          // ...remove the node from its current level's members array
          this.removeFromHierarchyMultiOffice(node, officeIndex);

          // ...and push it onto the members array of the new level
          for (let level of this.offices[officeIndex].levels) {
            if (level.levelOrder == newLevelOrder) {
              node.newFlag = false;
              level.levelMembers.push(node);
            }
          }
        }

        // Set the node's parent id to it's new parent's id
        for (let level of this.offices[officeIndex].levels) {
          for (let mem of level.levelMembers) {
            if (mem.id == node.id) {
              mem.parentId = newParent.id;
            }
          }
        }

        // Change the level reports to reflect the node's new parent
        for (let levRep of this.offices[officeIndex].levelReports) {
          if (levRep.childId == node.id) {
            levRep.parentId = newParent.id;
          }
        }

        EventBus.$emit("changeConnectorParent", node, newParent, officeIndex);

        let selLevel = this.findLevelMultiOffice(node.id, officeIndex);

        this.addToChangeLogMultiOffice(
          node,
          newParent,
          selLevel,
          false,
          officeIndex
        );
      } catch (e) {
        this.addToErrorLogs("swimlanes-shell moveHierarchyMultiOffice", e);
      }
    },
    moveFromUnassignedToHierMultiOffice(
      unassignedNode,
      newParent,
      newLevel,
      officeIndex
    ) {
      try {
        // find the unassigned node in the agent pool
        let agentIdx = this.offices[officeIndex].agentPool.findIndex(
          a => a.id == unassignedNode.id
        );

        if (newParent) {
          // set the unassigned node's parent id to the new parent's id
          unassignedNode.parentId = newParent.id;
        } else {
          unassignedNode.parentId = null;
        }

        // set the new flag to false since we're moving it into the hierarchy
        unassignedNode.newFlag = false;

        // add the unassigned node to the new level's level members
        this.offices[officeIndex].levels
          .find(l => l.levelOrder == newLevel)
          .levelMembers.push(unassignedNode);

        // add the report between the unassigned node and its new parent
        if (newParent) {
          this.offices[officeIndex].levelReports.push({
            parentId: newParent.id,
            childId: unassignedNode.id
          });

          let parentLevel = this.findLevelMultiOffice(
            newParent.id,
            officeIndex
          );

          // marker
          this.addConnector(
            { level: parentLevel.levelOrder, member: newParent },
            { level: newLevel, member: unassignedNode },
            officeIndex
          );
        }

        // remove the now assigned agent from the unassigned agent pool
        if (agentIdx >= 0)
          this.offices[officeIndex].agentPool.splice(agentIdx, 1);

        // this.recalc();

        // save the change to the change log
        this.addToChangeLogMultiOffice(
          unassignedNode,
          newParent,
          this.offices[officeIndex].levels[newLevel],
          false,
          officeIndex
        );

        // if (this.searchAgent && this.searchAgent.id == unassignedNode.id) {
        //   this.$nextTick().then(() => {
        //     this.memberToScrollTo = null;
        //     this.$nextTick().then(() => {
        //       this.memberToScrollTo = unassignedNode;
        //       this.searchAgent = unassignedNode;
        //     });
        //   });
        // }

        this.$nextTick().then(() => {
          this.memberToHighlight = null;
          this.$nextTick().then(() => {
            this.memberToHighlight = this.searchAgent;
          });
        });
      } catch (e) {
        this.addToErrorLogs(
          "swimlanes-shell moveFromUnassignedToHierMultiOffice",
          e
        );
      }
    }
  }
};
</script>
<style>
label[for="primaryAgencyInd"] {
  font-size: 0.9rem !important;
  font-weight: bold;
}

#officeSelections > .v-select-list {
  min-width: 300px;
}
#mainDiv {
  min-height: 100%;
  padding-top: 25px;
}
#mainRow {
  overflow-x: auto;
  flex: 1;
  display: flex;
  flex-direction: row;
  min-height: 0;
  max-height: 100%;
  min-width: 0;
}

#unclassifiedCol {
  overflow-x: auto;
  flex: 1;
  display: flex;
  flex-direction: column;

  max-height: 100%;
  min-width: 0;
  min-height: 0;
  max-width: 275px;
}
#buttonRow {
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  flex: 1;
  display: flex;
  flex-direction: row;
  min-height: 0;
  max-height: 100%;
  min-width: 0;
  max-width: 100%;
}
.hierRow {
  padding-top: 35px;
  padding-bottom: 35px;
  padding-left: 10px;
}
.thing {
  min-width: 225px;
  height: 2rem;
  padding: 0px;
  margin: 0px;
  background: transparent;
}
.muConnector {
  position: absolute;
  border-left: 3px dashed green;
  z-index: 100;
  -webkit-transform-origin: top left;
  -moz-transform-origin: top left;
  -o-transform-origin: top left;
  -ms-transform-origin: top left;
  transform-origin: top left;
}
.scroll {
  display: block;
  overflow-y: auto;
}
.nameDiv {
  border-radius: 5px;
  text-align: center;
  background-color: white;
  z-index: 195;
}
.v-overlay {
  align-items: flex-start !important;
  justify-content: flex-start !important;
  color: rgb(185, 209, 230);
}
.drag-item-text {
  font-size: 0.95rem;
  padding-left: 1rem;
}
.v-list-item--dense,
.v-list--dense .v-list-item {
  min-height: 1.5rem;
  max-height: 2rem;
}
.v-list-item {
  padding: 0;
}
.theme--light.v-list-item--active:before,
.theme--light.v-list-item--active:hover:before,
.theme--light.v-list-item:focus:before {
  min-width: 100px !important;
}
.waitCircle {
  z-index: 1200;
  position: fixed;
  top: 50%;
  left: 60%;
}
.icon-action-button {
  width: 60px;
  margin-right: 10px;
}
.selected-table {
  max-height: 200px;
  overflow: auto;
  min-height: 100px;
  margin: 0px;
}
#selectedMovingRows.v-data-table thead tr:last-child th {
  background-color: #00a5a5;
  color: white;
  font-weight: bold;
}
#selectedMovingRows.theme--light.v-data-table
  .v-data-table-header
  th.sortable:hover {
  color: white;
}
#selectedMovingRows.theme--light.v-data-table
  .v-data-table-header
  th.sortable.active {
  color: white;
}
.mdi-arrow-up::before,
.mdi-arrow-down::before {
  color: white;
}
.trim {
  padding: 0px;
  margin: 0px;
}
</style>
<style lang="scss">
$ease-out: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
.drag-item {
  transition: $ease-out;
  cursor: pointer;
  height: 2rem;

  /* items grabbed state */
  &[aria-grabbed="true"] {
    background: #b3d4fc;
    color: rgb(0, 85, 140);
    height: 2rem;
    margin-top: -2px;
    outline: none !important;
  }
}
</style>
